import _ from "lodash";

import { applyOpacityToColor, isValuePresent } from "../../utils/builderUtils";

export const buildVariantThemeStylesheet = (builder, device, cta, variant) => {
    const options = variant.options;

    // prettier-ignore
    let desktopStyles = '';

    if (cta.cta_type == "hook" || cta.cta_type == "overlay") {
      let borderRadius = variant.options["container-rounding"]
        ? variant.options["container-rounding"]
        : cta.cta_type == "hook"
        ? "4"
        : "0"

      let boxShadow = variant.options["show-shadow"] !== "false" ? "0 1px 23px 0 rgba(50,57,66,0.09)" : undefined;

      desktopStyles += `
        #cta_${cta.id} .cf-step-inner > .cf-cta-container {
          ${borderRadius ? `-webkit-border-radius: ${borderRadius}px;` : ''}
          ${borderRadius ? `-moz-border-radius: ${borderRadius}px;` : ''}
          ${borderRadius ? `border-radius: ${borderRadius}px;` : ''}
          ${boxShadow ? `-webkit-box-shadow: ${boxShadow};` : ''}
          ${boxShadow ? `-moz-box-shadow: ${boxShadow};` : ''}
          ${boxShadow ? `box-shadow: ${boxShadow};` : ''}
          overflow: hidden;
        }
      `;
    }

    {
      [
        { name: "Heading 1", value: "h1" },
        { name: "Heading 2", value: "h2" },
        { name: "Heading 3", value: "h3" },
        { name: "Heading 4", value: "h4" },
        { name: "Heading 5", value: "h5" },
        { name: "Heading 6", value: "h6" },
        { name: "Paragraph", value: "p" },
      ].forEach((heading) => {
        let fontSize;
        if (
          options[`${heading.value}-font-size`] &&
          options[`${heading.value}-font-size`] !== "theme"
        ) {
          fontSize = options[`${heading.value}-font-size`];
        }

        let lineHeight;
        if (options[`${heading.value}-font-line-height`]) {
          lineHeight = options[`${heading.value}-font-line-height`];
        }

        let fontFamily;
        if (
          options[`${heading.value}-font-family`] &&
          options[`${heading.value}-font-family`] !== "theme"
        ) {
          fontFamily = options[`${heading.value}-font-family`];
        }

        let fontWeight;
        if (
          options[`${heading.value}-font-weight`] &&
          options[`${heading.value}-font-weight`] !== "theme"
        ) {
          fontWeight = options[`${heading.value}-font-weight`];
        }

        let fontColor;
        if (
          options[`${heading.value}-font-color`] &&
          options[`${heading.value}-font-color`] !== "theme"
        ) {
          fontColor = options[`${heading.value}-font-color`];
        }

        // prettier-ignore
        desktopStyles += `
          ${heading.value == "p" ? `#cta_${cta.id} .cf-element .cf-reviews-content,` : ''}
          ${heading.value == "p" ? `#cta_${cta.id} .cf-element .cf-reviews-customer-profile-name,` : ''}
          ${heading.value == "p" ? `#cta_${cta.id} .cf-element .cf-reviews-customer-profile-title,` : ''}
          ${heading.value == "p" ? `#cta_${cta.id} .cf-element .cf-reviews-date,` : ''}
          ${heading.value == "p" ? `#cta_${cta.id} .cf-element .cf-quiz-question-description,` : ''}
          ${heading.value == "h3" ? `#cta_${cta.id} .cf-element .cf-reviews-title,` : ''}
          #cta_${cta.id} .cf-element .cf-quiz-inner-wrapper ${heading.value}${heading.value == "p" ? ':not(.cf-label)' : ''},
          #cta_${cta.id} .cf-cta-container .cf-element[data-type="headline"] ${heading.value}${heading.value == "p" ? ':not(.cf-label)' : ''},
          ${heading.name == "Paragraph" ? `#cta_${cta.id} .cf-cta-container .cf-element[data-type="headline"],` : ''}
          ${heading.name == "Paragraph" ? `#cta_${cta.id} .cf-cta-container .cf-element[data-type="text"],` : ''}
          #cta_${cta.id} .cf-cta-container .cf-element[data-type="text"] ${heading.value}${heading.value == "p" ? ':not(.cf-label)' : ''}
          ${heading.value == "p" ? `, #cta_${cta.id} .cf-cta-container .cf-element[data-type="text"] > .cf-text-element, #cta_${cta.id} .cf-cta-container .cf-element[data-type="list"] .cf-content, #cta_${cta.id} .cf-cta-container .cf-element[data-type="products"] p, #cta_${cta.id} .cf-cta-container .cf-element[data-type="product_hero"] p` : ''} {
            ${fontSize ? `font-size: ${fontSize}px;` : ''}
            ${lineHeight ? `line-height: ${lineHeight}px;` : ''}
            ${fontFamily && fontFamily !== 'inherit' ? `font-family: ${fontFamily}, sans-serif;` : ''}
            ${fontWeight ? `font-weight: ${fontWeight};` : ''}
            ${fontColor ? `color: ${fontColor};` : ''}
          }`
      });
    }

    // prettier-ignore
    let mobileStyles = '';
    {
      [
        { name: "Heading 1", value: "h1" },
        { name: "Heading 2", value: "h2" },
        { name: "Heading 3", value: "h3" },
        { name: "Heading 4", value: "h4" },
        { name: "Heading 5", value: "h5" },
        { name: "Heading 6", value: "h6" },
        { name: "Paragraph", value: "p" },
      ].forEach((heading) => {
        let fontSize;
        if (
          options[`${heading.value}-font-size-mobile`] &&
          options[`${heading.value}-font-size-mobile`] !== "theme"
        ) {
          fontSize = options[`${heading.value}-font-size-mobile`];
        }

        let lineHeight;
        if (options[`${heading.value}-font-line-height-mobile`]) {
          lineHeight = options[`${heading.value}-font-line-height-mobile`];
        }

        let fontFamily;
        if (
          options[`${heading.value}-font-family-mobile`] &&
          options[`${heading.value}-font-family-mobile`] !== "theme"
        ) {
          fontFamily = options[`${heading.value}-font-family-mobile`];
        }

        let fontWeight;
        if (
          options[`${heading.value}-font-weight-mobile`] &&
          options[`${heading.value}-font-weight-mobile`] !== "theme"
        ) {
          fontWeight = options[`${heading.value}-font-weight-mobile`];
        }

        let fontColor;
        if (
          options[`${heading.value}-font-color-mobile`] &&
          options[`${heading.value}-font-color-mobile`] !== "theme"
        ) {
          fontColor = options[`${heading.value}-font-color-mobile`];
        }

        // prettier-ignore
        mobileStyles += `
${heading.value == "p" ? `#cta_${cta.id} .cf-element .cf-reviews-content,` : ''}
${heading.value == "p" ? `#cta_${cta.id} .cf-element .cf-reviews-customer-profile-name,` : ''}
${heading.value == "p" ? `#cta_${cta.id} .cf-element .cf-reviews-customer-profile-title,` : ''}
${heading.value == "p" ? `#cta_${cta.id} .cf-element .cf-reviews-date,` : ''}
${heading.value == "p" ? `#cta_${cta.id} .cf-element .cf-quiz-question-description,` : ''}
${heading.value == "h3" ? `#cta_${cta.id} .cf-element .cf-reviews-title,` : ''}
#cta_${cta.id} .cf-element .cf-quiz-inner-wrapper ${heading.value}${heading.value == "p" ? ':not(.cf-label)' : ''},
#cta_${cta.id} .cf-cta-container .cf-element[data-type="headline"] ${heading.value}${heading.value == "p" ? ':not(.cf-label)' : ''},
${heading.name == "Paragraph" ? `#cta_${cta.id} .cf-cta-container .cf-element[data-type="headline"],` : ''}
${heading.name == "Paragraph" ? `#cta_${cta.id} .cf-cta-container .cf-element[data-type="text"],` : ''}
#cta_${cta.id} .cf-cta-container .cf-element[data-type="text"] ${heading.value}${heading.value == "p" ? ':not(.cf-label)' : ''} {
  ${fontSize ? `font-size: ${fontSize}px;` : ''}
  ${lineHeight ? `line-height: ${lineHeight}px;` : ''}
  ${fontFamily && fontFamily !== 'inherit' ? `font-family: ${fontFamily}, sans-serif;` : ''}
  ${fontWeight ? `font-weight: ${fontWeight};` : ''}
  ${fontColor ? `color: ${fontColor};` : ''}
}`
      });
    }

    // button styles
    let buttonBorderRadius;
    if (options["button-radius"] == "cf-not-rounded") {
      buttonBorderRadius = "0px";
    }
    if (options["button-radius"] == "cf-slightly-rounded") {
      buttonBorderRadius = "4px";
    }
    if (options["button-radius"] == "cf-fully-rounded") {
      buttonBorderRadius = "100px";
    }
    if (options["button-radius"] == "custom") {
      buttonBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          buttonBorderRadius += `${
            _.isNil(options["button-radius-" + side]) == false
              ? options["button-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let buttonBoxShadow;
    let buttonBoxShadowHover;

    if (options["button-shadow"] == "soft") {
      buttonBoxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["button-shadow"] == "hard") {
      buttonBoxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["button-shadow"] == "custom") {
      buttonBoxShadow = "";
      buttonBoxShadow +=
        (options["button-shadow-horizontal-distance"]
          ? `${options["button-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      buttonBoxShadow +=
        (options["button-shadow-vertical-distance"]
          ? `${options["button-shadow-vertical-distance"]}px`
          : "0px") + " ";

      buttonBoxShadow +=
        (options["button-shadow-blur-radius"]
          ? `${options["button-shadow-blur-radius"]}px`
          : "0px") + " ";

      buttonBoxShadow +=
        (options["button-shadow-spread-radius"]
          ? `${options["button-shadow-spread-radius"]}px`
          : "0px") + " ";

      buttonBoxShadow +=
        (options["button-shadow-color"]
          ? options["button-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";

      buttonBoxShadowHover =
        buttonBoxShadow +
        (options["button-hover-shadow-color"]
          ? options["button-hover-shadow-color"]
          : options["button-shadow-color"]
          ? options["button-shadow-color"]
          : "rgba(0,0,0, 0.35)");

      buttonBoxShadow +=
        options["button-shadow-inset"] == "true" ? "inset" : "";
      buttonBoxShadowHover +=
        options["button-shadow-inset"] == "true" ? "inset" : "";
    }

    let nextButtonFontWeight;
    if (
      options["next-button-font-weight"] &&
      options["next-button-font-weight"] !== "theme"
    ) {
      nextButtonFontWeight = options["next-button-font-weight"];
    }

    let nextButtonBorderRadius = "";
    if (options["next-button-radius"] == "cf-not-rounded") {
      nextButtonBorderRadius = "0px";
    }
    if (options["next-button-radius"] == "cf-slightly-rounded") {
      nextButtonBorderRadius = "4px";
    }
    if (options["next-button-radius"] == "cf-fully-rounded") {
      nextButtonBorderRadius = "100px";
    }
    if (options["next-button-radius"] == "custom") {
      nextButtonBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          nextButtonBorderRadius += `${
            _.isNil(options["next-button-radius-" + side]) == false
              ? options["next-button-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let nextButtonBoxShadow;
    let nextButtonBoxShadowHover;

    if (options["next-button-shadow"] == "None") {
      nextButtonBoxShadow = "none";
    }

    if (options["next-button-shadow"] == "soft") {
      nextButtonBoxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["next-button-shadow"] == "hard") {
      nextButtonBoxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["next-button-shadow"] == "custom") {
      nextButtonBoxShadow = "";
      nextButtonBoxShadow +=
        (variant.options["next-button-shadow-horizontal-distance"]
          ? `${variant.options["next-button-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      nextButtonBoxShadow +=
        (variant.options["next-button-shadow-vertical-distance"]
          ? `${variant.options["next-button-shadow-vertical-distance"]}px`
          : "0px") + " ";

      nextButtonBoxShadow +=
        (variant.options["next-button-shadow-blur-radius"]
          ? `${variant.options["next-button-shadow-blur-radius"]}px`
          : "0px") + " ";

      nextButtonBoxShadow +=
        (variant.options["next-button-shadow-spread-radius"]
          ? `${variant.options["next-button-shadow-spread-radius"]}px`
          : "0px") + " ";

      nextButtonBoxShadow +=
        (variant.options["next-button-shadow-color"]
          ? variant.options["next-button-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";

      nextButtonBoxShadowHover =
        nextButtonBoxShadow +
        (variant.options["next-button-hover-shadow-color"]
          ? variant.options["next-button-hover-shadow-color"]
          : variant.options["next-button-shadow-color"]
          ? variant.options["next-button-shadow-color"]
          : "rgba(0,0,0, 0.35)");

      nextButtonBoxShadow +=
        variant.options["next-button-shadow-inset"] == "true" ? "inset" : "";
      nextButtonBoxShadowHover +=
        variant.options["next-button-shadow-inset"] == "true" ? "inset" : "";
    }

    let nextButtonPadding = options["next-button-padding"];
    let nextButtonPaddingValue = "";

    if (nextButtonPadding == "cf-button-small") {
      nextButtonPaddingValue = "padding: 8px 15px !important;";
    } else if (nextButtonPadding == "cf-button-regular") {
      nextButtonPaddingValue = "padding: 10px 20px !important;";
    } else if (nextButtonPadding == "cf-button-large") {
      nextButtonPaddingValue = "padding: 13px 20px !important;";
    } else {
      nextButtonPaddingValue = "padding: 8px 15px !important;";
    }

    // prettier-ignore
    desktopStyles += `
#cta_${cta.id} .cf-button, #cta_${cta.id} .cf-survey-field .cf-survey-choice {
  ${options["button-color"] ? 'background: ' + options["button-color"] + ';' : ''}
  ${options["button-text-color"] ? 'color: ' + options["button-text-color"] + ';' : ''}
  ${options["button-size"] == 'custom' && options["button-size-value"] ? 'padding: ' + options["button-size-value"] + 'px 20px;' : ''}
  ${options["button-border-style"] ? 'border-style: ' + options["button-border-style"] + ';' : ''}
  ${_.isNil(options["button-border-width"]) == false ? 'border-width: ' + options["button-border-width"] + 'px;' : ''}
  ${_.isNil(options["button-border-width-left"]) == false ? 'border-left-width: ' + options["button-border-width-left"] + 'px;' : _.isNil(options["button-border-width"]) == false ? 'border-left-width: ' + options["button-border-width"] + 'px;' : ''}
  ${_.isNil(options["button-border-width-right"]) == false ? 'border-right-width: ' + options["button-border-width-right"] + 'px;' : _.isNil(options["button-border-width"]) == false ? 'border-right-width: ' + options["button-border-width"] + 'px;' : ''}
  ${_.isNil(options["button-border-width-top"]) == false ? 'border-top-width: ' + options["button-border-width-top"] + 'px;' : _.isNil(options["button-border-width"]) == false ? 'border-top-width: ' + options["button-border-width"] + 'px;' : ''}
  ${_.isNil(options["button-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["button-border-width-bottom"] + 'px;' : _.isNil(options["button-border-width"]) == false ? 'border-bottom-width: ' + options["button-border-width"] + 'px;' : ''}
  ${options["button-border-color"] ? 'border-color: ' + options["button-border-color"] + ';' : options["button-color"] ? 'border-color: ' + options["button-color"] + ';' : ''}
  ${buttonBorderRadius ? 'border-radius: ' + buttonBorderRadius + ';' : ''}
  ${buttonBoxShadow ? 'box-shadow: ' + buttonBoxShadow + ';' : ''}
}

#cta_${cta.id} .cf-survey-next.cf-button-small,
#cta_${cta.id} .cf-survey-next.cf-button-regular,
#cta_${cta.id} .cf-survey-next.cf-button-large,
#cta_${cta.id} .cf-survey-next {
  ${options["next-button-color"] ? 'background: ' + options["next-button-color"] + '!important;' : ''}
  ${nextButtonPadding == 'custom' && options["next-button-padding-value"] ? `padding: ${options["next-button-padding-value"]}px 20px !important;` : nextButtonPaddingValue}
  ${options["next-button-font-size"] ? `font-size: ${options['next-button-font-size']}px !important;` : 'font-size: 14px !important;'}
  ${nextButtonFontWeight ? `font-weight: ${nextButtonFontWeight} !important;` : ''}
  font-family: ${options["next-button-font-family"] ? options["next-button-font-family"] : ''} !important;
  ${options["next-button-text-color"] ? 'color: ' + options["next-button-text-color"] + ' !important;' : ''}
  ${options["next-button-border-style"] ? 'border-style: ' + options["next-button-border-style"] + ' !important;' : ''}
  ${options["next-button-border-style"] !== "" && _.isNil(options["next-button-border-width"]) == false ? 'border-width: ' + options["next-button-border-width"] + 'px !important;' : 'border-width: 1px !important;'}
  ${options["next-button-border-style"] !== "" && _.isNil(options["next-button-border-width-left"]) == false ? 'border-left-width: ' + options["next-button-border-width-left"] + 'px !important;' : _.isNil(options["next-button-border-width"]) == false ? 'border-left-width: ' + options["next-button-border-width"] + 'px !important;' : ''}
  ${options["next-button-border-style"] !== "" && _.isNil(options["next-button-border-width-right"]) == false ? 'border-right-width: ' + options["next-button-border-width-right"] + 'px !important;' : _.isNil(options["next-button-border-width"]) == false ? 'border-right-width: ' + options["next-button-border-width"] + 'px !important;' : ''}
  ${options["next-button-border-style"] !== "" && _.isNil(options["next-button-border-width-top"]) == false ? 'border-top-width: ' + options["next-button-border-width-top"] + 'px !important;' : _.isNil(options["next-button-border-width"]) == false ? 'border-top-width: ' + options["next-button-border-width"] + 'px !important;' : ''}
  ${options["next-button-border-style"] !== "" && _.isNil(options["next-button-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["next-button-border-width-bottom"] + 'px !important;' : _.isNil(options["next-button-border-width"]) == false ? 'border-bottom-width: ' + options["next-button-border-width"] + 'px !important;' : ''}
  ${options["next-button-border-style"] !== "" && options["next-button-border-color"] ? 'border-color: ' + options["next-button-border-color"] + ' !important;' : options["next-button-border-color"] ? 'border-color: ' + options["next-button-border-color"] + ' !important;' : ''}
  ${nextButtonBorderRadius ? 'border-radius: ' + nextButtonBorderRadius + ' !important;' : ''}
  ${nextButtonBoxShadow ? 'box-shadow: ' + nextButtonBoxShadow + ' !important;' : ''}
}

#cta_${cta.id} .cf-survey-next.cf-button-small:hover,
#cta_${cta.id} .cf-survey-next.cf-button-regular:hover,
#cta_${cta.id} .cf-survey-next.cf-button-large:hover,
#cta_${cta.id} .cf-survey-next:hover {
  ${options["next-button–hover-color"] ? 'background: ' + options["next-button–hover-color"] + ' !important;' : options["next-button-color"] ? 'background: ' + options["next-button-color"] + ' !important;' : ''}
  ${options["next-button–hover-text-color"] ? 'color: ' + options["next-button–hover-text-color"] + ' !important;' : options["next-button-text-color"] ? 'color: ' + options["next-button-text-color"] + ' !important;' : ''}
  ${options["next-button-hover-border-color"] ? 'border-color: ' + options["next-button-hover-border-color"] + ' !important;' : options["next-button-border-color"] ? 'border-color: ' +  options["next-button-border-color"] + ' !important;' : ''}
  ${nextButtonBoxShadowHover ? 'box-shadow: ' + nextButtonBoxShadowHover + ' !important;' : ''}
}

#cta_${cta.id} .cf-button {
  ${options["button-width"] == 'custom' && options["button-width-value"] ? 'min-width: ' + options["button-width-value"] + 'px;' : ''}
}

${options["form-vertical-button-alignment"] ? `
#cta_${cta.id} .cf-element .cf-form-2:not(.cf-form-horizontal) .cf-button-outer {
  margin-left: ${{ left: "0px", center: "auto", right: "auto" }[options["form-vertical-button-alignment"]]} !important;
  margin-right: ${{ left: "auto", center: "auto", right: "0px" }[options["form-vertical-button-alignment"]]} !important;
}` : ''}

#cta_${cta.id} .cf-button:hover, #cta_${cta.id} .cf-button:active, #cta_${cta.id} .cf-survey-field .cf-survey-choice:hover {
  ${options["button–hover-color"] ? 'background: ' + options["button–hover-color"] + ';' : 'background: ' + options["button-color"] + ';'}
  ${options["button–hover-text-color"] ? 'color: ' + options["button–hover-text-color"] + ';' : 'color: ' + options["button-text-color"] + ';'}
  ${options["button-hover-border-color"] ? 'border-color: ' + options["button-hover-border-color"] + ';' : 'border-color: ' + options["button-border-color"] + ';'}
  ${buttonBoxShadowHover ? 'box-shadow: ' + buttonBoxShadowHover + ';' : ''}
}

#cta_${cta.id} .cf-form-2.cf-form-theme-default.cf-field-regular.cf-form-horizontal .cf-button-outer .cf-button,
#cta_${cta.id} .cf-form-2.cf-form-theme-default.cf-field-large.cf-form-horizontal .cf-button-outer .cf-button,
#cta_${cta.id} .cf-form-2.cf-form-theme-default.cf-field-regular.cf-form-horizontal .cf-button-outer .cf-button p,
#cta_${cta.id} .cf-form-2.cf-form-theme-default.cf-field-large.cf-form-horizontal .cf-button-outer .cf-button p,
#cta_${cta.id} .cf-button,
#cta_${cta.id} .cf-button p,
#cta_${cta.id} .cf-button div,
#cta_${cta.id} .cf-button h1,
#cta_${cta.id} .cf-button h2,
#cta_${cta.id} .cf-button h3,
#cta_${cta.id} .cf-button h4,
#cta_${cta.id} .cf-button h5,
#cta_${cta.id} .cf-button h6,
#cta_${cta.id} .cf-button-small p,
#cta_${cta.id} .cf-button-regular p,
#cta_${cta.id} .cf-button-large p,
#cta_${cta.id} .cf-survey-field .cf-survey-choice p,
#cta_${cta.id} .cf-survey-field .cf-survey-choice .cf-survey-label,
#cta_${cta.id} .cf-button-outer button.cf-text-element p {
  ${options["button-font-weight"] ? `font-weight: ${options["button-font-weight"]};` : ''}
  ${options["button-font-size"] ? `font-size: ${options["button-font-size"]}px;` : ''}
  ${options["button-font"] ? `font-family: ${options["button-font"]};` : ''}
}`

    let fontSizeMobile;
    if (options["button-font-size-mobile"]) {
      fontSizeMobile = options["button-font-size-mobile"];
    }

    // prettier-ignore
    mobileStyles += `
#cta_${cta.id} .cf-form-2.cf-form-theme-default.cf-field-regular.cf-form-horizontal .cf-button-outer .cf-button,
#cta_${cta.id} .cf-form-2.cf-form-theme-default.cf-field-large.cf-form-horizontal .cf-button-outer .cf-button,
#cta_${cta.id} .cf-form-2.cf-form-theme-default.cf-field-regular.cf-form-horizontal .cf-button-outer .cf-button p,
#cta_${cta.id} .cf-form-2.cf-form-theme-default.cf-field-large.cf-form-horizontal .cf-button-outer .cf-button p,
#cta_${cta.id} .cf-button,
#cta_${cta.id} .cf-button p,
#cta_${cta.id} .cf-button div,
#cta_${cta.id} .cf-button h1,
#cta_${cta.id} .cf-button h2,
#cta_${cta.id} .cf-button h3,
#cta_${cta.id} .cf-button h4,
#cta_${cta.id} .cf-button h5,
#cta_${cta.id} .cf-button h6,
#cta_${cta.id} .cf-survey-field .cf-survey-choice p,
#cta_${cta.id} .cf-survey-field .cf-survey-choice .cf-survey-label {
  ${fontSizeMobile ? `font-size: ${fontSizeMobile}px !important;` : ''}
}

#cta_${cta.id} .cf-survey-next.cf-button-small,
#cta_${cta.id} .cf-survey-next.cf-button-regular,
#cta_${cta.id} .cf-survey-next.cf-button-large,
#cta_${cta.id} .cf-survey-next {
${options["next-button-font-size-mobile"] ? `font-size: ${options['next-button-font-size-mobile']}px !important;` : ''}
}

`

    let fieldRadius;
    if (options["field-rounded"] == "cf-field-not-rounded") {
      fieldRadius = "0px";
    }
    if (options["field-rounded"] == "cf-field-slightly-rounded") {
      fieldRadius = "3px";
    }
    if (options["field-rounded"] == "cf-field-fully-rounded") {
      fieldRadius = "100px";
    }
    if (options["field-rounded"] == "custom") {
      fieldRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          fieldRadius += `${
            _.isNil(options["field-radius-" + side]) == false
              ? options["field-radius-" + side]
              : "3"
          }px `;
        }
      );
    }

    let fieldFontSize;
    if (options["field-font-size"]) {
      fieldFontSize = options["field-font-size"];
    }

    let fieldLabelFontSize;
    if (options["field-label-font-size"]) {
      fieldLabelFontSize = options["field-label-font-size"];
    }

    let fieldConsentLabelFontSize;
    if (options["field-consent-label-font-size"]) {
      fieldConsentLabelFontSize = options["field-consent-label-font-size"];
    }

    let fieldSmsConsentLabelFontSize;
    if (options["field-sms-consent-label-font-size"]) {
      fieldSmsConsentLabelFontSize = options["field-sms-consent-label-font-size"];
    }

    let fieldLabelFontFamily;
    if (options["field-label-font-family"]) {
      fieldLabelFontFamily = options["field-label-font-family"];
    }

    let fieldFontWeight;
    if (
      options["field-font-weight"] &&
      options["field-font-weight"] !== "theme"
    ) {
      fieldFontWeight = options["field-font-weight"];
    }

    let fieldLabelFontWeight;
    if (options["field-label-font-weight"]) {
      fieldLabelFontWeight = options["field-label-font-weight"];
    }

    let fieldBoxShadow;

    if (options["box-shadow"] == "soft") {
      fieldBoxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["box-shadow"] == "hard") {
      fieldBoxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["box-shadow"] == "custom") {
      fieldBoxShadow = "";
      fieldBoxShadow +=
        (options["box-shadow-horizontal-distance"]
          ? `${options["box-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      fieldBoxShadow +=
        (options["box-shadow-vertical-distance"]
          ? `${options["box-shadow-vertical-distance"]}px`
          : "0px") + " ";

      fieldBoxShadow +=
        (options["box-shadow-blur-radius"]
          ? `${options["box-shadow-blur-radius"]}px`
          : "0px") + " ";

      fieldBoxShadow +=
        (options["box-shadow-spread-radius"]
          ? `${options["box-shadow-spread-radius"]}px`
          : "0px") + " ";

      fieldBoxShadow +=
        (options["box-shadow-color"]
          ? options["box-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";
    }

    // prettier-ignore
    let handleStyle = `
      ${options['field-handle-color'] ? 'background: ' + options['field-handle-color'] + ';' : ''} 
      ${options['field-handle-border-color'] ? 'border-color: ' + options['field-handle-border-color'] + ';' : ''}`

    desktopStyles +=
      // prettier-ignore
      `
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default, #cta_${cta.id} .cf-element .cf-products-item-variants .cf-form-2.cf-form-theme-default select {
  ${options["field-font"] ? 'font-family: ' + options["field-font"] + ';' : ''}
}

#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="text"],
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="date"],
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="datetime-local"],
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="email"],
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="tel"],
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="number"],
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default textarea {
  ${_.isNil(options["field-text-color"]) == false ? 'color: ' + options["field-text-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-form.element-content .cf-form-2.cf-form-theme-default select:not(.cf-sms-countries):not(select[data-selected="true"]) {
  ${isValuePresent(options["field-text-color"]) == true ? `color: ${applyOpacityToColor(options["field-text-color"], 50, false)} !important;` : 'color: rgba(0, 0, 0 , 0.2) !important;'}
}

#cta_${cta.id} .cf-element .cf-form.element-content .cf-form-2.cf-form-theme-default select[data-selected="true"] {
  ${isValuePresent(options["field-text-color"]) == true ? `color: ${options["field-text-color"]} !important;` : ''}
}

#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="text"],
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="date"],
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="datetime-local"],
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="email"],
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="tel"],
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="number"],
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default textarea,
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default select {
  ${_.isNil(options["field-background-color"]) == false ? 'background: ' + options["field-background-color"] + ' !important;' : ''}
  ${_.isNil(options["field-border-style"]) == false ? 'border-style: ' + options["field-border-style"] + ' !important;' : ''}
  ${_.isNil(options["field-border-width"]) == false ? 'border-width: ' + options["field-border-width"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-width-left"]) == false ? 'border-left-width: ' + options["field-border-width-left"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-width-right"]) == false ? 'border-right-width: ' + options["field-border-width-right"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-width-top"]) == false ? 'border-top-width: ' + options["field-border-width-top"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["field-border-width-bottom"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-color"]) == false ? 'border-color: ' + options["field-border-color"] + ' !important;' : ''}
  ${_.isNil(fieldRadius) == false ? 'border-radius: ' + fieldRadius + ' !important;' : ''}
  ${fieldBoxShadow ? 'box-shadow: ' + fieldBoxShadow + ' !important;' : ''}
  ${fieldFontWeight ? `font-weight: ${fieldFontWeight} !important;` : ''}
  ${fieldFontSize ? `font-size: ${fieldFontSize}px !important;` : ''}
  ${options["field-font"] ? `font-family: ${options["field-font"]} !important;` : ''}
  line-height: normal;
  appearance: auto;
}

#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default .cf-label {
  ${options["label-color"] ? 'color: ' + options["label-color"] + ';' : ''}
  ${fieldLabelFontSize ? `font-size: ${fieldLabelFontSize}px !important;` : ''}
  ${fieldLabelFontWeight ? `font-weight: ${fieldLabelFontWeight} !important;` : fieldFontWeight ? `font-weight: ${fieldFontWeight};` : ''}
  ${fieldLabelFontFamily == 'font-default' ? `font-family: ${options["field-font"]};` : fieldLabelFontFamily ? `font-family: ${fieldLabelFontFamily};` : ""}
}

#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default .cf-consent-label {
  ${fieldLabelFontWeight ? `font-weight: ${fieldLabelFontWeight} !important;` : fieldFontWeight ? `font-weight: ${fieldFontWeight} !important;` : ''}
}

#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default .cf-consent-label:not(.cf-sms-label) {
  ${fieldConsentLabelFontSize ? `font-size: ${fieldConsentLabelFontSize}px !important;` : ''}
}

#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default .cf-sms-label {
  ${fieldSmsConsentLabelFontSize ? `font-size: ${fieldSmsConsentLabelFontSize}px !important;` : ''}
}

#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default .cf-field-range-slider {
  ${_.isNil(options["field-background-color"]) == false ? 'background: ' + options["field-background-color"] + ' !important;' : ''}
  ${_.isNil(options["field-border-style"]) == false ? 'border-style: ' + options["field-border-style"] + ' !important;' : ''}
  ${_.isNil(options["field-border-width"]) == false ? 'border-width: ' + options["field-border-width"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-width-left"]) == false ? 'border-left-width: ' + options["field-border-width-left"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-width-right"]) == false ? 'border-right-width: ' + options["field-border-width-right"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-width-top"]) == false ? 'border-top-width: ' + options["field-border-width-top"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["field-border-width-bottom"] + 'px !important;' : ''}
  ${_.isNil(options["field-border-color"]) == false ? 'border-color: ' + options["field-border-color"] + ' !important;' : ''}
  ${_.isNil(fieldRadius) == false ? 'border-radius: ' + fieldRadius + ' !important;' : ''}
  ${fieldBoxShadow ? 'box-shadow: ' + fieldBoxShadow + ' !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default .noUi-value {
  ${options["label-color"] ? 'color: ' + options["label-color"] + ';' : ''}
}

#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default .noUi-marker {
  ${options["label-color"] ? 'background: ' + options["label-color"] + ';' : ''};
}

#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default .noUi-connect {
  ${_.isNil(options["field-border-color"]) == false ? 'background: ' + options["field-border-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default .noUi-handle {
  ${handleStyle}
}

#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default .noUi-tooltip {
  ${_.isNil(options["field-text-color"]) == false ? 'color: ' + options["field-text-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="text"]::placeholder, 
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="date"]::placeholder,
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="datetime-local"]::placeholder,
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="email"]::placeholder, 
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="tel"]::placeholder,
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="number"]::placeholder,
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default textarea::placeholder, 
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default select::placeholder {
  ${_.isNil(options["field-text-color"]) == false ? 'color: ' + options["field-text-color"] + ' !important;' : ''}
  ${fieldFontWeight ? `font-weight: ${fieldFontWeight} !important;` : ''}
}`;

    let fieldFontSizeMobile;
    if (options["field-font-size-mobile"]) {
      fieldFontSizeMobile = options["field-font-size-mobile"];
    }

    let fieldLabelFontSizeMobile;
    if (options["field-label-font-size-mobile"]) {
      fieldLabelFontSizeMobile = options["field-label-font-size-mobile"];
    }

    let fieldConsentLabelFontSizeMobile;
    if (options["field-consent-label-font-size-mobile"]) {
      fieldConsentLabelFontSizeMobile = options["field-consent-label-font-size-mobile"];
    }

    let fieldSmsConsentLabelFontSizeMobile;
    if (options["field-sms-consent-label-font-size-mobile"]) {
      fieldSmsConsentLabelFontSizeMobile = options["field-sms-consent-label-font-size-mobile"];
    }

    mobileStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="text"], 
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="date"],
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="datetime-local"],
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="email"], 
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="tel"],
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="number"],
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default textarea, 
#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default select {
  ${fieldFontSizeMobile ? `font-size: ${fieldFontSizeMobile}px !important;` : ''}
}

#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default .cf-label {
  ${fieldLabelFontSizeMobile ? `font-size: ${fieldLabelFontSizeMobile}px !important;` : ''}
}

#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default .cf-consent-label:not(.cf-sms-label) {
  ${fieldConsentLabelFontSizeMobile ? `font-size: ${fieldConsentLabelFontSizeMobile}px !important;` : ''}
}

#cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default .cf-sms-label {
  ${fieldSmsConsentLabelFontSizeMobile ? `font-size: ${fieldSmsConsentLabelFontSizeMobile}px !important;` : ''}
}
`;

    let progressOuterRadius = "";
    if (options["progress-outer-radius"] == "cf-not-rounded") {
      progressOuterRadius = "0px";
    }
    if (options["progress-outer-radius"] == "cf-slightly-rounded") {
      progressOuterRadius = "4px";
    }
    if (options["progress-outer-radius"] == "cf-fully-rounded") {
      progressOuterRadius = "100px";
    }
    if (options["progress-outer-radius"] == "custom") {
      progressOuterRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          progressOuterRadius += `${
            _.isNil(options["progress-outer-radius-" + side]) == false
              ? options["progress-outer-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    desktopStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-progress {
  ${progressOuterRadius ? 'border-radius: ' + progressOuterRadius + ' !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-progress-outer {
  ${options["progress-outer-background-color"] ? 'background: ' + options["progress-outer-background-color"] + ' !important;' : ''}
  ${progressOuterRadius ? 'border-radius: ' + progressOuterRadius + ' !important;' : ''}
  ${options["progress-border-style"] ? 'border-style: ' + options["progress-border-style"] + ' !important;' : ''}
  ${_.isNil(options["progress-border-width"]) == false ? 'border-width: ' + options["progress-border-width"] + 'px !important;' : ''}
  ${_.isNil(options["progress-border-width-left"]) == false ? 'border-left-width: ' + options["progress-border-width-left"] + 'px !important;' : ''}
  ${_.isNil(options["progress-border-width-right"]) == false ? 'border-right-width: ' + options["progress-border-width-right"] + 'px !important;' : ''}
  ${_.isNil(options["progress-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["progress-border-width-bottom"] + 'px !important;' : ''}
  ${_.isNil(options["progress-border-width-top"]) == false ? 'border-top-width: ' + options["progress-border-width-top"] + 'px !important;' : ''}
  ${options["progress-border-color"] ? 'border-color: ' + options["progress-border-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-progress-inner {
  ${options["progress-inner-background-color"] ? 'background: ' + options["progress-inner-background-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-progress-message, 
#cta_${cta.id} .cf-element .cf-progress-message h1, 
#cta_${cta.id} .cf-element .cf-progress-message h2, 
#cta_${cta.id} .cf-element .cf-progress-message h3, 
#cta_${cta.id} .cf-element .cf-progress-message h4, 
#cta_${cta.id} .cf-element .cf-progress-message h5, 
#cta_${cta.id} .cf-element .cf-progress-message p, 
#cta_${cta.id} .cf-element .cf-progress-message span {
  ${options["progress-text-font"] ? 'font-family: ' + options["progress-text-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
  ${options['progress-text-font-weight'] ? 'font-weight: ' + options['progress-text-font-weight'] + ' !important;' : ''}
  ${options["progress-text-color"] ? 'color: ' + options["progress-text-color"] + ' !important;' : ''} 
  ${options["progress-text-size"] ? 'font-size: ' + options["progress-text-size"] + 'px !important;' : ''}
}`;

    mobileStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-progress-inner {
  ${options["progress-format"] == "line" && options['progress-height-mobile'] ? 'min-height: ' + options['progress-height-mobile'] + 'px !important;' : ''}
  ${options["progress-format"] == "box" && options['progress-inner-padding-mobile'] ? 'padding: ' + options['progress-inner-padding-mobile'] + 'px !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-progress-message, 
#cta_${cta.id} .cf-element .cf-progress-message h1, 
#cta_${cta.id} .cf-element .cf-progress-message h2, 
#cta_${cta.id} .cf-element .cf-progress-message h3, 
#cta_${cta.id} .cf-element .cf-progress-message h4, 
#cta_${cta.id} .cf-element .cf-progress-message h5, 
#cta_${cta.id} .cf-element .cf-progress-message p, 
#cta_${cta.id} .cf-element .cf-progress-message span {
  ${options["progress-text-size-mobile"] ? 'font-size: ' + options["progress-text-size-mobile"] + 'px !important;' : ''}
}`;

    ////////// START QUIZES THEME STYLES

    let quizProgressOuterRadius = "";
    if (options["quiz-progress-outer-radius"] == "cf-not-rounded") {
      quizProgressOuterRadius = "0px";
    }
    if (options["quiz-progress-outer-radius"] == "cf-slightly-rounded") {
      quizProgressOuterRadius = "4px";
    }
    if (options["quiz-progress-outer-radius"] == "cf-fully-rounded") {
      quizProgressOuterRadius = "100px";
    }
    if (options["quiz-progress-outer-radius"] == "custom") {
      quizProgressOuterRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          quizProgressOuterRadius += `${
            _.isNil(options["quiz-progress-outer-radius-" + side]) == false
              ? options["quiz-progress-outer-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let quizOptionFontSize;
    if (
      options["quiz-option-font-size"] &&
      options["quiz-option-font-size"] !== "theme"
    ) {
      quizOptionFontSize = options["quiz-option-font-size"];
    }

    let quizOptionFontFamily;
    if (
      options["quiz-option-font-family"] &&
      options["quiz-option-font-family"] !== "theme"
    ) {
      quizOptionFontFamily = options["quiz-option-font-family"];
    }

    let quizOptionFontWeight;
    if (
      options["quiz-option-font-weight"] &&
      options["quiz-option-font-weight"] !== "theme"
    ) {
      quizOptionFontWeight = options["quiz-option-font-weight"];
    }

    let quizOptionFontColor;
    if (
      options["quiz-option-font-color"] &&
      options["quiz-option-font-color"] !== "theme"
    ) {
      quizOptionFontColor = options["quiz-option-font-color"];
    }

    let quizHoverOptionFontColor;
    if (
      options["quiz-hover-option-font-color"] &&
      options["quiz-hover-option-font-color"] !== "theme"
    ) {
      quizHoverOptionFontColor = options["quiz-hover-option-font-color"];
    }

    let quizOptionFontLineHeight;
    if (
      options["quiz-option-font-line-height"] &&
      options["quiz-option-font-line-height"] !== "theme"
    ) {
      quizOptionFontLineHeight = options["quiz-option-font-line-height"];
    }

    let quizOptionVisualFontSize =
      options["quiz-option-visual-font-size"] || 18;
    let quizOptionVisualColor = options["quiz-option-color"] || undefined;
    let quizHoverOptionVisualColor =
      options["quiz-hover-option-color"] || undefined;

    let quizOptionColorSize = options["quiz-option-color-size"] || undefined;
    let quizOptionBackgroundColor =
      options["quiz-option-background-color"] || undefined;

    let quizOptionBoxShadow;
    if (options["quiz-option-box-shadow"] == "soft") {
      quizOptionBoxShadow = "0 3px 5px rgb(179 179 179 / 78%)";
    }
    if (options["quiz-option-box-shadow"] == "hard") {
      quizOptionBoxShadow = "-3px 3px 0 rgb(0 0 0 / 10%)";
    }
    if (options["quiz-option-box-shadow"] == "none") {
      quizOptionBoxShadow = "unset";
    }
    if (options["quiz-option-box-shadow"] == "custom") {
      quizOptionBoxShadow = "";
      quizOptionBoxShadow +=
        (options["quiz-option-box-shadow-horizontal-distance"]
          ? `${options["quiz-option-box-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      quizOptionBoxShadow +=
        (options["quiz-option-box-shadow-vertical-distance"]
          ? `${options["quiz-option-box-shadow-vertical-distance"]}px`
          : "0px") + " ";

      quizOptionBoxShadow +=
        (options["quiz-option-box-shadow-blur-radius"]
          ? `${options["quiz-option-box-shadow-blur-radius"]}px`
          : "0px") + " ";

      quizOptionBoxShadow +=
        (options["quiz-option-box-shadow-color"]
          ? options["quiz-option-box-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";
    }

    let quizOptionsLayout = options["quiz-options-layout"];
    let quizQuestionDistanceFromProgress =
      options["quiz-question-distance-from-progress"] || 20;

    let quizConditionalContentBorderStyle =
      options["quiz-conditional-content-border-style"] || "none";
    let quizConditionalContentHasBorder =
      quizConditionalContentBorderStyle !== "none";

    const quizConditionalContentBorderWidth = (side) => {
      const width = options[`quiz-conditional-content-border-width-${side}`];
      return _.isNil(width) ? 0 : width;
    };

    let quizConditionalContentBorderRadius = "4px";
    if (options["quiz-conditional-content-border-radius"] == "cf-not-rounded") {
      quizConditionalContentBorderRadius = "0px";
    } else if (
      options["quiz-conditional-content-border-radius"] == "cf-fully-rounded"
    ) {
      quizConditionalContentBorderRadius = "100px";
    } else if (options["quiz-conditional-content-border-radius"] == "custom") {
      quizConditionalContentBorderRadius = [
        "top-left",
        "top-right",
        "bottom-right",
        "bottom-left",
      ]
        .map((side) => {
          const radius =
            options[`quiz-conditional-content-border-radius-${side}`];
          return `${_.isNil(radius) ? 4 : radius}px`;
        })
        .join(" ");
    }

    let quizBackButtonBorderRadius = "";
    if (options["quiz-back-button-radius"] == "cf-not-rounded") {
      quizBackButtonBorderRadius = "0px";
    }
    if (options["quiz-back-button-radius"] == "cf-slightly-rounded") {
      quizBackButtonBorderRadius = "4px";
    }
    if (options["quiz-back-button-radius"] == "cf-fully-rounded") {
      quizBackButtonBorderRadius = "100px";
    }
    if (options["quiz-back-button-radius"] == "custom") {
      quizBackButtonBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          quizBackButtonBorderRadius += `${
            _.isNil(options["quiz-back-button-radius-" + side]) == false
              ? options["quiz-back-button-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    desktopStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-quiz-progress {
      ${quizProgressOuterRadius ? `border-radius: ${quizProgressOuterRadius} !important;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-content-answers-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    #cta_${cta.id} .cf-element .cf-quiz-back-button {
      ${options["quiz-back-button-color"] ? `background: ${options["quiz-back-button-color"]} !important;` : ''}
      ${options["quiz-back-button-text-color"] ? `color: ${options["quiz-back-button-text-color"]} !important;` : ''}
      ${options["quiz-back-button-border-style"] ? 'border-style: ' + options["quiz-back-button-border-style"] + ' !important;' : ''}
      ${options["quiz-back-button-border-style"] !== "" && _.isNil(options["quiz-back-button-border-width"]) == false ? 'border-width: ' + options["quiz-back-button-border-width"] + 'px !important;' : ''}
      ${options["quiz-back-button-border-style"] !== "" && _.isNil(options["quiz-back-button-border-width-left"]) == false ? 'border-left-width: ' + options["quiz-back-button-border-width-left"] + 'px !important;' : _.isNil(options["quiz-button-border-width"]) == false ? 'border-left-width: ' + options["quiz-button-border-width"] + 'px !important;' : ''}
      ${options["quiz-back-button-border-style"] !== "" && _.isNil(options["quiz-back-button-border-width-right"]) == false ? 'border-right-width: ' + options["quiz-back-button-border-width-right"] + 'px !important;' : _.isNil(options["quiz-back-button-border-width"]) == false ? 'border-right-width: ' + options["quiz-back-button-border-width"] + 'px !important;' : ''}
      ${options["quiz-back-button-border-style"] !== "" && _.isNil(options["quiz-back-button-border-width-top"]) == false ? 'border-top-width: ' + options["quiz-back-button-border-width-top"] + 'px !important;' : _.isNil(options["quiz-back-button-border-width"]) == false ? 'border-top-width: ' + options["quiz-back-button-border-width"] + 'px !important;' : ''}
      ${options["quiz-back-button-border-style"] !== "" && _.isNil(options["quiz-back-button-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["quiz-back-button-border-width-bottom"] + 'px !important;' : _.isNil(options["quiz-back-button-border-width"]) == false ? 'border-bottom-width: ' + options["quiz-back-button-border-width"] + 'px !important;' : ''}
      ${options["quiz-back-button-border-style"] !== "" && options["quiz-back-button-border-color"] ? 'border-color: ' + options["quiz-back-button-border-color"] + ' !important;' : options["quiz-back-button-color"] ? 'border-color: ' + options["quiz-back-button-color"] + ' !important;' : ''}
      ${quizBackButtonBorderRadius ? 'border-radius: ' + quizBackButtonBorderRadius + ' !important;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-back-button:hover, #cta_${cta.id} .cf-quiz-back-button:active {
      ${options["quiz-back-button–hover-color"] ? `background: ${options["quiz-back-button–hover-color"]} !important;` : options["quiz-button-color"] ? `background: ${options["quiz-button-color"]} !important;` : ''}
      ${options["quiz-back-button–hover-text-color"] ? `color: ${options["quiz-back-button–hover-text-color"]} !important;` : options["quiz-button-text-color"] ? `color: ${options["quiz-button-text-color"]} !important;` : ''}
      ${options["quiz-back-button-hover-border-color"] ? 'border-color: ' + options["quiz-back-button-hover-border-color"] + ' !important;' : options["quiz-back-button-border-color"] ? 'border-color: ' +  options["quiz-back-button-border-color"] + ' !important;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-question {
      text-align: center;
      margin-left: auto;
      margin-right: auto;
      max-width: 100% !important;
      max-width: -webkit-fill-available !important;
      max-width: fill-available !important;
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-progress {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      justify-content: center;
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-progress-outer {
      flex: 1;
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-progress-message {
      overflow: hidden;
    }

    #cta_${cta.id} .cf-element .cf-quiz-answers-wrapper {
      ${quizOptionsLayout == "stacked" ? 'flex-direction: column;' : ''}
      display: inline-flex;
      margin: 20px 0px;
      width: 100%;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
    }

    #cta_${cta.id} .cf-element .cf-quiz-conditional-content {
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
      margin: 15px 0;
      ${options["quiz-conditional-content-background-color"] ? `background: ${options["quiz-conditional-content-background-color"]};` : ''}
      border-style: ${quizConditionalContentBorderStyle};
      ${quizConditionalContentHasBorder && options["quiz-conditional-content-border-color"] ? `border-color: ${options["quiz-conditional-content-border-color"]};` : ''}
      ${quizConditionalContentHasBorder ? `border-width: ${quizConditionalContentBorderWidth("top")}px ${quizConditionalContentBorderWidth("right")}px ${quizConditionalContentBorderWidth("bottom")}px ${quizConditionalContentBorderWidth("left")}px;` : ''}
      border-radius: ${quizConditionalContentBorderRadius};
      ${options["quiz-conditional-content-padding"] ? `padding: ${options["quiz-conditional-content-padding"]}px;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-conditional-content-item {
      width: 100%;
    }

    #cta_${cta.id} .cf-element .cf-quiz-conditional-content-item img {
      max-width: 100%;
      height: auto;
      display: block;
    }

    #cta_${cta.id} .cf-element .cf-quiz-answers-wrapper input {
      padding: 13px 0px 11px 10px !important;
    }

    #cta_${cta.id} .cf-element .cf-quiz-buttons-wrapper {
      display: flex;
      justify-content: center;
      gap: 25px;
    }

    #cta_${cta.id} .cf-element .cf-quiz-button {
      border-radius: 5px;
      padding: 10px;
      border: 3px solid #000;
    }

    #cta_${cta.id} .cf-element .cf-quiz-disabled-button {
      color: #000;
      background-color: #d8d8d8;
      border: 3px solid #d8d8d8;
    }

    #cta_${cta.id} .cf-element .cf-quiz-option-letter {
      ${quizOptionVisualColor ? `border: 2px solid ${quizOptionVisualColor};` : 'border: 2px solid #000;'}
      ${quizOptionVisualColor ? `background-color: ${quizOptionVisualColor}14;` : ''}
      ${quizOptionVisualFontSize ? `font-size: ${quizOptionVisualFontSize*0.77}px;` : ''}
      ${quizOptionVisualColor ? `color: ${quizOptionVisualColor};` : ''}
      width: ${quizOptionVisualFontSize * 1.5}px !important;
      height: ${quizOptionVisualFontSize * 1.5}px !important;
      border-radius: 50% !important;
      line-height: 182% !important;
      display: block !important;
      text-align: center !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }

    #cta_${cta.id} .cf-element .cf-quiz-question-option:hover .cf-quiz-option-letter {
      ${quizHoverOptionVisualColor ? `border: 2px solid ${quizHoverOptionVisualColor} !important;` : ''}
      ${quizHoverOptionVisualColor ? `background-color: ${quizHoverOptionVisualColor}14 !important;` : ''}
      ${quizHoverOptionVisualColor ? `color: ${quizHoverOptionVisualColor} !important;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-option-emoji,
    #cta_${cta.id} .cf-element .cf-quiz-option-icon {
      ${!variant.options["label-image-placement"] || variant.options["label-image-placement"] == "center" ? 'text-align: center;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-option-emoji,
    #cta_${cta.id} .cf-element .cf-quiz-option-icon svg {
      ${quizOptionVisualFontSize ? `font-size: ${quizOptionVisualFontSize}px;` : ''}
      ${quizOptionVisualColor ? `color: ${quizOptionVisualColor};` : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-question-option:hover .cf-quiz-option-emoji,
    #cta_${cta.id} .cf-element .cf-quiz-question-option:hover .cf-quiz-option-icon svg {
      ${quizHoverOptionVisualColor ? `color: ${quizHoverOptionVisualColor};` : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-option-color {
      ${quizOptionColorSize ? `width: ${quizOptionColorSize}px;` : 'width: 50px;'}
      ${quizOptionColorSize ? `height: ${quizOptionColorSize}px;` : 'height: 50px;'}
      background-color: #000;
      margin-left: auto;
      margin-right: auto;
      border-radius: 50%;
    }

    #cta_${cta.id} .cf-element .cf-quiz-image-box svg {
      max-width: 100%;
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-loading-bar {
      margin-left: auto;
      margin-right: auto;
      display: block;
      position: relative;
      height: 12px;
      width: 60%;
      border: 1px solid #000;
      border-radius: 10px;
      overflow: hidden;
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-loading-bar:after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 0;
      background: #8d8d8c;
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-loading-spinner {
      margin-top: 25px;
      margin-left: auto;
      margin-right: auto;
      width: 48px;
      height: 48px;
      display: block;
      border-radius: 50%;
      position: relative;
      animation: cf-quiz-loading-spinner 1s linear infinite
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-loading-spinner::before {
      content: "";
      box-sizing: border-box;
      position: absolute;
      inset: 0px;
      border-radius: 50%;
      border: 5px solid #000;
      animation: cf-quiz-loading-spinner-prix 2s linear infinite ;
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-quiz-label-image {
      height: fit-content;
      margin: 15px 0px;
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-quiz-image-box {
      ${!variant.options["label-image-placement"] || variant.options["label-image-placement"] == "center" ? 'text-align: center;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-quiz-image-box img {
      object-fit: cover;
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-quiz-answers-outer-wrapper {
      ${["left", "right"].includes(variant.options["label-image-placement"]) ? 'display: flex;' : ''}
      ${variant.options["label-image-placement"] == "right" ? 'flex-direction: row-reverse;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-quiz-answers-outer-wrapper img {
      ${['left', 'right'].includes(variant.options["label-image-placement"]) ? 'max-width: 80%;' : ''}
      ${variant.options["label-image-placement"] == 'left' ? 'margin-right: 30px;' : ''}
      ${variant.options["label-image-placement"] == 'right' ? 'margin-left: 30px;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-quiz-inner-wrapper {
      margin-left: auto;
      margin-right: auto;
      ${['left', 'right'].includes(variant.options["label-image-placement"]) ? 'margin-top: 0px; margin-bottom: auto;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-option-image-svg {
      display: block;
      width: 150px;
      fill: rgba(255, 255, 255, 1);
      background-color: rgba(105, 114, 123, 0.5);
      border: 1px solid rgba(105, 114, 123, 0.2);
    }

    #cta_${cta.id} .cf-element .cf-quiz-option-icon .svg-inline--fa {
      display: var(--fa-display, inline-block);
      height: 1em;
      overflow: visible;
    }

    #cta_${cta.id} .cf-element .cf-quiz-question-option[data-field-type="survey"],
    #cta_${cta.id} .cf-element .cf-quiz-question-option[data-field-type="radio_survey"] {
      padding: 15px;
    }

    #cta_${cta.id} .cf-element .cf-quiz-question-option[data-field-type="survey"],
    #cta_${cta.id} .cf-element .cf-quiz-question-option[data-field-type="radio_survey"],
    #cta_${cta.id} .cf-element .cf-quiz-question-option[data-field-type="image"],
    #cta_${cta.id} .cf-element .cf-quiz-question-option[data-field-type="color"],
    #cta_${cta.id} .cf-element .cf-quiz-question-option[data-field-type="icon"],
    #cta_${cta.id} .cf-element .cf-quiz-question-option[data-field-type="letter"],
    #cta_${cta.id} .cf-element .cf-quiz-question-option[data-field-type="emoji"] {
      box-sizing: border-box;
      align-items: center;
      justify-content: flex-start;
      display: flex;
      cursor: pointer;
      ${quizOptionBackgroundColor ? `background: ${quizOptionBackgroundColor};` : ''}
      ${quizOptionBoxShadow ? `box-shadow: ${quizOptionBoxShadow} !important;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-question-option[data-field-type="radio_survey"] .cf-quiz-option-radio {
      width: 18px;
      height: 18px;
      min-width: 18px;
      border: 2px solid #bdc3c7;
      border-radius: 50%;
      background: #fff;
      margin-right: 10px;
      flex-shrink: 0;
      box-sizing: border-box;
    }

    #cta_${cta.id} .cf-element .cf-form-fields {
      width: 100%;
    }

    #cta_${cta.id} .cf-element .cf-form-2 {
      margin-left: auto;
      margin-right: auto;
    }

    #cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="text"].cf-quiz-required,
    #cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="date"].cf-quiz-required,
    #cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="datetime-local"].cf-quiz-required,
    #cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="email"].cf-quiz-required,
    #cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="tel"].cf-quiz-required,
    #cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default input[type="number"].cf-quiz-required,
    #cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default textarea.cf-quiz-required,
    #cta_${cta.id} .cf-element .cf-form-2.cf-form-theme-default select.cf-quiz-required {
      box-shadow: 0 0 5px 0 rgb(241 4 4) !important;
      margin-top: 3px !important;
    }

    #cta_${cta.id} .cf-element .cf-quiz-option-label {
      margin-left: auto;
      margin-right: auto;
      ${options["quiz-option-text-alignment"] == 'left' ? `margin-left: 0px !important; text-align: left !important;` : ''}
      ${options["quiz-option-text-alignment"] == 'right' ? `margin-right: 0px !important; text-align: right !important;` : ''}
      ${quizOptionFontSize ? `font-size: ${quizOptionFontSize}px;` : ''}
      ${quizOptionFontFamily && quizOptionFontFamily !== 'inherit' ? `font-family: ${quizOptionFontFamily}, sans-serif;` : ''}
      ${quizOptionFontWeight ? `font-weight: ${quizOptionFontWeight};` : ''}
      ${quizOptionFontColor ? `color: ${quizOptionFontColor};` : ''}
      ${quizOptionFontLineHeight ? `line-height: ${quizOptionFontLineHeight}px;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-progress {
      ${quizQuestionDistanceFromProgress ? `margin-bottom: ${quizQuestionDistanceFromProgress}px;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-progress-outer {
      ${options["quiz-progress-outer-background-color"] ? `background: ${options["quiz-progress-outer-background-color"]} !important;` : ''}
      ${options["quiz-progress-border-style"] ? `border-style: ${options["quiz-progress-border-style"]} !important;` : ''}
      ${options["quiz-progress-border-color"] ? `border-color: ${options["quiz-progress-border-color"]} !important;` : ''}
      ${quizProgressOuterRadius ? `border-radius: ${quizProgressOuterRadius} !important;` : ''}
      ${_.isNil(options["quiz-progress-border-width-left"]) == false ? `border-left-width: ${options["quiz-progress-border-width-left"]}px !important;` : ''}
      ${_.isNil(options["quiz-progress-border-width-right"]) == false ? `border-right-width: ${options["quiz-progress-border-width-right"]}px !important;` : ''}
      ${_.isNil(options["quiz-progress-border-width-bottom"]) == false ? `border-bottom-width: ${options["quiz-progress-border-width-bottom"]}px !important;` : ''}
      ${_.isNil(options["quiz-progress-border-width-top"]) == false ? `border-top-width: ${options["quiz-progress-border-width-top"]}px !important;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-progress-inner {
      ${options["quiz-progress-inner-background-color"] ? `background: ${options["quiz-progress-inner-background-color"]} !important;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-progress-message,
    #cta_${cta.id} .cf-element .cf-quiz-progress-message h1,
    #cta_${cta.id} .cf-element .cf-quiz-progress-message h2,
    #cta_${cta.id} .cf-element .cf-quiz-progress-message h3,
    #cta_${cta.id} .cf-element .cf-quiz-progress-message h4,
    #cta_${cta.id} .cf-element .cf-quiz-progress-message h5,
    #cta_${cta.id} .cf-element .cf-quiz-progress-message p,
    #cta_${cta.id} .cf-element .cf-quiz-progress-message span {
      ${options["quiz-progress-text-font"] ? `font-family: ${options["quiz-progress-text-font"]}, Helvetica, Arial, sans-serif !important;` : ''}
      ${options['quiz-progress-text-font-weight'] ? `font-weight: ${options['quiz-progress-text-font-weight']} !important;` : ''}
      ${options["quiz-progress-text-color"] ? `color: ${options["quiz-progress-text-color"]} !important;` : ''}
      ${options["quiz-progress-text-size"] ? `font-size: ${options["quiz-progress-text-size"]}px !important;` : ''}
    }`;

    let quizOptionFontSizeMobile;
    if (
      options["quiz-option-font-size-mobile"] &&
      options["quiz-option-font-size-mobile"] !== "theme"
    ) {
      quizOptionFontSizeMobile = options["quiz-option-font-size-mobile"];
    } else {
      quizOptionFontSizeMobile = 14;
    }

    let quizOptionFontLineHeightMobile;
    if (
      options["quiz-option-font-line-height-mobile"] &&
      options["quiz-option-font-line-height-mobile"] !== "theme"
    ) {
      quizOptionFontLineHeightMobile =
        options["quiz-option-font-line-height-mobile"];
    }

    let quizOptionVisualFontSizeMobile =
      options["quiz-option-visual-font-size-mobile"] || undefined;
    let quizOptionColorSizeMobile =
      options["quiz-option-color-size-mobile"] || undefined;

    let quizQuestionDistanceFromProgressMobile =
      options["quiz-question-distance-from-progress-mobile"];

    let quizOptionsLayoutMobile = options["quiz-options-layout-mobile"];

    mobileStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-progress {
      ${quizQuestionDistanceFromProgressMobile ? `margin-bottom: ${quizQuestionDistanceFromProgressMobile}px !important;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-quiz-answers-outer-wrapper {
      ${["left", "right"].includes(variant.options["label-image-placement-mobile"]) ? 'display: flex;' : ''}
      ${variant.options["label-image-placement-mobile"] == "right" ? 'flex-direction: row-reverse;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-answers-wrapper {
      ${quizOptionsLayoutMobile == "stacked" ? 'flex-direction: column !important;' : ''}
      ${quizOptionsLayoutMobile == "responsive" ? 'flex-direction: row !important;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-quiz-answers-outer-wrapper img {
      margin: 0px;
    }

    #cta_${cta.id} .cf-element .cf-quiz-question .cf-quiz-answers-outer-wrapper img {
      max-width: 100%;
      margin-left: auto;
      margin-right: auto;
    }

    #cta_${cta.id} .cf-element .cf-quiz-option-letter {
      width: ${quizOptionVisualFontSizeMobile * 1.5}px !important;
      height: ${quizOptionVisualFontSizeMobile * 1.5}px !important;
      ${quizOptionVisualFontSizeMobile ? `font-size: ${quizOptionVisualFontSizeMobile*0.77}px;` : ''}
      border-radius: 2px;
    }

    #cta_${cta.id} .cf-element .cf-quiz-option-emoji,
    #cta_${cta.id} .cf-element .cf-quiz-option-icon svg {
      ${quizOptionVisualFontSizeMobile ? `font-size: ${quizOptionVisualFontSizeMobile}px;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-option-color {
      ${quizOptionColorSizeMobile ? `width: ${quizOptionColorSizeMobile}px !important;` : ''}
      ${quizOptionColorSizeMobile ? `height: ${quizOptionColorSizeMobile}px !important;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-quiz-question-option[data-field-type="icon"] .cf-quiz-option-label,
    #cta_${cta.id} .cf-element .cf-quiz-question-option[data-field-type="emoji"] .cf-quiz-option-label,
    #cta_${cta.id} .cf-element .cf-quiz-question-option[data-field-type="color"] .cf-quiz-option-label,
    #cta_${cta.id} .cf-element .cf-quiz-question-option[data-field-type="letter"] .cf-quiz-option-label {
      max-width: 70%;
    }

    #cta_${cta.id} .cf-element .cf-quiz-option-label {
      ${quizOptionFontSizeMobile ? `font-size: ${quizOptionFontSizeMobile}px;` : ''}
      ${quizOptionFontLineHeightMobile ? `line-height: ${quizOptionFontLineHeightMobile}px;` : ''}
      ${options["quiz-option-text-alignment-mobile"] == 'left' ? `margin-left: 0px !important; margin-right: auto !important; text-align: left !important;` : ''}
      ${options["quiz-option-text-alignment-mobile"] == 'right' ? `margin-right: 0px !important; margin-left: auto !important; text-align: right !important;` : ''}
      ${options["quiz-option-text-alignment-mobile"] == 'center' ? `margin-left: auto !important; margin-right: auto !important; text-align: center !important;` : ''}
    }
    `;
    //////// END QUIZES THEME STYLES

    ////////// START SURVEYS THEME STYLES
    let surveysVisualTypePlacement;
    if (options["visual-type-placement"] == "left") {
      surveysVisualTypePlacement = "width: auto;";
    } else {
      surveysVisualTypePlacement = "width: 100%;";
    }

    let surveysVisualTypeFontSize;
    if (options["visual-type-font-size"]) {
      surveysVisualTypeFontSize = options["visual-type-font-size"];
    }

    let surveysFontColor;
    if (options["visual-type-font-color"]) {
      surveysFontColor = options["visual-type-font-color"];
    } else {
      surveysFontColor = "#0072f7";
    }

    desktopStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-survey .cf-visual-type-box {
        ${surveysVisualTypePlacement ? surveysVisualTypePlacement : ""}
      }

      #cta_${cta.id} .cf-element .cf-survey .cf-visual-type-letter {
        ${surveysFontColor ? `border: 2px solid ${surveysFontColor};` : ''}
        ${surveysFontColor ? `background-color: ${surveysFontColor}14;` : ''}
        ${surveysFontColor ? `color: ${surveysFontColor};` : ""}
      }

      #cta_${cta.id} .cf-element .cf-survey .cf-visual-type {
        ${surveysFontColor ? `color: ${surveysFontColor};` : ""}
      }`;

    let surveysVisualTypePlacementMobile;
    if (options["visual-type-placement-mobile"] == "centered") {
      surveysVisualTypePlacementMobile = "width: 100%;";
    }

    let surveysVisualTypeFontSizeMobile;
    if (options["visual-type-font-size"]) {
      surveysVisualTypeFontSizeMobile = options["visual-type-font-size-mobile"];
    }

    let surveysFontColorMobile;
    if (options["visual-type-font-color-mobile"]) {
      surveysFontColorMobile = options["visual-type-font-color-mobile"];
    } else {
      surveysFontColor = "#0072f7";
    }

    mobileStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-survey .cf-visual-type-box {
        ${surveysVisualTypePlacementMobile ? surveysVisualTypePlacementMobile : ""}
      }

      #cta_${cta.id} .cf-element .cf-survey .cf-visual-type-letter {
        ${surveysFontColorMobile ? `border: 2px solid ${surveysFontColorMobile};` : ''}
        ${surveysFontColorMobile ? `background: ${surveysFontColorMobile};` : ''}
        width: ${surveysVisualTypeFontSizeMobile * 1.5}px !important;
        height: ${surveysVisualTypeFontSizeMobile * 1.5}px !important;
        border-radius: 2px;
      }

      #cta_${cta.id} .cf-element .cf-survey .cf-visual-type {
        ${surveysVisualTypeFontSizeMobile ? `font-size: ${surveysVisualTypeFontSizeMobile}px;` : ""}
        ${surveysVisualTypeFontSizeMobile ? `line-height: ${surveysVisualTypeFontSizeMobile * 1.3}px;` : ""}
        ${surveysFontColorMobile ? `color: ${surveysFontColorMobile};` : ""}
      }`;
    //////// END SURVEYS THEME STYLES

    ////////// START COLLAPSES THEME STYLES
    let collapseHeadingFontFamily =
      options["collapse-heading-font-family"] || undefined;
    let collapseHeadingFontWeight =
      options["collapse-heading-font-weight"] || undefined;
    let collapseHeadingFontSize =
      options["collapse-heading-font-size"] || undefined;
    let collapseHeadingFontColor =
      options["collapse-heading-font-color"] || undefined;
    let collapseHeadingBackgroundColor =
      options["collapse-heading-background-color"] || undefined;

    let collapseHeadingBorderRadius = "";
    if (options["collapse-heading-radius"] == "cf-not-rounded") {
      collapseHeadingBorderRadius = "0px";
    }
    if (options["collapse-heading-radius"] == "cf-slightly-rounded") {
      collapseHeadingBorderRadius = "4px";
    }
    if (options["collapse-heading-radius"] == "cf-fully-rounded") {
      collapseHeadingBorderRadius = "100px";
    }
    if (options["collapse-heading-radius"] == "custom") {
      collapseHeadingBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          collapseHeadingBorderRadius += `${
            _.isNil(options["collapse-heading-radius-" + side]) == false
              ? options["collapse-heading-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let collapseBoxShadow;

    if (options["collapse-shadow"] == "None") {
      collapseBoxShadow = "none";
    }

    if (options["collapse-shadow"] == "soft") {
      collapseBoxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["collapse-shadow"] == "hard") {
      collapseBoxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["collapse-shadow"] == "custom") {
      collapseBoxShadow = "";
      collapseBoxShadow +=
        (options["collapse-shadow-horizontal-distance"]
          ? `${options["collapse-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      collapseBoxShadow +=
        (options["collapse-shadow-vertical-distance"]
          ? `${options["collapse-shadow-vertical-distance"]}px`
          : "0px") + " ";

      collapseBoxShadow +=
        (options["collapse-shadow-blur-radius"]
          ? `${options["collapse-shadow-blur-radius"]}px`
          : "0px") + " ";

      collapseBoxShadow +=
        (options["collapse-shadow-spread-radius"]
          ? `${options["collapse-shadow-spread-radius"]}px`
          : "0px") + " ";

      collapseBoxShadow +=
        (options["collapse-shadow-color"]
          ? options["collapse-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";
    }

    let collapseContentBackgroundColor =
      options["collapse-content-background-color"] || undefined;
    let collapseItemsDistance = options["collapse-items-distance"] || 4;

    desktopStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-collapse {
      ${collapseItemsDistance ? `margin-bottom: ${collapseItemsDistance}px;` : ''}
      ${collapseBoxShadow ? `box-shadow: ${collapseBoxShadow} !important;` : ''}

    }

    #cta_${cta.id} .cf-element .cf-collapse-title * {
      ${collapseHeadingFontFamily ? `font-family: ${collapseHeadingFontFamily}, Helvetica, Arial, sans-serif !important;` : 'font-family: sans-serif !important;'}
      ${collapseHeadingFontWeight ? `font-weight: ${collapseHeadingFontWeight} !important;` : ''}
      ${collapseHeadingFontSize ? `font-size: ${collapseHeadingFontSize}px !important;` : ''}
      ${collapseHeadingFontColor ? `color: ${collapseHeadingFontColor};` : ''}
    }

    #cta_${cta.id} .cf-element .cf-collapse > .cf-collapse-heading svg {
      ${collapseHeadingFontColor ? `color: ${collapseHeadingFontColor} !important;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-collapse-heading {
      ${collapseHeadingBackgroundColor ? `background: ${collapseHeadingBackgroundColor};` : ''}
      ${options["collapse-heading-border-style"] ? `border-style: ${options["collapse-heading-border-style"]} !important;` : ''}
      ${_.isNil(options["collapse-heading-border-width"]) == false ? 'border-width: ' + options["collapse-heading-border-width"] + 'px !important;' : ''}
      ${_.isNil(options["collapse-heading-border-width-left"]) == false ? 'border-left-width: ' + options["collapse-heading-border-width-left"] + 'px !important;' : ''}
      ${_.isNil(options["collapse-heading-border-width-right"]) == false ? 'border-right-width: ' + options["collapse-heading-border-width-right"] + 'px !important;' : ''}
      ${_.isNil(options["collapse-heading-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["collapse-heading-border-width-bottom"] + 'px !important;' : ''}
      ${_.isNil(options["collapse-heading-border-width-top"]) == false ? 'border-top-width: ' + options["collapse-heading-border-width-top"] + 'px !important;' : ''}
      ${options["collapse-heading-border-color"] ? `border-color: ${options["collapse-heading-border-color"]} !important;` : 'border-color: #000000;'}
      ${collapseHeadingBorderRadius ? 'border-radius: ' + collapseHeadingBorderRadius + ' !important;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-collapse-heading.cf-collapse-box-in {
      border-bottom-left-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
    }

    #cta_${cta.id} .cf-element .cf-collapse-box.cf-collapse-box-in {
      ${collapseHeadingBorderRadius ? 'border-radius: ' + collapseHeadingBorderRadius + ' !important;' : ''}
      border-top-left-radius: 0px !important;
      border-top-right-radius: 0px !important;
    }

    #cta_${cta.id} .cf-element .cf-collapse-box {
      ${collapseContentBackgroundColor ? `background: ${collapseContentBackgroundColor};` : ''}
    }
    `;
    let collapseHeadingFontSizeMobile =
      options["collapse-heading-font-size-mobile"] || undefined;

    // prettier-ignore
    mobileStyles +=
    `#cta_${cta.id} .cf-element .cf-collapse-title * {
      ${collapseHeadingFontSizeMobile ? `font-size: ${collapseHeadingFontSizeMobile}px !important;` : ''}
    }
    `;
    ////////// END COLLAPSES THEME STYLES

    ////////// START CAROUSEL THEME STYLES

    let carouselBackgroundColor =
      options["carousel-background-color"] || undefined;

    let carouselArrowControlsColor =
      options["carousel-arrow-controls-color"] || undefined;

    let carouselArrowBorderStyle =
      options["carousel-arrow-border-style"] || "solid";

    let carouselArrowBorderColor =
      options["carousel-arrow-border-color"] || carouselArrowControlsColor || undefined;

    let carouselArrowBorderRadius = "";
    if (options["carousel-arrow-border-radius"] == "cf-not-rounded") {
      carouselArrowBorderRadius = "0px";
    } else if (options["carousel-arrow-border-radius"] == "cf-slightly-rounded") {
      carouselArrowBorderRadius = "4px";
    } else if (options["carousel-arrow-border-radius"] == "cf-fully-rounded" || !options["carousel-arrow-border-radius"]) {
      carouselArrowBorderRadius = "50%";
    } else if (options["carousel-arrow-border-radius"] == "custom") {
      carouselArrowBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          carouselArrowBorderRadius += `${
            _.isNil(options["carousel-arrow-border-radius-" + side]) == false
              ? options["carousel-arrow-border-radius-" + side]
              : "50"
          }% `;
        }
      );
    }

    let carouselIndicatorControlsColor =
      options["carousel-indicator-controls-color"] || undefined;

    let carouselIndicatorSize = options["carousel-indicator-size"] || undefined;
    let carouselArrowSize = options["carousel-arrow-size"] || undefined;

    let carouselIndicatorBorderRadius = "";
    if (options["carousel-indicator-border-radius"] == "cf-not-rounded") {
      carouselIndicatorBorderRadius = "0px";
    }
    if (options["carousel-indicator-border-radius"] == "cf-slightly-rounded") {
      carouselIndicatorBorderRadius = "4px";
    }
    if (options["carousel-indicator-border-radius"] == "cf-fully-rounded") {
      carouselIndicatorBorderRadius = "100px";
    }
    if (options["carousel-indicator-border-radius"] == "custom") {
      carouselIndicatorBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          carouselIndicatorBorderRadius += `${
            _.isNil(options["carousel-indicator-border-radius-" + side]) ==
            false
              ? options["carousel-indicator-border-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    // prettier-ignore
    desktopStyles += `
    #cta_${cta.id} .cf-element .cf-carousel-element .cf-carousel-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    #cta_${cta.id} .cf-element .cf-carousel-element .cf-carousel {
      position: relative;
      display: flex;
      transition: 0.5s;
    }

    #cta_${cta.id} .cf-element .cf-carousel-element .cf-carousel-item {
      flex: 1 0 100%;
    }

    #cta_${cta.id} .cf-element .cf-carousel-element .cf-carousel-item .cf-section {
      height: 100%;
    }

    #cta_${cta.id} .cf-element .cf-carousel-element .cf-carousel-indicators {
      display: inline-flex;
      flex-wrap: wrap;
      gap: 15px;
      margin-top: 10px;
      align-items: center;
      justify-content: center;
      width: 100%;
    }

    #cta_${cta.id} .cf-element .cf-carousel-element .cf-carousel-slide-wrapper {
      flex: 1;
      align-items: center;
      overflow: hidden;
      display: flex;
      max-width: 100%;
      ${carouselBackgroundColor ? `background: ${carouselBackgroundColor};` : ''}
    }

    #cta_${cta.id} .cf-element .cf-carousel-element .cf-carousel-indicator {
      cursor: pointer;
      padding: 5px;
      ${carouselIndicatorControlsColor ? `background: ${carouselIndicatorControlsColor};` : 'background: #bdc3c7;'}
      ${carouselIndicatorBorderRadius ? `border-radius: ${carouselIndicatorBorderRadius};` : 'border-radius: 50%;'}
      ${carouselIndicatorSize ? `width: ${carouselIndicatorSize}px;` : ''}
      ${carouselIndicatorSize ? `height: ${carouselIndicatorSize}px;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-carousel-element .cf-carousel-indicator.active {
      ${options["carousel-indicator-active-border-style"] ? 'border-style: ' + options["carousel-indicator-active-border-style"] + ' !important;' : 'border: 1px solid #000;'}
      ${options["carousel-indicator-active-border-style"] !== "" && _.isNil(options["carousel-indicator-active-border-width"]) == false ? 'border-width: ' + options["carousel-indicator-active-border-width"] + 'px !important;' : ''}
      ${options["carousel-indicator-active-border-style"] !== "" && _.isNil(options["carousel-indicator-active-border-width-left"]) == false ? 'border-left-width: ' + options["carousel-indicator-active-border-width-left"] + 'px !important;' : _.isNil(options["carousel-indicator-active-border-width"]) == false ? 'border-left-width: ' + options["carousel-indicator-active-border-width"] + 'px !important;' : ''}
      ${options["carousel-indicator-active-border-style"] !== "" && _.isNil(options["carousel-indicator-active-border-width-right"]) == false ? 'border-right-width: ' + options["carousel-indicator-active-border-width-right"] + 'px !important;' : _.isNil(options["carousel-indicator-active-border-width"]) == false ? 'border-right-width: ' + options["carousel-indicator-active-border-width"] + 'px !important;' : ''}
      ${options["carousel-indicator-active-border-style"] !== "" && _.isNil(options["carousel-indicator-active-border-width-top"]) == false ? 'border-top-width: ' + options["carousel-indicator-active-border-width-top"] + 'px !important;' : _.isNil(options["carousel-indicator-active-border-width"]) == false ? 'border-top-width: ' + options["carousel-indicator-active-border-width"] + 'px !important;' : ''}
      ${options["carousel-indicator-active-border-style"] !== "" && _.isNil(options["carousel-indicator-active-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["carousel-indicator-active-border-width-bottom"] + 'px !important;' : _.isNil(options["carousel-indicator-active-border-width"]) == false ? 'border-bottom-width: ' + options["carousel-indicator-active-border-width"] + 'px !important;' : ''}
      ${options["carousel-indicator-active-border-style"] !== "" && options["carousel-indicator-active-border-color"] ? 'border-color: ' + options["carousel-indicator-active-border-color"] + ' !important;' : options["carousel-indicator-active-color"] ? 'border-color: ' + options["carousel-indicator-active-color"] + ' !important;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-carousel-element .cf-arrow-control {
      cursor: pointer;
      margin: 0px 10px;
      z-index: 1;
    }

    #cta_${cta.id} .cf-element .cf-carousel-element .cf-arrow-control svg {
      ${carouselArrowBorderStyle && carouselArrowBorderStyle !== 'none' ? `
        border-style: ${carouselArrowBorderStyle};
        border-left-width: ${options["carousel-arrow-border-width-left"] || options["carousel-arrow-border-width"] || "1"}px;
        border-right-width: ${options["carousel-arrow-border-width-right"] || options["carousel-arrow-border-width"] || "1"}px;
        border-top-width: ${options["carousel-arrow-border-width-top"] || options["carousel-arrow-border-width"] || "1"}px;
        border-bottom-width: ${options["carousel-arrow-border-width-bottom"] || options["carousel-arrow-border-width"] || "1"}px;
        border-color: ${carouselArrowBorderColor || 'black'};
      ` : 'border: none;'}
      ${carouselArrowControlsColor ? `color: ${carouselArrowControlsColor};` : ''}
      ${carouselArrowBorderRadius ? `border-radius: ${carouselArrowBorderRadius};` : 'border-radius: 50%;'}
      box-sizing: initial !important;
    }

    #cta_${cta.id} .cf-element .cf-carousel-element .cf-arrow-control svg:hover {
      ${options["carousel-arrow-hover-border-color"] ? `border-color: ${options["carousel-arrow-hover-border-color"]};` : ''}
      ${options["carousel-arrow-hover-controls-color"] ? `color: ${options["carousel-arrow-hover-controls-color"]};` : ''}
      ${options["carousel-arrow-hover-background-color"] ? `background-color: ${options["carousel-arrow-hover-background-color"]};` : ''}
    }

    #cta_${cta.id} .cf-element .cf-carousel-element .cf-arrow-control .svg-inline--fa {
      display: var(--fa-display, inline-block);
      height: 1em;
      overflow: visible;
      ${carouselArrowSize ? `font-size: ${carouselArrowSize}px;` : 'font-size: 12px;'}
    }
    `

    let carouselIndicatorSizeMobile =
      options["carousel-indicator-size-mobile"] || undefined;

    let carouselArrowSizeMobile =
      options["carousel-arrow-size-mobile"] || undefined;

    mobileStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-carousel-element .cf-carousel-indicator {
      ${carouselIndicatorSizeMobile ? `width: ${carouselIndicatorSizeMobile}px;` : ''}
      ${carouselIndicatorSizeMobile ? `height: ${carouselIndicatorSizeMobile}px;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-carousel-element .cf-arrow-control {
      margin: 0px 5px;
    }

    #cta_${cta.id} .cf-element .cf-carousel-element .cf-carousel-wrapper {
      overflow: hidden;
      max-width: 100%;
    }

    #cta_${cta.id} .cf-element .cf-carousel-element .cf-carousel-item {
      overflow-y: auto;
    }

    #cta_${cta.id} .cf-element .cf-carousel-element .cf-arrow .svg-inline--fa {
      ${carouselArrowSizeMobile ? `font-size: ${carouselArrowSizeMobile}px;` : 'font-size: 12px;'}
    }
    `;
    ////////// END CAROUSEL THEME STYLES

    ////////// START TABS THEME STYLES
    let tabsAlignment = "";
    if (variant.options["tabs-layout"] !== "vertical") {
      tabsAlignment = options["tabs-alignment"];
    }
    let tabsFontFamily = options["tabs-font-family"] || undefined;
    let tabsFontWeight = options["tabs-font-weight"] || undefined;
    let tabsFontSize = options["tabs-font-size"] || undefined;
    let tabsFontColor = options["tabs-font-color"] || undefined;
    let tabsFontColorHover = options["tabs-font-color-hover"] || undefined;
    let tabsFontColorActive = options["tabs-font-color-active"] || undefined;
    let tabsBackgroundColor = options["tabs-background-color"] || undefined;
    let tabsBackgroundColorHover =
      options["tabs-background-color-hover"] || undefined;
    let tabsBackgroundColorActive =
      options["tabs-background-color-active"] || undefined;

    let tabsBorderRadius = "";
    if (options["tabs-radius"] == "cf-not-rounded") {
      tabsBorderRadius = "0px";
    }
    if (options["tabs-radius"] == "cf-slightly-rounded") {
      tabsBorderRadius = "4px";
    }
    if (options["tabs-radius"] == "cf-fully-rounded") {
      tabsBorderRadius = "100px";
    }
    if (options["tabs-radius"] == "custom") {
      tabsBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          tabsBorderRadius += `${
            _.isNil(options["tabs-radius-" + side]) == false
              ? options["tabs-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let tabsItemPadding = "";
    if (options["tabs-padding-style"] == "custom") {
      tabsItemPadding = options["tabs-padding-value"] || 0;
    }

    let tabsContentBackgroundColor =
      options["tabs-content-background-color"] || undefined;

    let tabsContentBorderRadius = "";
    if (options["tabs-content-radius"] == "cf-not-rounded") {
      tabsContentBorderRadius = "0px";
    }
    if (options["tabs-content-radius"] == "cf-slightly-rounded") {
      tabsContentBorderRadius = "4px";
    }
    if (options["tabs-content-radius"] == "cf-fully-rounded") {
      tabsContentBorderRadius = "100px";
    }
    if (options["tabs-content-radius"] == "custom") {
      tabsContentBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          tabsContentBorderRadius += `${
            _.isNil(options["tabs-content-radius-" + side]) == false
              ? options["tabs-content-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let tabsContentSpacingHorizontal =
      options["tabs-content-spacing-horizontal"] || undefined;
    let tabsContentSpacingVertical =
      options["tabs-content-spacing-vertical"] || undefined;
    let tabsWidth = options["tabs-width"] || undefined;

    let tabsBorderColor = options["tabs-border-color"] || undefined;
    let tabsBorderColorActive =
      options["tabs-border-color-active"] || undefined;
    let tabsBorderColorHover = options["tabs-border-color-hover"] || undefined;

    desktopStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-tabs-element .cf-tabs-container {
      display: flex;
    }

    #cta_${cta.id} .cf-element .cf-tabs-element .cf-tab-item {
      cursor: pointer;
      overflow: hidden;
      ${tabsBackgroundColor ? `background: ${tabsBackgroundColor};` : ''}
      ${options["tabs-border-style"] ? `border-style: ${options["tabs-border-style"]} !important;` : ''}
      ${_.isNil(options["tabs-border-width"]) == false ? 'border-width: ' + options["tabs-border-width"] + 'px !important;' : ''}
      ${_.isNil(options["tabs-border-width-left"]) == false ? 'border-left-width: ' + options["tabs-border-width-left"] + 'px !important;' : ''}
      ${_.isNil(options["tabs-border-width-right"]) == false ? 'border-right-width: ' + options["tabs-border-width-right"] + 'px !important;' : ''}
      ${_.isNil(options["tabs-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["tabs-border-width-bottom"] + 'px !important;' : ''}
      ${_.isNil(options["tabs-border-width-top"]) == false ? 'border-top-width: ' + options["tabs-border-width-top"] + 'px !important;' : ''}
      ${tabsBorderColor ? `border-color: ${tabsBorderColor} !important;` : 'border-color: #000000;'}
      ${tabsBorderRadius ? 'border-radius: ' + tabsBorderRadius + ' !important;' : ''}
      text-align: center;
      box-sizing: border-box;
    }

    #cta_${cta.id} .cf-element .cf-tabs-element .cf-tab-item,
    #cta_${cta.id} .cf-element .cf-tabs-element .cf-tab-item h1,
    #cta_${cta.id} .cf-element .cf-tabs-element .cf-tab-item h2,
    #cta_${cta.id} .cf-element .cf-tabs-element .cf-tab-item h3,
    #cta_${cta.id} .cf-element .cf-tabs-element .cf-tab-item h4,
    #cta_${cta.id} .cf-element .cf-tabs-element .cf-tab-item h5,
    #cta_${cta.id} .cf-element .cf-tabs-element .cf-tab-item p {
      ${tabsFontFamily ? `font-family: ${tabsFontFamily}, Helvetica, Arial, sans-serif;` : 'font-family: sans-serif !important;'}
    }

    #cta_${cta.id} .cf-element .cf-tabs-element .cf-tabs-container .cf-section-box {
      ${tabsContentBackgroundColor ? `background: ${tabsContentBackgroundColor};` : ''}
      ${options["tabs-content-border-style"] ? `border-style: ${options["tabs-content-border-style"]} !important;` : ''}
      ${_.isNil(options["tabs-content-border-width"]) == false ? 'border-width: ' + options["tabs-content-border-width"] + 'px !important;' : ''}
      ${_.isNil(options["tabs-content-border-width-left"]) == false ? 'border-left-width: ' + options["tabs-content-border-width-left"] + 'px !important;' : ''}
      ${_.isNil(options["tabs-content-border-width-right"]) == false ? 'border-right-width: ' + options["tabs-content-border-width-right"] + 'px !important;' : ''}
      ${_.isNil(options["tabs-content-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["tabs-content-border-width-bottom"] + 'px !important;' : ''}
      ${_.isNil(options["tabs-content-border-width-top"]) == false ? 'border-top-width: ' + options["tabs-content-border-width-top"] + 'px !important;' : ''}
      ${options["tabs-content-border-color"] ? `border-color: ${options["tabs-content-border-color"]} !important;` : 'border-color: #000000;'}
      ${tabsContentBorderRadius ? 'border-radius: ' + tabsContentBorderRadius + ' !important;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-tabs-element .cf-tabs-container .cf-tabs-list {
      ${tabsAlignment ? `justify-content: ${tabsAlignment};` : ''}
      ${tabsFontWeight ? `font-weight: ${tabsFontWeight};` : ''}
      ${tabsFontSize ? `font-size: ${tabsFontSize}px;` : ''}
      ${tabsFontColor ? `color: ${tabsFontColor};` : ''}
    }

    #cta_${cta.id} .cf-element .cf-tabs-element .cf-tab-item.active {
      ${tabsFontColorActive ? `color: ${tabsFontColorActive};` : 'color: #1e90ff;'}
      ${tabsBackgroundColorActive ? `background: ${tabsBackgroundColorActive};` : ''}
      ${tabsBorderColorActive ? `border-color: ${tabsBorderColorActive} !important;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-tabs-element .cf-tab-item:hover,
    #cta_${cta.id} .cf-element .cf-tabs-element .cf-tab-item.active:hover {
      ${tabsBorderColorHover ? `border-color: ${tabsBorderColorHover} !important;` : ''}
      ${tabsFontColorHover ? `color: ${tabsFontColorHover};` : 'color: #1e90ff;'}
      ${tabsBackgroundColorHover ? `background: ${tabsBackgroundColorHover};` : ''}
    }
    `;

    let tabsFontSizeMobile = options["tabs-font-size-mobile"] || "15";

    let tabsItemPaddingMobile = "";
    if (options["tabs-padding-style-mobile"] == "custom") {
      tabsItemPaddingMobile = options["tabs-padding-value-mobile"];
    }

    let tabsContentSpacingHorizontalMobile =
      options["tabs-content-spacing-horizontal-mobile"] || undefined;
    let tabsContentSpacingVerticalMobile =
      options["tabs-content-spacing-vertical-mobile"] || undefined;
    let tabsWidthMobile = options["tabs-width-mobile"] || undefined;

    mobileStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-tabs-element .cf-tabs-container .cf-tabs-list {
        ${tabsFontSizeMobile ? `font-size: ${tabsFontSizeMobile}px;` : ''}
      }
      `;
    ////////// END TABS THEME STYLES

    ////////// START ICON THEME STYLES
    let iconFontSize;
    if (options["icon-font-size"] && options["icon-font-size"] !== "theme") {
      iconFontSize = options["icon-font-size"];
    }

    let lineHeight;
    if (options["icon-font-line-height"]) {
      lineHeight = options["icon-font-line-height"];
    }

    let iconFontColor;
    if (options["icon-font-color"] && options["icon-font-color"] !== "theme") {
      iconFontColor = options["icon-font-color"];
    }

    let iconBorderRadius = "";
    if (options["icon-border-radius"] == "cf-not-rounded") {
      iconBorderRadius = "0px";
    }
    if (options["icon-border-radius"] == "cf-slightly-rounded") {
      iconBorderRadius = "4px";
    }
    if (options["icon-border-radius"] == "cf-fully-rounded") {
      iconBorderRadius = "100px";
    }
    if (options["icon-border-radius"] == "custom") {
      iconBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          iconBorderRadius += `${
            _.isNil(options["icon-border-radius-" + side]) == false
              ? options["icon-border-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let iconBoxShadow;
    let iconBoxShadowHover;

    if (options["icon-border-shadow"] == "None") {
      iconBoxShadow = "none";
    }

    if (options["icon-border-shadow"] == "soft") {
      iconBoxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["icon-border-shadow"] == "hard") {
      iconBoxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["icon-border-shadow"] == "custom") {
      iconBoxShadow = "";
      iconBoxShadow +=
        (options["icon-border-shadow-horizontal-distance"]
          ? `${options["icon-border-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      iconBoxShadow +=
        (options["icon-border-shadow-vertical-distance"]
          ? `${options["icon-border-shadow-vertical-distance"]}px`
          : "0px") + " ";

      iconBoxShadow +=
        (options["icon-border-shadow-blur-radius"]
          ? `${options["icon-border-shadow-blur-radius"]}px`
          : "0px") + " ";

      iconBoxShadow +=
        (options["icon-border-shadow-spread-radius"]
          ? `${options["icon-border-shadow-spread-radius"]}px`
          : "0px") + " ";

      iconBoxShadowHover =
        iconBoxShadow +
        (options["icon-hover-shadow-color"] ||
          options["icon-border-hover-shadow-color"] ||
          options["icon-border-shadow-color"] ||
          "rgba(0,0,0, 0.35)") +
        " ";

      iconBoxShadow +=
        (options["icon-border-shadow-color"]
          ? options["icon-border-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";

      iconBoxShadow +=
        options["icon-border-shadow-inset"] == "true" ? "inset" : "";
      iconBoxShadowHover +=
        options["icon-border-shadow-inset"] == "true" ? "inset" : "";
    }

    let iconMaxWidth;
    if (
      options["icon-max-width-style"] == "custom" &&
      options["icon-max-width-value"]
    ) {
      iconMaxWidth = `${options["icon-max-width-value"]}px !important;`;
    } else if (options["icon-max-width-style"] == "full") {
      iconMaxWidth = "100% !important;";
    }

    desktopStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-icon-element {
      ${lineHeight ? `line-height: ${lineHeight}px;` : ''}
      ${iconFontColor ? `color: ${iconFontColor};` : ''}
      ${iconMaxWidth ? `max-width: ${iconMaxWidth};` : ''}
      ${options["icon-border-style"] ? 'border-style: ' + options["icon-border-style"] + ' !important;' : ''}
      ${options["icon-border-style"] !== "" && _.isNil(options["icon-border-width"]) == false ? 'border-width: ' + options["icon-border-width"] + 'px !important;' : ''}
      ${options["icon-border-style"] !== "" && _.isNil(options["icon-border-width-left"]) == false ? 'border-left-width: ' + options["icon-border-width-left"] + 'px !important;' : _.isNil(options["icon-border-width"]) == false ? 'border-left-width: ' + options["icon-border-width"] + 'px !important;' : ''}
      ${options["icon-border-style"] !== "" && _.isNil(options["icon-border-width-right"]) == false ? 'border-right-width: ' + options["icon-border-width-right"] + 'px !important;' : _.isNil(options["icon-border-width"]) == false ? 'border-right-width: ' + options["icon-border-width"] + 'px !important;' : ''}
      ${options["icon-border-style"] !== "" && _.isNil(options["icon-border-width-top"]) == false ? 'border-top-width: ' + options["icon-border-width-top"] + 'px !important;' : _.isNil(options["icon-border-width"]) == false ? 'border-top-width: ' + options["icon-border-width"] + 'px !important;' : ''}
      ${options["icon-border-style"] !== "" && _.isNil(options["icon-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["icon-border-width-bottom"] + 'px !important;' : _.isNil(options["icon-border-width"]) == false ? 'border-bottom-width: ' + options["icon-border-width"] + 'px !important;' : ''}
      ${options["icon-border-style"] !== "" && options["icon-border-color"] ? 'border-color: ' + options["icon-border-color"] + ' !important;' : options["icon-border-color"] ? 'border-color: ' + options["icon-border-color"] + ' !important;' : ''}
      ${iconBorderRadius ? 'border-radius: ' + iconBorderRadius + ' !important;' : ''}
      ${iconBoxShadow ? 'box-shadow: ' + iconBoxShadow + ' !important;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-icon-element .svg-inline--fa {
      ${iconFontSize ? `font-size: ${iconFontSize}px;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-icon-element:hover {
      ${options["icon-hover-border-color"] || options["icon-border-hover-border-color"] ? 'border-color: ' + (options["icon-hover-border-color"] || options["icon-border-hover-border-color"]) + ' !important;' : options["icon-border-color"] ? 'border-color: ' +  options["icon-border-color"] + ' !important;' : ''}
      ${iconBoxShadowHover ? 'box-shadow: ' + iconBoxShadowHover + ' !important;' : ''}
    }`;

    let iconFontSizeMobile;
    if (
      options["icon-font-size-mobile"] &&
      options["icon-font-size-mobile"] !== "theme"
    ) {
      iconFontSizeMobile = options["icon-font-size-mobile"];
    }

    let lineHeightMobile;
    if (options["icon-font-line-height-mobile"]) {
      lineHeightMobile = options["icon-font-line-height-mobile"];
    }

    let iconFontColorMobile;
    if (
      options["icon-font-color-mobile"] &&
      options["icon-font-color-mobile"] !== "theme"
    ) {
      iconFontColorMobile = options["icon-font-color-mobile"];
    }

    let maxWidthMobile;
    if (
      options["icon-max-width-style-mobile"] == "custom" &&
      options["icon-max-width-value-mobile"]
    ) {
      maxWidthMobile = `${options["icon-max-width-value-mobile"]}px !important;`;
    } else if (options["icon-max-width-style-mobile"] == "full") {
      maxWidthMobile = "100% !important;";
    }

    mobileStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-icon-element {
      ${lineHeightMobile ? `line-height: ${lineHeightMobile}px;` : ''}
      ${iconFontColorMobile ? `color: ${iconFontColorMobile};` : ''}
      ${maxWidthMobile ? `max-width: ${maxWidthMobile};` : ''}
    }

    #cta_${cta.id} .cf-element .cf-icon-element .svg-inline--fa {
      ${iconFontSizeMobile ? `font-size: ${iconFontSizeMobile}px;` : ''}
    }`;

    //////// END ICON THEME STYLES

    ////////// START LIST THEME STYLES

    let listContentFontFamily;
    if (options["list-content-font-family"]) {
      listContentFontFamily = options["list-content-font-family"];
    }

    let listContentFontWeight;
    if (options["list-content-font-weight"]) {
      listContentFontWeight = options["list-content-font-weight"];
    }

    let listFontSize;
    if (options["list-content-font-size"]) {
      listFontSize = options["list-content-font-size"];
    }

    let listContentFontColor;
    if (options["list-content-font-color"]) {
      listContentFontColor = options["list-content-font-color"];
    }

    let listContentTextShadow;
    if (options["list-content-box-shadow"] == "soft") {
      listContentTextShadow = "0 3px 5px rgb(179 179 179 / 78%)";
    }
    if (options["list-content-box-shadow"] == "hard") {
      listContentTextShadow = "-3px 3px 0 rgb(0 0 0 / 10%)";
    }
    if (options["list-content-box-shadow"] == "custom") {
      listContentTextShadow = "";
      listContentTextShadow +=
        (options["list-content-box-shadow-horizontal-distance"]
          ? `${options["list-content-box-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      listContentTextShadow +=
        (options["list-content-box-shadow-vertical-distance"]
          ? `${options["list-content-box-shadow-vertical-distance"]}px`
          : "0px") + " ";

      listContentTextShadow +=
        (options["list-content-box-shadow-blur-radius"]
          ? `${options["list-content-box-shadow-blur-radius"]}px`
          : "0px") + " ";

      listContentTextShadow +=
        (options["list-content-box-shadow-color"]
          ? options["list-content-box-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";
    }

    let listVisualTypeFontSize;
    if (options["list-visual-type-font-size"]) {
      listVisualTypeFontSize = options["list-visual-type-font-size"];
    }

    let listVisualTypeFontColor;
    if (options["list-visual-type-font-color"]) {
      listVisualTypeFontColor = options["list-visual-type-font-color"];
    }

    const listVisualTypeAlignment = {
      top: "flex-start",
      center: "center",
      bottom: "flex-end",
    }[options["list-visual-type-alignment"]];

    let borderRadius = "";
    if (options["list-border-radius"] == "cf-not-rounded") {
      borderRadius = "0px";
    }
    if (options["list-border-radius"] == "cf-slightly-rounded") {
      borderRadius = "4px";
    }
    if (options["list-border-radius"] == "cf-fully-rounded") {
      borderRadius = "100px";
    }
    if (options["list-border-radius"] == "custom") {
      borderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          borderRadius += `${
            _.isNil(options["list-border-radius-" + side]) == false
              ? options["list-border-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let boxShadow;

    if (options["list-container-shadow"] == "None") {
      boxShadow = "none";
    }

    if (options["list-container-shadow"] == "soft") {
      boxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["list-container-shadow"] == "hard") {
      boxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["list-container-shadow"] == "custom") {
      boxShadow = "";
      boxShadow +=
        (options["list-container-shadow-horizontal-distance"]
          ? `${options["list-container-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (options["list-container-shadow-vertical-distance"]
          ? `${options["list-container-shadow-vertical-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (options["list-container-shadow-blur-radius"]
          ? `${options["list-container-shadow-blur-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (options["list-container-shadow-spread-radius"]
          ? `${options["list-container-shadow-spread-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (options["list-container-shadow-color"]
          ? options["list-container-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";

      boxShadow +=
        options["list-container-shadow-inset"] == "true" ? "inset" : "";
    }

    let listBackgroundColor;
    if (options["list-background"]) {
      listBackgroundColor = options["list-background"];
    }

    desktopStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-list-element-item {
      ${listVisualTypeAlignment ? `align-items: ${listVisualTypeAlignment} !important;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-list-element-item .cf-content,
    #cta_${cta.id} .cf-element .cf-list-element-item .cf-content div,
    #cta_${cta.id} .cf-element .cf-list-element-item .cf-content p,
    #cta_${cta.id} .cf-element .cf-list-element-item .cf-content h1,
    #cta_${cta.id} .cf-element .cf-list-element-item .cf-content h2,
    #cta_${cta.id} .cf-element .cf-list-element-item .cf-content h3,
    #cta_${cta.id} .cf-element .cf-list-element-item .cf-content h4,
    #cta_${cta.id} .cf-element .cf-list-element-item .cf-content h5,
    #cta_${cta.id} .cf-element .cf-list-element-item .cf-content li {
      ${listFontSize ? `font-size: ${listFontSize}px !important;` : ""}
      ${listContentFontFamily ? `font-family: ${listContentFontFamily}, sans-serif !important;` : ''}
      ${listContentFontWeight ? `font-weight: ${listContentFontWeight} !important;` : ''}
      ${listContentFontColor ? `color: ${listContentFontColor} !important;` : ''}
      ${listContentTextShadow ? `text-shadow: ${listContentTextShadow} !important;` : ''}
    }

    /* Enable bullet points for nested lists within list items */
    #cta_${cta.id} .cf-element .cf-list-element-item .cf-content ul {
      list-style-type: disc !important;
      padding-left: 20px !important;
    }

    #cta_${cta.id} .cf-element .cf-list-element-item .cf-content ul li {
      list-style-type: disc !important;
      display: list-item !important;
    }

    #cta_${cta.id} .cf-element .cf-list-element-item .cf-content ul li::marker {
      color: ${listContentFontColor || 'inherit'} !important;
    }

    /* Support for ordered lists */
    #cta_${cta.id} .cf-element .cf-list-element-item .cf-content ol {
      list-style-type: decimal !important;
      padding-left: 20px !important;
    }

    #cta_${cta.id} .cf-element .cf-list-element-item .cf-content ol li {
      list-style-type: decimal !important;
      display: list-item !important;
    }

    #cta_${cta.id} .cf-element .cf-list-element-item .cf-content ol li::marker {
      color: ${listContentFontColor || 'inherit'} !important;
    }

    #cta_${cta.id} .cf-element .cf-list-element-item .cf-visual-type {
      ${listVisualTypeFontSize ? `font-size: ${listVisualTypeFontSize}px !important;` : ''}
      ${listVisualTypeFontColor ? `color: ${listVisualTypeFontColor} !important;` : ''}
    }


    #cta_${cta.id} .cf-element .cf-list-element ul {
      ${borderRadius ? 'border-radius: ' + borderRadius + ' !important;' : ''}
      ${options["list-border-style"] ? 'border-style: ' + options["list-border-style"] + ' !important;' : ''}
      ${options["list-border-style"] !== "" && _.isNil(options["list-border-width"]) == false ? 'border-width: ' + options["list-border-width"] + 'px !important;' : ''}
      ${options["list-border-style"] !== "" && _.isNil(options["list-border-width-left"]) == false ? 'border-left-width: ' + options["list-border-width-left"] + 'px !important;' : _.isNil(options["list-border-width"]) == false ? 'border-left-width: ' + options["list-border-width"] + 'px !important;' : ''}
      ${options["list-border-style"] !== "" && _.isNil(options["list-border-width-right"]) == false ? 'border-right-width: ' + options["list-border-width-right"] + 'px !important;' : _.isNil(options["list-border-width"]) == false ? 'border-right-width: ' + options["list-border-width"] + 'px !important;' : ''}
      ${options["list-border-style"] !== "" && _.isNil(options["list-border-width-top"]) == false ? 'border-top-width: ' + options["list-border-width-top"] + 'px !important;' : _.isNil(options["list-border-width"]) == false ? 'border-top-width: ' + options["list-border-width"] + 'px !important;' : ''}
      ${options["list-border-style"] !== "" && _.isNil(options["list-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["list-border-width-bottom"] + 'px !important;' : _.isNil(options["list-border-width"]) == false ? 'border-bottom-width: ' + options["list-border-width"] + 'px !important;' : ''}
      ${options["list-border-style"] !== "" && options["list-border-color"] ? 'border-color: ' + options["list-border-color"] + ' !important;' : 'border-color: #000;'}
      ${borderRadius ? 'border-radius: ' + borderRadius + ' !important;' : ''}
      ${boxShadow ? 'box-shadow: ' + boxShadow + ' !important;' : ''}
      ${listBackgroundColor ? `background: ${listBackgroundColor} !important;` : ''}
    }

    #cta_${cta.id} .cf-element .cf-list-element .cf-items-divider:not(:last-child) {
      ${options["list-items-divider-style"] ? `border-style: ${options["list-items-divider-style"]};` : ''}
      ${options["list-items-divider-style"] !== "" && _.isNil(options["list-items-divider-border-width"]) == false ? `border-bottom-width: ${options["list-items-divider-border-width"]}px;`: ''}
      ${options["list-items-divider-style"] !== "" && options["list-items-divider-color"] ? `border-color: ${options["list-items-divider-color"]} !important;` : options["list-border-color"] ? `border-color: ${options["list-border-color"]};` : ''}
      ${["solid", "dashed", "dotted"].includes(options["list-items-divider-style"]) ? "margin-top: 10px; margin-bottom: 10px;" : ""}
    }
    `;

    let listFontSizeMobile;
    if (options["list-content-font-size"]) {
      listFontSizeMobile = options["list-content-font-size-mobile"];
    }
    let listVisualTypeFontSizeMobile;
    if (options["list-visual-type-font-size-mobile"]) {
      listVisualTypeFontSizeMobile =
        options["list-visual-type-font-size-mobile"];
    }

    mobileStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-list-element-item .cf-content,
      #cta_${cta.id} .cf-element .cf-list-element-item .cf-content div,
      #cta_${cta.id} .cf-element .cf-list-element-item .cf-content p,
      #cta_${cta.id} .cf-element .cf-list-element-item .cf-content h1,
      #cta_${cta.id} .cf-element .cf-list-element-item .cf-content h2,
      #cta_${cta.id} .cf-element .cf-list-element-item .cf-content h3,
      #cta_${cta.id} .cf-element .cf-list-element-item .cf-content h4 {
      ${listFontSizeMobile ? `font-size: ${listFontSizeMobile}px !important;` : ""}
    }

    #cta_${cta.id} .cf-element .cf-list-element-item .cf-visual-type {
      ${listVisualTypeFontSizeMobile ? `font-size: ${listVisualTypeFontSizeMobile}px !important;` : ''}
    }
    `;

    //////// END LIST THEME STYLES

    let timerPadding;
    if (options["timer-padding"]) {
      const paddingValue = parseInt(options["timer-padding"]);
      timerPadding = `${paddingValue / 2}px ${paddingValue}px`;
    }

    let timerPaddingMobile;
    if (options["timer-padding-mobile"]) {
      const paddingValueMobile = parseInt(options["timer-padding-mobile"]);
      timerPaddingMobile = `${
        paddingValueMobile / 2
      }px ${paddingValueMobile}px`;
    }

    let timerBorderRadius = "";
    if (options["timer-radius"] == "cf-not-rounded") {
      timerBorderRadius = "0px";
    }
    if (options["timer-radius"] == "cf-slightly-rounded") {
      timerBorderRadius = "4px";
    }
    if (options["timer-radius"] == "cf-fully-rounded") {
      timerBorderRadius = "100px";
    }
    if (options["timer-radius"] == "custom") {
      timerBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          timerBorderRadius += `${
            _.isNil(options["timer-radius-" + side]) == false
              ? options["timer-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let timerBoxShadow;

    if (options["timer-shadow"] == "None") {
      timerBoxShadow = "none";
    }

    if (options["timer-shadow"] == "soft") {
      timerBoxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["timer-shadow"] == "hard") {
      timerBoxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["timer-shadow"] == "custom") {
      timerBoxShadow = "";
      timerBoxShadow +=
        (options["timer-shadow-horizontal-distance"]
          ? `${options["timer-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      timerBoxShadow +=
        (options["timer-shadow-vertical-distance"]
          ? `${options["timer-shadow-vertical-distance"]}px`
          : "0px") + " ";

      timerBoxShadow +=
        (options["timer-shadow-blur-radius"]
          ? `${options["timer-shadow-blur-radius"]}px`
          : "0px") + " ";

      timerBoxShadow +=
        (options["timer-shadow-spread-radius"]
          ? `${options["timer-shadow-spread-radius"]}px`
          : "0px") + " ";

      timerBoxShadow +=
        (options["timer-shadow-color"]
          ? options["timer-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";
    }

    desktopStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-timer-card .cf-timer-unit-number {
  ${timerPadding ? 'padding: ' + timerPadding + ' !important;' : ''}
  ${options["timer-number-size"] ? 'font-size: ' + options["timer-number-size"] + 'px !important;' : ''}
  ${options["timer-number-font"] ? 'font-family: ' + options["timer-number-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
  ${options['timer-number-font-weight'] ? 'font-weight: ' + options['timer-number-font-weight'] + ' !important;' : ''}
  ${options["timer-background-color"] ? 'background: ' + options["timer-background-color"] + ' !important;' : ''}
  ${options["timer-number-color"] ? 'color: ' + options["timer-number-color"] + ' !important;' : ''}
  ${options["timer-border-style"] ? 'border-style: ' + options["timer-border-style"] + '!important;' : ''}
  ${_.isNil(options["timer-border-width"]) == false ? 'border-width: ' + options["timer-border-width"] + 'px !important;' : ''}
  ${_.isNil(options["timer-border-width-left"]) == false ? 'border-left-width: ' + options["timer-border-width-left"] + 'px !important;' : ''}
  ${_.isNil(options["timer-border-width-right"]) == false ? 'border-right-width: ' + options["timer-border-width-right"] + 'px !important;' : ''}
  ${_.isNil(options["timer-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["timer-border-width-bottom"] + 'px !important;' : ''}
  ${_.isNil(options["timer-border-width-top"]) == false ? 'border-top-width: ' + options["timer-border-width-top"] + 'px !important;' : ''}
  ${options["timer-border-color"] ? 'border-color: ' + options["timer-border-color"] + ' !important;' : ''}
  ${timerBorderRadius ? 'border-radius: ' + timerBorderRadius + ' !important;' : ''}
  ${timerBoxShadow ? 'box-shadow: ' + timerBoxShadow + ' !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-timer-card .cf-timer-unit-text {
  ${options["timer-unit-size"] ? 'font-size: ' + options["timer-unit-size"] + 'px !important;' : ''}
  ${options["timer-unit-font"] ? 'font-family: ' + options["timer-unit-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
  ${options['timer-unit-font-weight'] ? 'font-weight: ' + options['timer-unit-font-weight'] + ' !important;' : ''}
  ${options["timer-unit-color"] ? 'color: ' + options["timer-unit-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-timer-inline .cf-timer-unit-number {
  ${options["timer-number-size"] ? 'font-size: ' + options["timer-number-size"] + 'px !important;' : ''}
  ${options["timer-number-font"] ? 'font-family: ' + options["timer-number-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
  ${options['timer-number-font-weight'] ? 'font-weight: ' + options['timer-number-font-weight'] + ' !important;' : ''}
  ${options["timer-number-color"] ? 'color: ' + options["timer-number-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-timer-inline .cf-timer-unit-text {
  ${options["timer-unit-size"] ? 'font-size: ' + options["timer-unit-size"] + 'px !important;' : ''}
  ${options["timer-unit-font"] ? 'font-family: ' + options["timer-unit-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
  ${options['timer-unit-font-weight'] ? 'font-weight: ' + options['timer-unit-font-weight'] + ' !important;' : ''}
  ${options["timer-unit-color"] ? 'color: ' + options["timer-unit-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-timer-message h1, 
#cta_${cta.id} .cf-element .cf-timer-message h2, 
#cta_${cta.id} .cf-element .cf-timer-message h3, 
#cta_${cta.id} .cf-element .cf-timer-message h4, 
#cta_${cta.id} .cf-element .cf-timer-message h5, 
#cta_${cta.id} .cf-element .cf-timer-message p, 
#cta_${cta.id} .cf-element .cf-timer-message span {
  ${options["timer-message-size"] ? 'font-size: ' + options["timer-message-size"] + 'px !important;' : ''}
  ${options["timer-message-font"] ? 'font-family: ' + options["timer-message-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
  ${options['timer-message-font-weight'] ? 'font-weight: ' + options['timer-message-font-weight'] + ' !important;' : ''}
  ${options["timer-message-color"] ? 'color: ' + options["timer-message-color"] + ' !important;' : ''}
}`;

    mobileStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element .cf-timer-card .cf-timer-unit-number, #cta_${cta.id} .cf-element .cf-timer-inline .cf-timer-unit-number {
  ${options["timer-number-size-mobile"] ? 'font-size: ' + options["timer-number-size-mobile"] + 'px !important;' : ''}
  ${timerPaddingMobile ? 'padding: ' + timerPaddingMobile + ' !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-timer-card .cf-timer-unit-text, #cta_${cta.id} .cf-element .cf-timer-inline .cf-timer-unit-text {
  ${options["timer-unit-size-mobile"] ? 'font-size: ' + options["timer-unit-size-mobile"] + 'px !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-timer-message h1, 
#cta_${cta.id} .cf-element .cf-timer-message h2, 
#cta_${cta.id} .cf-element .cf-timer-message h3, 
#cta_${cta.id} .cf-element .cf-timer-message h4, 
#cta_${cta.id} .cf-element .cf-timer-message h5, 
#cta_${cta.id} .cf-element .cf-timer-message p, 
#cta_${cta.id} .cf-element .cf-timer-message span {
  ${options["timer-message-size-mobile"] ? 'font-size: ' + options["timer-message-size-mobile"] + 'px !important;' : ''}
}`;

  ////////// START SHARED PRODUCT HERO/FEED THEME STYLES

  desktopStyles +=
    // prettier-ignore
    `#cta_${cta.id} .cf-element .cf-products-reviews-stars-inner svg {
      color: #EFAB40;
    }

    #cta_${cta.id} .cf-element .cf-products-list .cf-products-reviews-stars-inner svg {
      width: auto !important;
    }

    #cta_${cta.id} .cf-element .cf-products-reviews-stars-inner .svg-inline--fa {
      display: var(--fa-display, inline-block);
      height: 1em;
      overflow: visible;
      font-size: 14px;
    }

    #cta_${cta.id} .cf-center .cf-products-options-wrapper,
    #cta_${cta.id} .cf-center .cf-products-reviews {
      justify-content: center !important;
    }

    #cta_${cta.id} .cf-left .cf-products-options-wrapper,
    #cta_${cta.id} .cf-left .cf-products-reviews {
      justify-content: left !important;
    }

    #cta_${cta.id} .cf-right .cf-products-options-wrapper,
    #cta_${cta.id} .cf-right .cf-products-reviews {
      justify-content: right !important;
    }

    #cta_${cta.id} .cf-element .cf-products-reviews {
      display: flex;
      gap: 10px;
      align-items: center;
      font-family: "Inter", Helvetica, sans-serif;
      font-size: 11px;
    }

    #cta_${cta.id} .cf-element .cf-quantity-picker-label {
      font-family: "Inter", Helvetica, sans-serif;
    }

    #cta_${cta.id} .cf-element .cf-variant-picker-label {
      font-family: "Inter", Helvetica, sans-serif;
    }

    #cta_${cta.id} .cf-element .cf-products-options-wrapper {
      display: flex;
      gap: 15px;
      flex-wrap: wrap;
      overflow: hidden;
      margin: 0px 0px 5px 0px;
    }

    #cta_${cta.id} .cf-element .cf-products-subscription-label {
      font-family: "Inter", Helvetica, sans-serif;
    }

    #cta_${cta.id} .cf-element div.cf-products-subscription-dropdown-wrapper.cf-product-content-type > div > select,
    #cta_${cta.id} .cf-element .cf-products-subscription-dropdown-wrapper .cf-form-2.cf-form-theme-default select {
      appearance: auto;
      height: 44px;
      padding: 11px 0px 9px 10px;
      font-size: 15px !important;
      font-weight: normal !important;
      margin: 0px;
      margin-bottom: 10px;
    }

    #cta_${cta.id} .cf-element .cf-products-subscription-radio-wrapper p {
      font-size: 12px;
      display: flex;
      flex: 1;
      align-items: flex-start;
    }

    #cta_${cta.id} .cf-element .cf-product-content-type:empty {
      display:none !important;
    }

    #cta_${cta.id} .cf-element .cf-products-option-item--disabled {
      text-decoration: line-through !important;
      opacity: 0.4 !important;
    }

    #cta_${cta.id} .cf-element .cf-products-item-button--disabled {
      opacity: 0.4 !important;
    }

    #cta_${cta.id} .cf-element div.cf-products-subscription-dropdown-wrapper.cf-product-content-type > div > select,
    #cta_${cta.id} .cf-element .cf-products-subscription-radio-wrapper label {
      font-family: "Inter", Helvetica, sans-serif;
    }

    #cta_${cta.id} .cf-element .cf-products-subscription-radio-wrapper label {
      cursor: pointer;
    }

    #cta_${cta.id} .cf-element div.cf-products-subscription-dropdown-wrapper.cf-product-content-type > div > select {
      border-color: #000 !important;
      border-radius: 3px !important;
    }

    #cta_${cta.id} .cf-element .cf-products-subscription-radio-wrapper input[type="radio"] {
      margin: 5px 5px 5px 0px;
      appearance: none !important;
      width: 13px !important;
      height: 13px !important;
      border-radius: 50%;
      background-clip: content-box !important;
      background-color: var(--cf-products-subscription-radio-color, #D4DDEA) !important;
    }

    #cta_${cta.id} .cf-element .cf-products-subscription-radio-wrapper input[type="radio"]:checked {
      background-color: var(--cf-products-subscription-radio-selected-color, #003FFF) !important;
    }

    #cta_${cta.id} .cf-element .cf-products-option-item {
      text-align: center !important;
      text-transform: uppercase;
    }

    #cta_${cta.id} .cf-element div.cf-variant-picker-wrapper.cf-product-content-type > div > select,
    #cta_${cta.id} .cf-element .cf-products-option-item {
      border: 1px solid #000 !important;
      cursor: pointer;
      border-radius: 20px;
      padding: 6px 10px;
      font-family: "Inter", Helvetica, sans-serif;
      font-size: 12px;
    }

    #cta_${cta.id} .cf-element .cf-products-item--shopify .cf-products-item-info {
      padding: 0px;
    }

    #cta_${cta.id} .cf-element .cf-products-item--shopify .cf-products-list .cf-products-item-info {
      padding: 10px 30px;
    }

    #cta_${cta.id} .cf-element .cf-increment-quantity-picker .cf-decrement,
    #cta_${cta.id} .cf-element .cf-increment-quantity-picker .cf-products-quantity,
    #cta_${cta.id} .cf-element .cf-increment-quantity-picker .cf-increment {
      font-family: 'Inter', Helvetica, sans-serif !important;
    }

    #cta_${cta.id} .cf-element .cf-product-content-type {
      margin-bottom: 10px;
    }

    #cta_${cta.id} .cf-element .cf-products-item-image-wrapper {
      position: relative;
    }

    #cta_${cta.id} .cf-element .cf-product-item-image-block {
      max-width: 100% !important;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    #cta_${cta.id} .cf-element .cf-product__main-image {
      max-width: 500px;
      max-height: 600px;
      object-fit: cover;
      cursor: pointer;
    }

    #cta_${cta.id} .cf-element .cf-product__slider-wrap {
      max-width: 500px;
      margin-top: 5px;
      display: flex;
      align-items: center;
    }

    #cta_${cta.id} .cf-element .cf-product__slider {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;
    }

    #cta_${cta.id} .cf-element .cf-product__image {
      object-fit: cover;
      cursor: pointer;
      opacity: 0.5;
      margin: 0.25rem;
    }

    #cta_${cta.id} .cf-element .cf-product__image:first-child {
      margin-left: 0 !important;
    }

    #cta_${cta.id} .cf-element .cf-product__image:last-child {
      margin-right: 0 !important;
    }

    #cta_${cta.id} .cf-element .cf-product__image:hover {
      opacity: 1;
    }

    #cta_${cta.id} .cf-element .cf-product__image--active {
      opacity: 1;
    }

    #cta_${cta.id} .cf-element .cf-products-item-image-wrapper .cf-products-item-badge {
      position: absolute;
      z-index: 1;
      color: #fff;
      background-color: #003FFF;
      padding: 5px;
      font-size: 10px;
      margin: 7px;
    }

    #cta_${cta.id} .cf-products-item-title p {
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
    }

    #cta_${cta.id} .cf-products-item-remove-from-cart {
      display: inline-flex;
    }

    #cta_${cta.id} .cf-products-item-remove-from-cart p {
      color: #6b7280 !important;
      margin: 5px 0px;
      cursor: pointer;
    }

    #cta_${cta.id} .cf-products-item-description,
    #cta_${cta.id} .cf-products-empty-message p {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }

    #cta_${cta.id} .cf-element .cf-shopify-product-placeholder-svg {
      visibility: visible;
      content: url("data:image/svg+xml,%3Csvg viewBox='0 0 2192 2500' fill='red' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='clip0_2_2'%3E%3Cpath d='M1344.77 989.806C1344.24 986.017 1340.92 983.92 1338.18 983.689C1335.44 983.46 1277.48 979.165 1277.48 979.165C1277.48 979.165 1237.23 939.206 1232.81 934.783C1228.39 930.363 1219.76 931.708 1216.41 932.694C1215.92 932.839 1207.61 935.401 1193.88 939.65C1180.44 900.961 1156.71 865.407 1114.96 865.407C1113.81 865.407 1112.62 865.454 1111.43 865.521C1099.56 849.821 1084.85 843 1072.15 843C974.898 843 928.437 964.562 913.869 1026.34C876.08 1038.04 849.235 1046.37 845.806 1047.45C824.712 1054.06 824.045 1054.73 821.276 1074.6C819.191 1089.65 764 1516.43 764 1516.43L1194.06 1597L1427.08 1546.59C1427.08 1546.59 1345.28 993.596 1344.77 989.806H1344.77ZM1170.11 947.001L1133.72 958.263C1133.74 955.698 1133.75 953.175 1133.75 950.416C1133.75 926.371 1130.41 907.011 1125.06 891.664C1146.57 894.363 1160.89 918.836 1170.11 947.001ZM1098.37 896.432C1104.35 911.416 1108.24 932.92 1108.24 961.938C1108.24 963.423 1108.23 964.78 1108.21 966.153C1084.55 973.483 1058.83 981.441 1033.06 989.425C1047.53 933.579 1074.66 906.606 1098.37 896.432V896.432ZM1069.48 869.083C1073.68 869.083 1077.9 870.508 1081.95 873.293C1050.78 887.957 1017.38 924.892 1003.27 998.649L943.861 1017.05C960.385 960.788 999.623 869.083 1069.48 869.083H1069.48Z' fill='%238F8F8F' /%3E%3Cpath d='M1338.28 983.843C1335.54 983.615 1277.65 979.32 1277.65 979.32C1277.65 979.32 1237.44 939.372 1233.03 934.95C1231.37 933.305 1229.15 932.462 1226.82 932.098L1194.34 1597L1427.08 1546.61C1427.08 1546.61 1345.37 993.748 1344.86 989.96C1344.33 986.171 1341.02 984.074 1338.28 983.843' fill='%23555555' /%3E%3Cpath d='M1115.54 1112.46L1086.76 1197.91C1086.76 1197.91 1061.54 1184.48 1030.62 1184.48C985.295 1184.48 983.014 1212.87 983.014 1220.02C983.014 1259.05 1084.96 1274 1084.96 1365.42C1084.96 1437.34 1039.25 1483.66 977.613 1483.66C903.65 1483.66 865.826 1437.72 865.826 1437.72L885.63 1372.42C885.63 1372.42 924.51 1405.73 957.317 1405.73C978.754 1405.73 987.474 1388.89 987.474 1376.58C987.474 1325.67 903.838 1323.4 903.838 1239.75C903.838 1169.34 954.477 1101.2 1056.7 1101.2C1096.09 1101.2 1115.54 1112.46 1115.54 1112.46' fill='white' /%3E%3Cpath d='M811.975 1848V1775.27H840.669C846.185 1775.27 850.884 1776.33 854.767 1778.43C858.649 1780.52 861.608 1783.42 863.644 1787.13C865.704 1790.83 866.734 1795.09 866.734 1799.92C866.734 1804.75 865.692 1809.01 863.609 1812.7C861.526 1816.39 858.507 1819.27 854.553 1821.33C850.624 1823.39 845.865 1824.42 840.278 1824.42H821.99V1812.1H837.792C840.751 1812.1 843.19 1811.59 845.107 1810.57C847.049 1809.53 848.493 1808.1 849.44 1806.27C850.41 1804.43 850.896 1802.31 850.896 1799.92C850.896 1797.5 850.41 1795.4 849.44 1793.6C848.493 1791.77 847.049 1790.37 845.107 1789.37C843.166 1788.35 840.704 1787.84 837.721 1787.84H827.352V1848H811.975ZM891.565 1775.27V1848H876.437V1775.27H891.565ZM919.237 1849.03C915.757 1849.03 912.656 1848.43 909.933 1847.22C907.211 1845.99 905.057 1844.18 903.47 1841.79C901.908 1839.37 901.127 1836.36 901.127 1832.77C901.127 1829.74 901.683 1827.19 902.796 1825.13C903.908 1823.07 905.423 1821.41 907.341 1820.16C909.259 1818.9 911.437 1817.96 913.875 1817.32C916.337 1816.68 918.918 1816.23 921.617 1815.97C924.789 1815.64 927.346 1815.33 929.287 1815.05C931.228 1814.74 932.637 1814.29 933.513 1813.7C934.389 1813.1 934.827 1812.23 934.827 1811.07V1810.86C934.827 1808.61 934.117 1806.87 932.696 1805.63C931.299 1804.4 929.311 1803.79 926.73 1803.79C924.008 1803.79 921.842 1804.39 920.232 1805.6C918.622 1806.78 917.557 1808.27 917.036 1810.07L903.044 1808.94C903.754 1805.62 905.151 1802.76 907.235 1800.34C909.318 1797.91 912.005 1796.04 915.296 1794.73C918.61 1793.41 922.445 1792.74 926.801 1792.74C929.832 1792.74 932.732 1793.1 935.502 1793.81C938.295 1794.52 940.769 1795.62 942.923 1797.11C945.102 1798.6 946.818 1800.52 948.073 1802.87C949.327 1805.19 949.955 1807.97 949.955 1811.21V1848H935.608V1840.44H935.182C934.306 1842.14 933.134 1843.64 931.666 1844.95C930.199 1846.22 928.435 1847.23 926.375 1847.96C924.316 1848.67 921.936 1849.03 919.237 1849.03ZM923.57 1838.59C925.795 1838.59 927.76 1838.15 929.465 1837.28C931.169 1836.38 932.507 1835.17 933.477 1833.65C934.448 1832.14 934.933 1830.42 934.933 1828.5V1822.72C934.46 1823.02 933.809 1823.31 932.98 1823.57C932.175 1823.8 931.264 1824.03 930.246 1824.24C929.228 1824.43 928.21 1824.61 927.192 1824.78C926.174 1824.92 925.251 1825.05 924.422 1825.17C922.646 1825.43 921.096 1825.84 919.77 1826.41C918.444 1826.98 917.414 1827.75 916.681 1828.72C915.947 1829.66 915.58 1830.85 915.58 1832.27C915.58 1834.33 916.325 1835.9 917.817 1836.99C919.332 1838.06 921.25 1838.59 923.57 1838.59ZM986.336 1849.07C980.749 1849.07 975.943 1847.88 971.919 1845.51C967.918 1843.12 964.84 1839.81 962.686 1835.57C960.555 1831.33 959.49 1826.46 959.49 1820.94C959.49 1815.35 960.567 1810.45 962.721 1806.24C964.899 1802 967.989 1798.7 971.99 1796.33C975.99 1793.94 980.749 1792.74 986.265 1792.74C991.024 1792.74 995.19 1793.61 998.765 1795.34C1002.34 1797.06 1005.17 1799.49 1007.25 1802.62C1009.34 1805.74 1010.48 1809.41 1010.7 1813.62H996.421C996.019 1810.9 994.954 1808.71 993.225 1807.06C991.521 1805.37 989.284 1804.53 986.514 1804.53C984.17 1804.53 982.122 1805.17 980.37 1806.45C978.642 1807.71 977.293 1809.54 976.322 1811.96C975.351 1814.37 974.866 1817.29 974.866 1820.73C974.866 1824.21 975.339 1827.17 976.286 1829.61C977.257 1832.04 978.618 1833.9 980.37 1835.18C982.122 1836.46 984.17 1837.1 986.514 1837.1C988.242 1837.1 989.793 1836.74 991.166 1836.03C992.562 1835.32 993.711 1834.29 994.61 1832.94C995.534 1831.57 996.137 1829.92 996.421 1828.01H1010.7C1010.46 1832.17 1009.32 1835.84 1007.29 1839.02C1005.28 1842.16 1002.49 1844.63 998.943 1846.4C995.392 1848.18 991.189 1849.07 986.336 1849.07ZM1045.24 1849.07C1039.63 1849.07 1034.8 1847.93 1030.75 1845.66C1026.73 1843.36 1023.63 1840.12 1021.45 1835.93C1019.27 1831.71 1018.18 1826.73 1018.18 1820.98C1018.18 1815.37 1019.27 1810.44 1021.45 1806.2C1023.63 1801.97 1026.69 1798.66 1030.65 1796.3C1034.62 1793.93 1039.29 1792.74 1044.64 1792.74C1048.24 1792.74 1051.59 1793.32 1054.69 1794.48C1057.81 1795.62 1060.53 1797.34 1062.85 1799.63C1065.2 1801.93 1067.02 1804.82 1068.32 1808.3C1069.63 1811.75 1070.28 1815.8 1070.28 1820.44V1824.6H1024.22V1815.22H1056.04C1056.04 1813.04 1055.56 1811.12 1054.62 1809.43C1053.67 1807.75 1052.35 1806.44 1050.67 1805.49C1049.02 1804.52 1047.09 1804.04 1044.89 1804.04C1042.59 1804.04 1040.55 1804.57 1038.78 1805.63C1037.03 1806.68 1035.65 1808.09 1034.66 1809.86C1033.66 1811.61 1033.15 1813.57 1033.13 1815.72V1824.63C1033.13 1827.33 1033.63 1829.66 1034.62 1831.63C1035.64 1833.59 1037.07 1835.11 1038.92 1836.17C1040.77 1837.24 1042.96 1837.77 1045.49 1837.77C1047.17 1837.77 1048.71 1837.54 1050.11 1837.06C1051.5 1836.59 1052.7 1835.88 1053.69 1834.93C1054.69 1833.98 1055.44 1832.82 1055.97 1831.45L1069.96 1832.38C1069.25 1835.74 1067.79 1838.67 1065.59 1841.18C1063.41 1843.67 1060.59 1845.61 1057.14 1847.01C1053.7 1848.38 1049.74 1849.07 1045.24 1849.07ZM1095.28 1816.47V1848H1080.15V1775.27H1094.85V1803.08H1095.49C1096.72 1799.86 1098.71 1797.34 1101.46 1795.51C1104.2 1793.67 1107.65 1792.74 1111.79 1792.74C1115.58 1792.74 1118.88 1793.57 1121.7 1795.23C1124.54 1796.86 1126.74 1799.22 1128.3 1802.3C1129.89 1805.35 1130.67 1809.01 1130.65 1813.27V1848H1115.52V1815.97C1115.54 1812.61 1114.69 1809.99 1112.96 1808.12C1111.26 1806.25 1108.87 1805.32 1105.79 1805.32C1103.73 1805.32 1101.9 1805.75 1100.32 1806.63C1098.76 1807.51 1097.53 1808.78 1096.63 1810.46C1095.75 1812.12 1095.3 1814.12 1095.28 1816.47ZM1167.2 1849.07C1161.68 1849.07 1156.91 1847.89 1152.88 1845.55C1148.88 1843.18 1145.79 1839.89 1143.62 1835.68C1141.44 1831.44 1140.35 1826.53 1140.35 1820.94C1140.35 1815.31 1141.44 1810.38 1143.62 1806.17C1145.79 1801.93 1148.88 1798.64 1152.88 1796.3C1156.91 1793.93 1161.68 1792.74 1167.2 1792.74C1172.71 1792.74 1177.47 1793.93 1181.47 1796.3C1185.5 1798.64 1188.6 1801.93 1190.78 1806.17C1192.95 1810.38 1194.04 1815.31 1194.04 1820.94C1194.04 1826.53 1192.95 1831.44 1190.78 1835.68C1188.6 1839.89 1185.5 1843.18 1181.47 1845.55C1177.47 1847.89 1172.71 1849.07 1167.2 1849.07ZM1167.27 1837.35C1169.78 1837.35 1171.87 1836.64 1173.55 1835.22C1175.23 1833.77 1176.5 1831.81 1177.35 1829.32C1178.23 1826.84 1178.67 1824.01 1178.67 1820.83C1178.67 1817.66 1178.23 1814.83 1177.35 1812.35C1176.5 1809.86 1175.23 1807.9 1173.55 1806.45C1171.87 1805.01 1169.78 1804.29 1167.27 1804.29C1164.73 1804.29 1162.6 1805.01 1160.87 1806.45C1159.17 1807.9 1157.88 1809.86 1157 1812.35C1156.15 1814.83 1155.73 1817.66 1155.73 1820.83C1155.73 1824.01 1156.15 1826.84 1157 1829.32C1157.88 1831.81 1159.17 1833.77 1160.87 1835.22C1162.6 1836.64 1164.73 1837.35 1167.27 1837.35ZM1219.01 1775.27V1848H1203.88V1775.27H1219.01ZM1251.22 1848.89C1247.08 1848.89 1243.33 1847.82 1239.97 1845.69C1236.63 1843.54 1233.98 1840.38 1232.01 1836.21C1230.07 1832.02 1229.1 1826.88 1229.1 1820.8C1229.1 1814.55 1230.11 1809.35 1232.12 1805.21C1234.13 1801.04 1236.81 1797.93 1240.14 1795.87C1243.51 1793.79 1247.19 1792.74 1251.19 1792.74C1254.24 1792.74 1256.79 1793.27 1258.82 1794.31C1260.88 1795.32 1262.54 1796.6 1263.8 1798.14C1265.07 1799.66 1266.04 1801.15 1266.71 1802.62H1267.17V1775.27H1282.26V1848H1267.35V1839.26H1266.71C1266 1840.78 1264.99 1842.28 1263.69 1843.77C1262.41 1845.24 1260.74 1846.46 1258.68 1847.43C1256.65 1848.4 1254.16 1848.89 1251.22 1848.89ZM1256.02 1836.85C1258.46 1836.85 1260.52 1836.19 1262.2 1834.86C1263.9 1833.51 1265.2 1831.63 1266.1 1829.21C1267.03 1826.8 1267.49 1823.97 1267.49 1820.73C1267.49 1817.48 1267.04 1814.67 1266.14 1812.28C1265.24 1809.88 1263.94 1808.04 1262.23 1806.74C1260.53 1805.43 1258.46 1804.78 1256.02 1804.78C1253.53 1804.78 1251.44 1805.46 1249.73 1806.81C1248.03 1808.16 1246.74 1810.03 1245.86 1812.42C1244.99 1814.81 1244.55 1817.58 1244.55 1820.73C1244.55 1823.9 1244.99 1826.71 1245.86 1829.14C1246.76 1831.56 1248.05 1833.45 1249.73 1834.83C1251.44 1836.17 1253.53 1836.85 1256.02 1836.85ZM1319.56 1849.07C1313.95 1849.07 1309.12 1847.93 1305.07 1845.66C1301.04 1843.36 1297.94 1840.12 1295.76 1835.93C1293.59 1831.71 1292.5 1826.73 1292.5 1820.98C1292.5 1815.37 1293.59 1810.44 1295.76 1806.2C1297.94 1801.97 1301.01 1798.66 1304.96 1796.3C1308.94 1793.93 1313.6 1792.74 1318.95 1792.74C1322.55 1792.74 1325.9 1793.32 1329 1794.48C1332.13 1795.62 1334.85 1797.34 1337.17 1799.63C1339.51 1801.93 1341.34 1804.82 1342.64 1808.3C1343.94 1811.75 1344.59 1815.8 1344.59 1820.44V1824.6H1298.53V1815.22H1330.35C1330.35 1813.04 1329.88 1811.12 1328.93 1809.43C1327.99 1807.75 1326.67 1806.44 1324.99 1805.49C1323.33 1804.52 1321.4 1804.04 1319.2 1804.04C1316.91 1804.04 1314.87 1804.57 1313.09 1805.63C1311.34 1806.68 1309.97 1808.09 1308.97 1809.86C1307.98 1811.61 1307.47 1813.57 1307.45 1815.72V1824.63C1307.45 1827.33 1307.94 1829.66 1308.94 1831.63C1309.96 1833.59 1311.39 1835.11 1313.24 1836.17C1315.08 1837.24 1317.27 1837.77 1319.81 1837.77C1321.49 1837.77 1323.03 1837.54 1324.42 1837.06C1325.82 1836.59 1327.01 1835.88 1328.01 1834.93C1329 1833.98 1329.76 1832.82 1330.28 1831.45L1344.27 1832.38C1343.56 1835.74 1342.11 1838.67 1339.91 1841.18C1337.73 1843.67 1334.91 1845.61 1331.45 1847.01C1328.02 1848.38 1324.06 1849.07 1319.56 1849.07ZM1354.46 1848V1793.45H1369.13V1802.97H1369.7C1370.69 1799.59 1372.36 1797.03 1374.71 1795.3C1377.05 1793.55 1379.75 1792.67 1382.8 1792.67C1383.56 1792.67 1384.38 1792.72 1385.25 1792.82C1386.13 1792.91 1386.9 1793.04 1387.56 1793.21V1806.63C1386.85 1806.42 1385.87 1806.23 1384.61 1806.06C1383.36 1805.9 1382.21 1805.81 1381.17 1805.81C1378.94 1805.81 1376.96 1806.3 1375.2 1807.27C1373.48 1808.22 1372.1 1809.54 1371.08 1811.25C1370.09 1812.95 1369.59 1814.92 1369.59 1817.14V1848H1354.46Z' fill='white' /%3E%3Cline x1='1526.23' y1='856.232' x2='1922.23' y2='460.232' stroke='white' strokeWidth='5' /%3E%3Cline y1='-2.5' x2='560.029' y2='-2.5' transform='matrix(-0.707107 -0.707107 -0.707107 0.707107 664 858)' stroke='white' strokeWidth='5' /%3E%3Cline y1='-2.5' x2='560.029' y2='-2.5' transform='matrix(0.707107 0.707107 0.707107 -0.707107 1528 1642)' stroke='white' strokeWidth='5' /%3E%3Cline x1='665.768' y1='1643.77' x2='269.768' y2='2039.77' stroke='white' strokeWidth='5' /%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2_2'%3E%3Crect width='2192' height='2500' fill='white' /%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E")
    }

    #cta_${cta.id} .cf-element .cf-generic-product-placeholder-svg {
      visibility: visible;
      content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 525.5 525.5'%3E%3Cpath d='M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z'%3E%3C/path%3E%3Cpath d='M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z'%3E%3C/path%3E%3Cpath d='M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z'%3E%3C/path%3E%3C/svg%3E");
    }
    `;

  mobileStyles +=
    // prettier-ignore
    `#cta_${cta.id} .cf-element .cf-products-reviews {
      font-size: 11px;
    }

    #cta_${cta.id} .cf-mobile-center .cf-products-options-wrapper,
    #cta_${cta.id} .cf-mobile-center .cf-products-reviews {
      justify-content: center !important;
    }

    #cta_${cta.id} .cf-mobile-left .cf-products-options-wrapper,
    #cta_${cta.id} .cf-mobile-left .cf-products-reviews {
      justify-content: left !important;
    }

    #cta_${cta.id} .cf-mobile-right .cf-products-options-wrapper,
    #cta_${cta.id} .cf-mobile-right .cf-products-reviews {
      justify-content: right !important;
    }

    #cta_${cta.id} .cf-element .cf-products-reviews-stars-inner .svg-inline--fa {
      font-size: 14px;
    }
    `;
  //////// END SHARED PRODUCT HERO/FEED THEME STYLES

  ////////// START PRODUCT HERO THEME STYLES

  let productsHeroInnerPadding;
  if (options["products-hero-item-padding"]) {
    const productsHeroPaddingValue = parseInt(options["products-hero-item-padding"]);
    productsHeroInnerPadding = `${productsHeroPaddingValue}px`;
  }

  let productsHeroOuterPadding;
  if (options["products-hero-padding"]) {
    const productsHeroPaddingValue = parseInt(options["products-hero-padding"]);
    productsHeroOuterPadding = `${productsHeroPaddingValue}px`;
  }

  let productsHeroContentSpacing;
  if (options["products-hero-content-type-spacing"]) {
    productsHeroContentSpacing = options["products-hero-content-type-spacing"];
  }

  let productsHeroBorderRadius = "";
  if (options["products-hero-item-radius"] == "cf-not-rounded") {
    productsHeroBorderRadius = "0px";
  }
  if (options["products-hero-item-radius"] == "cf-slightly-rounded") {
    productsHeroBorderRadius = "4px";
  }
  if (options["products-hero-item-radius"] == "cf-fully-rounded") {
    productsHeroBorderRadius = "100px";
  }
  if (options["products-hero-item-radius"] == "custom") {
    productsHeroBorderRadius = "";
    ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
      (side) => {
        productsHeroBorderRadius += `${
          _.isNil(options["products-hero-item-radius-" + side]) == false
            ? options["products-hero-item-radius-" + side]
            : "4"
        }px `;
      }
    );
  }

  let productsHeroBoxShadow;

  if (options["products-hero-item-shadow"] == "None") {
    productsHeroBoxShadow = "none";
  }

  if (options["products-hero-item-shadow"] == "soft") {
    productsHeroBoxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
  }

  if (options["products-hero-item-shadow"] == "hard") {
    productsHeroBoxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
  }

  if (options["products-hero-item-shadow"] == "custom") {
    productsHeroBoxShadow = "";
    productsHeroBoxShadow +=
      (options["products-hero-item-shadow-horizontal-distance"]
        ? `${options["products-hero-item-shadow-horizontal-distance"]}px`
        : "0px") + " ";

    productsHeroBoxShadow +=
      (options["products-hero-item-shadow-vertical-distance"]
        ? `${options["products-hero-item-shadow-vertical-distance"]}px`
        : "0px") + " ";

    productsHeroBoxShadow +=
      (options["products-hero-item-shadow-blur-radius"]
        ? `${options["products-hero-item-shadow-blur-radius"]}px`
        : "0px") + " ";

    productsHeroBoxShadow +=
      (options["products-hero-item-shadow-spread-radius"]
        ? `${options["products-hero-item-shadow-spread-radius"]}px`
        : "0px") + " ";

    productsHeroBoxShadow +=
      (options["products-hero-item-shadow-color"]
        ? options["products-hero-item-shadow-color"]
        : "rgba(0,0,0, 0.35)") + " ";
  }

  const productsHeroQuantityPickerButtonMinimumWidth = options["products-hero-quantity-picker-minimum-width"] ? options["products-hero-quantity-picker-minimum-width"] : undefined
  const productsHeroQuantityPickerFontFamily = options["products-hero-quantity-picker-font-family"]
  const productsHeroQuantityPickerFontWeight = options["products-hero-quantity-picker-font-weight"]
  const productsHeroQuantityPickerFontSize = options["products-hero-quantity-picker-font-size"]
  const productsHeroQuantityPickerFontColor = options["products-hero-quantity-picker-text-color"]
  const productsHeroQuantityPickerBackgroundColor = options["products-hero-quantity-picker-background-color"]
  const productsHeroQuantityPickerBorderStyle = options["products-hero-quantity-picker-border-style"]
  const productsHeroQuantityPickerBorderColor = options["products-hero-quantity-picker-border-color"]
  const productsHeroQuantityPickerBorderWidthLeft = options["products-hero-quantity-picker-border-left"]
  const productsHeroQuantityPickerBorderWidthRight = options["products-hero-quantity-picker-border-right"]
  const productsHeroQuantityPickerBorderWidthTop = options["products-hero-quantity-picker-border-top"]
  const productsHeroQuantityPickerBorderWidthBottom = options["products-hero-quantity-picker-border-bottom"]

  let productsHeroQuantityPickerBorderRounding;
  if (options["products-hero-quantity-picker-corner-rounding"] == "cf-not-rounded") {
    productsHeroQuantityPickerBorderRounding = "0px";
  }
  if (options["products-hero-quantity-picker-corner-rounding"] == "cf-slightly-rounded") {
    productsHeroQuantityPickerBorderRounding = "4px";
  }
  if (options["products-hero-quantity-picker-corner-rounding"] == "cf-fully-rounded") {
    productsHeroQuantityPickerBorderRounding = "100px";
  }
  if (options["products-hero-quantity-picker-corner-rounding"] == "custom") {
    productsHeroQuantityPickerBorderRounding = "";
    ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
      (side) => {
        productsHeroQuantityPickerBorderRounding += `${
          _.isNil(options["products-hero-quantity-picker-corner-" + side]) == false
            ? options["products-hero-quantity-picker-corner-" + side]
            : "4"
        }px `;
      }
  )};

  const productsHeroReviewsStarColor = options["products-hero-reviews-star-color"];
  const productsHeroReviewsStarSize = options["products-hero-reviews-star-size"];
  const productsHeroReviewsFontFamily = options["products-hero-reviews-font-family"];
  const productsHeroReviewsFontWeight = options["products-hero-reviews-font-weight"];
  const productsHeroReviewsFontSize = options["products-hero-reviews-font-size"];
  const productsHeroReviewsFontColor = options["products-hero-reviews-text-color"];

  const productsHeroImageCarouselHeight = options["products-hero-carousel-image-height"];

  const productsHeroContentLabelFontFamily = options["products-hero-content-label-font-family"];
  const productsHeroContentLabelFontWeight = options["products-hero-content-label-font-weight"];
  const productsHeroContentLabelFontSize = options["products-hero-content-label-font-size"];
  const productsHeroContentLabelLineHeight = options["products-hero-content-label-line-height"];
  const productsHeroContentLabelFontColor = options["products-hero-content-label-font-color"];

  desktopStyles +=
    // prettier-ignore
    `#cta_${cta.id} .cf-product-hero-element .cf-product-content-type {
      display: flex;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-product-hero-inner {
      display: flex;
      gap: 30px;
      padding: 15px;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element div.cf-variant-picker-wrapper select {
      appearance: auto;
      border-radius: 3px;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element div.cf-products-subscription-dropdown-wrapper select {
      border-radius: 3px;
      appearance: auto;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element  div.cf-variant-picker-wrapper.cf-product-content-type > div > select {
      appearance: auto;
      border-radius: 3px;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-quantity-picker-label {
      font-family: "Inter", Helvetica, sans-serif;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-variant-picker-label {
      font-family: "Inter", Helvetica, sans-serif;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element div.cf-products-subscription-dropdown-wrapper {
      display: flex;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element a {
      text-decoration: none !important;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-prod-hero-image-box .cf-products-placeholder-svg {
      width: 400px;
      height: 500px;
    }

    cta_${cta.id} .cf-element .cf-product-hero-element .cf-outer-center .cf-products-reviews,
    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-outer-center .cf-products-reviews div,
    .cta${cta.id} .cf-element .cf-product-hero-element .cf-outer-center .cf-products-reviews,
    .cta${cta.id} .cf-element .cf-product-hero-element .cf-outer-center .cf-products-reviews div {
      justify-content: center !important;
    }
    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-outer-left .cf-products-reviews,
    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-outer-left .cf-products-reviews div,
    .cta${cta.id} .cf-element .cf-product-hero-element .cf-outer-left .cf-products-reviews,
    .cta${cta.id} .cf-element .cf-product-hero-element .cf-outer-left .cf-products-reviews div {
      justify-content: left !important;
    }
    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-outer-right .cf-products-reviews,
    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-outer-right .cf-products-reviews div,
    .cta${cta.id} .cf-element .cf-product-hero-element .cf-outer-right .cf-products-reviews,
    .cta${cta.id} .cf-element .cf-product-hero-element .cf-outer-right .cf-products-reviews div {
      justify-content: right !important;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-form-2 {
      margin: unset;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-prod-hero-image-box {
      flex: 1;
      display: flex;
      align-items: flex-start;
      text-align: center;
      min-width: 50%;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-prod-hero-inner-box:has(.cf-prod-hero-image-box) {
      position: sticky;
      top: 0;
      align-self: flex-start;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-prod-hero-image-box img {
      max-height: fit-content;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-prod-hero-content-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow-wrap: anywhere;
      max-width: max-content !important;
      align-item: flex-start;
      ${options["products-hero-item-content-width"] ? 'width: ' + options["products-hero-item-content-width"] + 'px !important;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-prod-hero-image-box .cf-products-placeholder-svg {
      width: 400px;
      height: 500px;
    }

    #cta_${cta.id} .cf-product-hero-element .cf-product-content-type .cf-field-regular {
      max-width: initial;
    }

    #cta_${cta.id} .cf-product-hero-element.cf-outer-center .cf-product-hero-inner {
      margin-left: auto;
      margin-right: auto;
      justify-content: center;
    }

    #cta_${cta.id} .cf-product-hero-element.cf-outer-left .cf-product-hero-inner {
      margin-right: auto;
      justify-content: left;
    }

    #cta_${cta.id} .cf-product-hero-element.cf-outer-right .cf-product-hero-inner {
      margin-left: auto;
      justify-content: right;
    }

    #cta_${cta.id} .cf-product-hero-element .cf-products-subscription-radio-wrapper {
      width: fit-content;
      text-align: left !important;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-products-item-badge {
      color: #fff;
      background-color: #003FFF;
      padding: 5px 20px;
      font-size: 10px;
      width: fit-content;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-product__image {
      height: 100px;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-products-subscription-radio-wrapper input[type="radio"] {
      margin: 5px 5px 5px 0px;
      appearance: none !important;
      width: 13px !important;
      height: 13px !important;
      border-radius: 50%;
      background-clip: content-box !important;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-field-regular select {
      appearance: auto;
      border: 1px solid #000 !important;
      cursor: pointer;
      border-radius: 20px;
      padding: 6px 10px;
      font-family: "Inter", Helvetica, sans-serif;
    }

    #cta_${cta.id} .cf-product-hero-element .cf-quantity-picker-label,
    #cta_${cta.id} .cf-product-hero-element .cf-variant-picker-label,
    #cta_${cta.id} .cf-product-hero-element .cf-products-subscription-label {
      ${productsHeroContentLabelFontFamily ? `font-family: ${productsHeroContentLabelFontFamily} !important;` : "" }
      ${productsHeroContentLabelFontWeight ? `font-weight: ${productsHeroContentLabelFontWeight} !important;` : ""}
      ${productsHeroContentLabelFontSize ? `font-size: ${productsHeroContentLabelFontSize}px !important;` : ""}
      ${productsHeroContentLabelLineHeight ? `line-height: ${productsHeroContentLabelLineHeight}px !important;` : ""}
      ${productsHeroContentLabelFontColor ? `color: ${productsHeroContentLabelFontColor} !important;` : ""}
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-products-reviews-stars-inner svg {
      ${productsHeroReviewsStarColor ? `color: ${productsHeroReviewsStarColor};` : ""}
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-products-reviews-stars-inner .svg-inline--fa {
      ${productsHeroReviewsStarSize ? `font-size: ${productsHeroReviewsStarSize}px;` : ""}
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-products-reviews {
      ${productsHeroReviewsFontFamily ? `font-family: ${productsHeroReviewsFontFamily} !important;` : "" }
      ${productsHeroReviewsFontWeight ? `font-weight: ${productsHeroReviewsFontWeight} !important;` : ""}
      ${productsHeroReviewsFontSize ? `font-size: ${productsHeroReviewsFontSize}px !important;` : ""}
      ${productsHeroReviewsFontColor ? `color: ${productsHeroReviewsFontColor} !important;` : ""}
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-quantity-picker-wrapper {
      ${productsHeroQuantityPickerButtonMinimumWidth ? `width: ${productsHeroQuantityPickerButtonMinimumWidth}px !important;` : ""}
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-increment-quantity-picker .cf-decrement,
    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-increment-quantity-picker .cf-products-quantity,
    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-increment-quantity-picker .cf-increment {
      ${productsHeroQuantityPickerFontFamily ? `font-family: ${productsHeroQuantityPickerFontFamily} !important;` : ""}
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-increment-quantity-picker {
      ${productsHeroQuantityPickerFontWeight ? `font-weight: ${productsHeroQuantityPickerFontWeight} !important;` : ""}
      ${productsHeroQuantityPickerFontSize ? `font-size: ${productsHeroQuantityPickerFontSize}px !important;` : ""}
      ${productsHeroQuantityPickerFontColor ? `color: ${productsHeroQuantityPickerFontColor} !important;` : ""}
      ${productsHeroQuantityPickerBackgroundColor ? `background: ${productsHeroQuantityPickerBackgroundColor} !important;` : ""}
      ${productsHeroQuantityPickerBorderStyle ? `border-style: ${productsHeroQuantityPickerBorderStyle} !important;` : ""}
      ${productsHeroQuantityPickerBorderColor ? `border-color: ${productsHeroQuantityPickerBorderColor} !important;` : ""}
      ${productsHeroQuantityPickerBorderWidthLeft ? `border-left-width: ${productsHeroQuantityPickerBorderWidthLeft}px !important;` : ""}
      ${productsHeroQuantityPickerBorderWidthRight ? `border-right-width: ${productsHeroQuantityPickerBorderWidthRight}px !important;` : ""}
      ${productsHeroQuantityPickerBorderWidthBottom ? `border-bottom-width: ${productsHeroQuantityPickerBorderWidthBottom}px !important;` : ""}
      ${productsHeroQuantityPickerBorderWidthTop ? `border-top-width: ${productsHeroQuantityPickerBorderWidthTop}px !important;` : ""}
      ${productsHeroQuantityPickerBorderRounding ? `border-radius: ${productsHeroQuantityPickerBorderRounding} !important;` : ""}
    }

    #cta_${cta.id} .cf-product-hero-element .cf-products-item {
      max-width: 100% !important;
      ${productsHeroOuterPadding ? 'padding: ' + productsHeroOuterPadding + ' !important;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-product-content-type {
      ${productsHeroContentSpacing ? `margin-bottom: ${productsHeroContentSpacing}px !important;` : ""}
    }

    #cta_${cta.id} .cf-product-hero-element .cf-product-hero-inner {
      ${options["products-hero-item-width"] ? 'width: ' + options["products-hero-item-width"] + 'px !important;' : ''}
      ${productsHeroInnerPadding ? 'padding: ' + productsHeroInnerPadding + ' !important;' : ''}
      ${options["products-hero-item-background-color"] ? 'background: ' + options["products-hero-item-background-color"] + ' !important;' : ''}
      ${options["products-hero-item-border-style"] ? 'border-style: ' + options["products-hero-item-border-style"] + '!important;' : ''}
      ${_.isNil(options["products-hero-item-border-width"]) == false ? 'border-width: ' + options["products-hero-item-border-width"] + 'px !important;' : ''}
      ${_.isNil(options["products-hero-item-border-width-left"]) == false ? 'border-left-width: ' + options["products-hero-item-border-width-left"] + 'px !important;' : ''}
      ${_.isNil(options["products-hero-item-border-width-right"]) == false ? 'border-right-width: ' + options["products-hero-item-border-width-right"] + 'px !important;' : ''}
      ${_.isNil(options["products-hero-item-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["products-hero-item-border-width-bottom"] + 'px !important;' : ''}
      ${_.isNil(options["products-hero-item-border-width-top"]) == false ? 'border-top-width: ' + options["products-hero-item-border-width-top"] + 'px !important;' : ''}
      ${options["products-hero-item-border-color"] ? 'border-color: ' + options["products-hero-item-border-color"] + ' !important;' : ''}
      ${productsHeroBorderRadius ? 'border-radius: ' + productsHeroBorderRadius + ' !important;' : ''}
      ${productsHeroBoxShadow ? 'box-shadow: ' + productsHeroBoxShadow + ' !important;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-product__image {
      ${productsHeroImageCarouselHeight ? `height: ${productsHeroImageCarouselHeight}px;` : "height: 50px;"}
    }

    #cta_${cta.id} .cf-product-hero-element .cf-products-item-image img, #cta_${cta.id} .cf-product-hero-element .cf-products-item-image svg {
      ${options["products-hero-item-image-height"] ? 'height: ' + options["products-hero-item-image-height"] + 'px !important;' : ''}
    }

    #cta_${cta.id} .cf-product-hero-element .cf-products-item-image img,
    #cta_${cta.id} .cf-product-hero-element .cf-products-item-image svg {
      ${options["products-hero-item-image-width"] ? 'width: ' + options["products-hero-item-image-width"] + 'px !important;' : ''}
    }


    #cta_${cta.id} .cf-product-hero-element .cf-products-item-title p {
      ${options["products-hero-item-title-size"] ? 'font-size: ' + options["products-hero-item-title-size"] + 'px !important;' : ''}
      ${options["products-hero-item-title-line-height"] ? 'line-height: ' + options["products-hero-item-title-line-height"] + 'px !important;' : ''}
      ${options["products-hero-item-title-font"] ? 'font-family: ' + options["products-hero-item-title-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
      ${options["products-hero-item-title-font-weight"] ? 'font-weight: ' + options["products-hero-item-title-font-weight"] + ' !important;' : ''}
      ${options["products-hero-item-title-color"] ? 'color: ' + options["products-hero-item-title-color"] + ' !important;' : ''}
    }

    #cta_${cta.id} .cf-product-hero-element .cf-products-item-price p {
      ${options["products-hero-item-price-size"] ? 'font-size: ' + options["products-hero-item-price-size"] + 'px !important;' : ''}
      ${options["products-hero-item-price-font"] ? 'font-family: ' + options["products-hero-item-price-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
      ${options["products-hero-item-price-font-weight"] ? 'font-weight: ' + options["products-hero-item-price-font-weight"] + ' !important;' : ''}
    }

    #cta_${cta.id} .cf-product-hero-element .cf-products-item-description,
    #cta_${cta.id} .cf-product-hero-element .cf-products-item-description p,
    #cta_${cta.id} .cf-product-hero-element .cf-products-item-description h1,
    #cta_${cta.id} .cf-product-hero-element .cf-products-item-description h2,
    #cta_${cta.id} .cf-product-hero-element .cf-products-item-description h3,
    #cta_${cta.id} .cf-product-hero-element .cf-products-item-description h4,
    #cta_${cta.id} .cf-product-hero-element .cf-products-empty-message p {
      ${options["products-hero-item-description-font"] ? 'font-family: ' + options["products-hero-item-description-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
      ${options["products-hero-item-description-size"] ? 'font-size: ' + options["products-hero-item-description-size"] + 'px !important;' : ''}
      ${options["products-hero-item-description-line-height"] ? 'line-height: ' + options["products-hero-item-description-line-height"] + 'px !important;' : ''}
      ${options["products-hero-item-description-font-weight"] ? 'font-weight: ' + options["products-hero-item-description-font-weight"] + ' !important;' : ''}
      ${options["products-hero-item-description-color"] ? 'color: ' + options["products-hero-item-description-color"] + ' !important;' : ''}
    }
    `;

  const productsHeroProductImageCarouselHeightMobile = options["products-hero-carousel-image-height-mobile"];

  const productsHeroQuantityPickerButtonMinimumWidthMobile = options["products-hero-quantity-picker-minimum-width-mobile"] ? options["products-hero-quantity-picker-minimum-width-mobile"] : undefined
  const productsHeroQuantityPickerFontSizeMobile = options["products-hero-quantity-picker-font-size-mobile"];

  const productsHeroReviewsStarSizeMobile = options["products-hero-reviews-star-size-mobile"];
  const productsHeroReviewsFontSizeMobile = options["products-hero-reviews-font-size-mobile"];

  let productsHeroInnerPaddingMobile;
  if (options["products-hero-item-padding-mobile"]) {
    const productsHeroPaddingValueMobile = parseInt(
      options["products-hero-item-padding-mobile"]
    );
    productsHeroInnerPaddingMobile = `${productsHeroPaddingValueMobile}px`;
  }

  let productsHeroOuterPaddingMobile;
  if (options["products-hero-padding-mobile"]) {
    const productsHeroPaddingValueMobile = parseInt(
      options["products-hero-padding-mobile"]
    );
    productsHeroOuterPaddingMobile = `${productsHeroPaddingValueMobile}px`;
  }

  let productsHeroContentSpacingMobile;
  if (options["products-hero-content-type-spacing-mobile"]) {
    productsHeroContentSpacingMobile =
      options["products-hero-content-type-spacing-mobile"];
  }

  const productsHeroContentLabelFontSizeMobile = options["products-hero-content-label-font-size-mobile"];
  const productsHeroContentLabelLineHeightMobile = options["products-hero-content-label-line-height-mobile"];

  mobileStyles +=
    // prettier-ignore
    `#cta_${cta.id} .cf-element .cf-product-hero-element .cf-product-hero-inner {
      flex-direction: column !important;
      ${options["products-hero-item-width-mobile"] ? 'width: ' + options["products-hero-item-width-mobile"] + 'px !important;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-prod-hero-image-box {
      max-width: 100% !important;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-prod-hero-inner-box:has(.cf-prod-hero-image-box) {
      position: static;
      align-self: auto;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-prod-hero-content-box {
      max-width: 100% !important;
      ${options["products-hero-item-content-width-mobile"] ? 'width: ' + options["products-hero-item-content-width-mobile"] + 'px !important;' : ''}
    }

    #cta_${cta.id} .cf-product-hero-element.cf-products-outer {
      max-width: 100%;
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-product-hero-inner {
      ${options["products-hero-item-width-mobile"] ? 'width: ' + options["products-hero-item-width-mobile"] + 'px !important;' : ''}
    }

    #cta_${cta.id} .cf-product-hero-element .cf-quantity-picker-label,
    #cta_${cta.id} .cf-product-hero-element .cf-variant-picker-label,
    #cta_${cta.id} .cf-product-hero-element .cf-products-subscription-label {
      ${productsHeroContentLabelFontSizeMobile ? `font-size: ${productsHeroContentLabelFontSizeMobile}px !important;` : ""}
      ${productsHeroContentLabelLineHeightMobile ? `line-height: ${productsHeroContentLabelLineHeightMobile}px !important;` : ""}
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-products-reviews {
      ${productsHeroReviewsFontSizeMobile ? `font-size: ${productsHeroReviewsFontSizeMobile}px !important;` : ""}
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-products-reviews-stars-inner .svg-inline--fa {
      ${productsHeroReviewsStarSizeMobile ? `font-size: ${productsHeroReviewsStarSizeMobile}px;` : ""}
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-quantity-picker-wrapper {
      ${productsHeroQuantityPickerButtonMinimumWidthMobile ? `width: ${productsHeroQuantityPickerButtonMinimumWidthMobile}px !important;` : ""}
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-increment-quantity-picker {
      ${productsHeroQuantityPickerFontSizeMobile ? `font-size: ${productsHeroQuantityPickerFontSizeMobile}px !important;` : ""}
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-product__image {
      ${productsHeroProductImageCarouselHeightMobile ? `height: ${productsHeroProductImageCarouselHeightMobile}px;` : ""}
    }

    #cta_${cta.id} .cf-product-hero-element .cf-products-item {
      ${productsHeroOuterPaddingMobile ? 'padding: ' + productsHeroOuterPaddingMobile + ' !important;' : ''}
    }

    #cta_${cta.id} .cf-element .cf-product-hero-element .cf-product-content-type {
      ${productsHeroContentSpacingMobile ? `margin-bottom: ${productsHeroContentSpacingMobile}px !important;` : ""}
    }

    #cta_${cta.id} .cf-product-hero-element .cf-product-hero-inner {
      ${productsHeroInnerPaddingMobile ? 'padding: ' + productsHeroInnerPaddingMobile + ' !important;' : ''}
    }

    #cta_${cta.id} .cf-product-hero-element .cf-products-item-image img, #cta_${cta.id} .cf-product-hero-element .cf-products-item-image svg {
      ${options["products-hero-item-image-height-mobile"] ? 'height: ' + options["products-hero-item-image-height-mobile"] + 'px !important;' : ''}
    }

    #cta_${cta.id} .cf-product-hero-element .cf-products-item-image img,
    #cta_${cta.id} .cf-product-hero-element .cf-products-item-image .cf-products-list svg {
      ${options["products-hero-item-image-width-mobile"] ? 'width: ' + options["products-hero-item-image-width-mobile"] + 'px !important;' : ''}
    }

    #cta_${cta.id} .cf-product-hero-element .cf-products-item-title p {
      ${options["products-hero-item-title-size-mobile"] ? 'font-size: ' + options["products-hero-item-title-size-mobile"] + 'px !important;' : ''}
      ${options["products-hero-item-title-line-height-mobile"] ? 'line-height: ' + options["products-hero-item-title-line-height-mobile"] + 'px !important;' : ''}
    }

    #cta_${cta.id} .cf-product-hero-element .cf-products-item-price p {
      ${options["products-hero-item-price-size-mobile"] ? 'font-size: ' + options["products-hero-item-price-size-mobile"] + 'px !important;' : ''}
    }

    #cta_${cta.id} .cf-product-hero-element .cf-products-item-description,
    #cta_${cta.id} .cf-product-hero-element .cf-products-item-description p,
    #cta_${cta.id} .cf-product-hero-element .cf-products-item-description h1,
    #cta_${cta.id} .cf-product-hero-element .cf-products-item-description h2,
    #cta_${cta.id} .cf-product-hero-element .cf-products-item-description h3,
    #cta_${cta.id} .cf-product-hero-element .cf-products-item-description h4,
    #cta_${cta.id} .cf-product-hero-element .cf-products-empty-message p {
      ${options["products-hero-item-description-size-mobile"] ? 'font-size: ' + options["products-hero-item-description-size-mobile"] + 'px !important;' : ''}
      ${options["products-hero-item-description-line-height-mobile"] ? 'line-height: ' + options["products-hero-item-description-line-height-mobile"] + 'px !important;' : ''}
    }
  `;
  //////// END PRODUCT HERO THEME STYLES

  ////////// START PRODUCT FEED THEME STYLES

    let productsInnerPadding;
    if (options["products-item-padding"]) {
      const productsPaddingValue = parseInt(options["products-item-padding"]);
      productsInnerPadding = `${productsPaddingValue}px`;
    }

    let productsInnerPaddingMobile;
    if (options["products-item-padding-mobile"]) {
      const productsPaddingValueMobile = parseInt(
        options["products-item-padding-mobile"]
      );
      productsInnerPaddingMobile = `${productsPaddingValueMobile}px`;
    }

    let productsOuterPadding;
    if (options["products-padding"]) {
      const productsPaddingValue = parseInt(options["products-padding"]);
      productsOuterPadding = `${productsPaddingValue}px`;
    }

    let productsOuterPaddingMobile;
    if (options["products-padding-mobile"]) {
      const productsPaddingValueMobile = parseInt(
        options["products-padding-mobile"]
      );
      productsOuterPaddingMobile = `${productsPaddingValueMobile}px`;
    }

    let productsVerticalMargin;
    if (options["products-margin-vertical"]) {
      const productsMarginValue = parseInt(options["products-margin-vertical"]);
      productsVerticalMargin = `${productsMarginValue}px`;
    }

    let productsVerticalMarginMobile;
    if (options["products-margin-vertical-mobile"]) {
      const productsMarginValueMobile = parseInt(
        options["products-margin-vertical-mobile"]
      );
      productsVerticalMarginMobile = `${productsMarginValueMobile}px`;
    }

    let productsContentSpacing;
    if (options["products-content-type-spacing"]) {
      productsContentSpacing = options["products-content-type-spacing"];
    }

    let productsContentSpacingMobile;
    if (options["products-content-type-spacing-mobile"]) {
      productsContentSpacingMobile =
        options["products-content-type-spacing-mobile"];
    }

    let productsBorderRadius = "";
    if (options["products-item-radius"] == "cf-not-rounded") {
      productsBorderRadius = "0px";
    }
    if (options["products-item-radius"] == "cf-slightly-rounded") {
      productsBorderRadius = "4px";
    }
    if (options["products-item-radius"] == "cf-fully-rounded") {
      productsBorderRadius = "100px";
    }
    if (options["products-item-radius"] == "custom") {
      productsBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          productsBorderRadius += `${
            _.isNil(options["products-item-radius-" + side]) == false
              ? options["products-item-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let productsBoxShadow;

    if (options["products-item-shadow"] == "None") {
      productsBoxShadow = "none";
    }

    if (options["products-item-shadow"] == "soft") {
      productsBoxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["products-item-shadow"] == "hard") {
      productsBoxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["products-item-shadow"] == "custom") {
      productsBoxShadow = "";
      productsBoxShadow +=
        (options["products-item-shadow-horizontal-distance"]
          ? `${options["products-item-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      productsBoxShadow +=
        (options["products-item-shadow-vertical-distance"]
          ? `${options["products-item-shadow-vertical-distance"]}px`
          : "0px") + " ";

      productsBoxShadow +=
        (options["products-item-shadow-blur-radius"]
          ? `${options["products-item-shadow-blur-radius"]}px`
          : "0px") + " ";

      productsBoxShadow +=
        (options["products-item-shadow-spread-radius"]
          ? `${options["products-item-shadow-spread-radius"]}px`
          : "0px") + " ";

      productsBoxShadow +=
        (options["products-item-shadow-color"]
          ? options["products-item-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";
    }

    const quantityPickerButtonMinimumWidth = options["products-quantity-picker-minimum-width"] ? options["products-quantity-picker-minimum-width"] : undefined
    const quantityPickerFontFamily = options["products-quantity-picker-font-family"]
    const quantityPickerFontWeight = options["products-quantity-picker-font-weight"]
    const quantityPickerFontSize = options["products-quantity-picker-font-size"]
    const quantityPickerFontColor = options["products-quantity-picker-text-color"]
    const quantityPickerBackgroundColor = options["products-quantity-picker-background-color"]
    const quantityPickerBorderStyle = options["products-quantity-picker-border-style"]
    const quantityPickerBorderColor = options["products-quantity-picker-border-color"]
    const quantityPickerBorderWidthLeft = options["products-quantity-picker-border-left"]
    const quantityPickerBorderWidthRight = options["products-quantity-picker-border-right"]
    const quantityPickerBorderWidthTop = options["products-quantity-picker-border-top"]
    const quantityPickerBorderWidthBottom = options["products-quantity-picker-border-bottom"]

    let quantityPickerBorderRounding;
    if (options["products-quantity-picker-corner-rounding"] == "cf-not-rounded") {
      quantityPickerBorderRounding = "0px";
    }
    if (options["products-quantity-picker-corner-rounding"] == "cf-slightly-rounded") {
      quantityPickerBorderRounding = "4px";
    }
    if (options["products-quantity-picker-corner-rounding"] == "cf-fully-rounded") {
      quantityPickerBorderRounding = "100px";
    }
    if (options["products-quantity-picker-corner-rounding"] == "custom") {
      quantityPickerBorderRounding = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          quantityPickerBorderRounding += `${
            _.isNil(options["products-quantity-picker-corner-" + side]) == false
              ? options["products-quantity-picker-corner-" + side]
              : "4"
          }px `;
        }
    )};

    const variantPickerOptionsMinimumWidth = options["products-variant-picker-button-minimum-width"];
    const variantPickerFontFamily = options["products-variant-picker-font-family"];
    const variantPickerFontWeight = options["products-variant-picker-font-weight"];
    const variantPickerFontSize = options["products-variant-picker-font-size"];
    const variantPickerFontColor = options["products-variant-picker-text-color"];
    const variantPickerFontHoverColor = options["products-variant-picker-text-hover-color"];
    const variantPickerBorderStyle = options["products-variant-picker-border-style"];
    const variantPickerBorderColor = options["products-variant-picker-border-color"];
    const variantPickerBorderHoverColor = options["products-variant-picker-border-hover-color"];
    const variantPickerBorderWidthLeft = options["products-variant-picker-border-left"];
    const variantPickerBorderWidthRight = options["products-variant-picker-border-right"];
    const variantPickerBorderWidthTop = options["products-variant-picker-border-top"];
    const variantPickerBorderWidthBottom = options["products-variant-picker-border-bottom"];
    const variantPickerBackgroundColor = options["products-variant-picker-background-color"];
    const variantPickerBackgroundHoverColor = options["products-variant-picker-background-hover-color"];

    let variantPickerBorderRounding;
    if (options["products-variant-picker-corner-rounding"] == "cf-not-rounded") {
      variantPickerBorderRounding = "0px";
    }
    if (options["products-variant-picker-corner-rounding"] == "cf-slightly-rounded") {
      variantPickerBorderRounding = "4px";
    }
    if (options["products-variant-picker-corner-rounding"] == "cf-fully-rounded") {
      variantPickerBorderRounding = "100px";
    }
    if (options["products-variant-picker-corner-rounding"] == "custom") {
      variantPickerBorderRounding = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          variantPickerBorderRounding += `${
            _.isNil(options["products-variant-picker-corner-" + side]) == false
              ? options["products-variant-picker-corner-" + side]
              : "1"
          }px `;
        }
      );
    }

    const subscriptionChoicesFontFamily = options["products-subscription-choices-font-family"];
    const subscriptionChoicesFontWeight = options["products-subscription-choices-font-weight"]
    const subscriptionChoicesFontColor = options["products-subscription-choices-text-color"];
    const subscriptionChoicesFontHoverColor = options["products-subscription-choices-text-hover-color"];
    const subscriptionChoicesBackgroundColor = options["products-subscription-choices-background-color"];
    const subscriptionChoicesRadioColor = options["products-subscription-radio-color"];
    const subscriptionChoicesSelectedRadioColor = options["products-subscription-radio-selected-color"];
    const subscriptionChoicesDropdownBorderStyle = options["products-subscription-border-style"];
    const subscriptionChoicesDropdownBorderWidthLeft = options["products-subscription-border-left"];
    const subscriptionChoicesDropdownBorderWidthRight = options["products-subscription-border-right"];
    const subscriptionChoicesDropdownBorderWidthTop = options["products-subscription-border-top"];
    const subscriptionChoicesDropdownBorderWidthBottom = options["products-subscription-border-bottom"];
    const subscriptionChoicesDropdownBorderColor = options["products-subscription-border-color"];
    const subscriptionChoicesDropdownBorderHoverColor = options["products-subscription-border-hover-color"];

    let subscriptionChoicesBorderRounding;
    if (options["products-subscription-corner-rounding"] == "cf-not-rounded") {
      subscriptionChoicesBorderRounding = "0px";
    }
    if (options["products-subscription-corner-rounding"] == "cf-slightly-rounded") {
      subscriptionChoicesBorderRounding = "4px";
    }
    if (options["products-subscription-corner-rounding"] == "cf-fully-rounded") {
      subscriptionChoicesBorderRounding = "100px";
    }
    if (options["products-subscription-corner-rounding"] == "custom") {
      subscriptionChoicesBorderRounding = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          subscriptionChoicesBorderRounding += `${
            _.isNil(options["products-subscription-corner-" + side]) == false
              ? options["products-subscription-corner-" + side]
              : "1"
          }px `;
        }
      );
    }

    const reviewsStarColor = options["products-reviews-star-color"];
    const reviewsStarSize = options["products-reviews-star-size"];
    const reviewsFontFamily = options["products-reviews-font-family"];
    const reviewsFontWeight = options["products-reviews-font-weight"];
    const reviewsFontSize = options["products-reviews-font-size"];
    const reviewsFontColor = options["products-reviews-text-color"];

    const removeFromCartFontFamily = options["products-remove-from-cart-font-family"];
    const removeFromCartFontWeight = options["products-remove-from-cart-font-weight"];
    const removeFromCartFontSize = options["products-remove-from-cart-font-size"];
    const removeFromCartFontColor = options["products-remove-from-cart-text-color"];
    const removeFromCartFontHoverColor = options["products-remove-from-cart-text-hover-color"];
    const removeFromCartBackgroundColor = options["products-remove-from-cart-background-color"];
    const removeFromCartBackgroundHoverColor = options["products-remove-from-cart-background-hover-color"];
    const removeFromCartBorderStyle = options["products-remove-from-cart-border-style"];
    const removeFromCartBorderWidthLeft = options["products-remove-from-cart-border-left"];
    const removeFromCartBorderWidthRight = options["products-remove-from-cart-border-right"];
    const removeFromCartBorderWidthTop = options["products-remove-from-cart-border-top"];
    const removeFromCartBorderWidthBottom = options["products-remove-from-cart-border-bottom"];
    const removeFromCartBorderColor = options["products-remove-from-cart-border-color"] || "#000";
    const removeFromCartBorderHoverColor = options["products-remove-from-cart-border-hover-color"] || "#000";

    let removeFromCartBorderRounding;
    if (options["products-remove-from-cart-corner-rounding"] == "cf-not-rounded") {
      removeFromCartBorderRounding = "0px";
    }
    if (options["products-remove-from-cart-corner-rounding"] == "cf-slightly-rounded") {
      removeFromCartBorderRounding = "4px";
    }
    if (options["products-remove-from-cart-corner-rounding"] == "cf-fully-rounded") {
      removeFromCartBorderRounding = "100px";
    }
    if (options["products-remove-from-cart-corner-rounding"] == "custom") {
      removeFromCartBorderRounding = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          removeFromCartBorderRounding += `${
            _.isNil(options["products-remove-from-cart-corner-" + side]) == false
              ? options["products-remove-from-cart-corner-" + side]
              : "1"
          }px `;
        }
      );
    }

    const productImageCarouselHeight = options["products-carousel-image-height"];

    const productsContentLabelFontSize = options["products-content-label-font-size"];
    const productsContentLabelFontWeight = options["products-content-label-font-weight"];
    const productsContentLabelFontFamily = options["products-content-label-font-family"];
    const productsContentLabelLineHeight = options["products-content-label-line-height"];
    const productsContentLabelFontColor = options["products-content-label-font-color"];

    desktopStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-products-element.cf-products-outer {
  ${options["products-item-width"] ? 'max-width: ' + options["products-item-width"] + 'px !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-quantity-picker-label,
#cta_${cta.id} .cf-element .cf-products-element .cf-variant-picker-label,
#cta_${cta.id} .cf-element .cf-products-element .cf-products-subscription-label {
  ${productsContentLabelFontSize ? `font-size: ${productsContentLabelFontSize}px !important;` : ""}
  ${productsContentLabelFontWeight ? `font-weight: ${productsContentLabelFontWeight} !important;` : ""}
  ${productsContentLabelFontFamily ? `font-family: ${productsContentLabelFontFamily} !important;` : ""}
  ${productsContentLabelLineHeight ? `line-height: ${productsContentLabelLineHeight}px !important;` : ""}
  ${productsContentLabelFontColor ? `color: ${productsContentLabelFontColor} !important;` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-products-reviews-stars-inner svg {
  ${reviewsStarColor ? `color: ${reviewsStarColor};` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-products-reviews-stars-inner .svg-inline--fa {
  ${reviewsStarSize ? `font-size: ${reviewsStarSize}px;` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-products-reviews {
  ${reviewsFontFamily ? `font-family: ${reviewsFontFamily} !important;` : "" }
  ${reviewsFontWeight ? `font-weight: ${reviewsFontWeight} !important;` : ""}
  ${reviewsFontSize ? `font-size: ${reviewsFontSize}px !important;` : ""}
  ${reviewsFontColor ? `color: ${reviewsFontColor} !important;` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-products-item-remove-from-cart {
  ${removeFromCartBackgroundColor ? `background: ${removeFromCartBackgroundColor} !important;` : ""}
  ${removeFromCartBackgroundHoverColor ? `&:hover { background: ${removeFromCartBackgroundHoverColor} !important; }` : ""}
  ${removeFromCartBorderStyle ? `border-style: ${removeFromCartBorderStyle} !important;` : ""}
  ${removeFromCartBorderColor ? `border-color: ${removeFromCartBorderColor} !important;` : ""}
  ${removeFromCartBorderHoverColor ? `&:hover { border-color: ${removeFromCartBorderHoverColor} !important; }` : ""}
  ${removeFromCartBorderWidthLeft ? `border-left-width: ${removeFromCartBorderWidthLeft}px !important;` : ""}
  ${removeFromCartBorderWidthRight ? `border-right-width: ${removeFromCartBorderWidthRight}px !important;` : ""}
  ${removeFromCartBorderWidthTop ? `border-top-width: ${removeFromCartBorderWidthTop}px !important;` : ""}
  ${removeFromCartBorderWidthBottom ? `border-bottom-width: ${removeFromCartBorderWidthBottom}px !important;` : ""}
  ${removeFromCartBorderRounding ? `border-radius: ${removeFromCartBorderRounding} !important;` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-products-item-remove-from-cart p {
  ${removeFromCartFontFamily ? `font-family: ${removeFromCartFontFamily} !important;` : ""}
  ${removeFromCartFontWeight ? `font-weight: ${removeFromCartFontWeight} !important;` : ""}
  ${removeFromCartFontSize ? `font-size: ${removeFromCartFontSize}px !important;` : ""}
  ${removeFromCartFontColor ? `color: ${removeFromCartFontColor} !important;` : ""}
  ${removeFromCartFontHoverColor ? `&:hover { color: ${removeFromCartFontHoverColor} !important; }` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element div.cf-products-subscription-dropdown-wrapper.cf-product-content-type > div > select,
#cta_${cta.id} .cf-element .cf-products-element .cf-products-subscription-radio-wrapper label {
  ${subscriptionChoicesFontFamily ? `font-family: ${subscriptionChoicesFontFamily} !important;` : "" }
  ${subscriptionChoicesFontWeight ? `font-weight: ${subscriptionChoicesFontWeight} !important;` : ""}
  ${subscriptionChoicesFontColor ? `color: ${subscriptionChoicesFontColor} !important;` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-products-subscription-radio-wrapper label {
  ${subscriptionChoicesFontHoverColor ? `&:hover { color: ${subscriptionChoicesFontHoverColor} !important; }` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element div.cf-products-subscription-dropdown-wrapper.cf-product-content-type > div > select {
  appearance: auto;
  ${subscriptionChoicesBackgroundColor ? `background: ${subscriptionChoicesBackgroundColor} !important;` : ""}
  ${subscriptionChoicesDropdownBorderStyle ? `border-style: ${subscriptionChoicesDropdownBorderStyle} !important;` : ""}
  ${subscriptionChoicesDropdownBorderColor ? `border-color: ${subscriptionChoicesDropdownBorderColor} !important;` : ""}
  ${subscriptionChoicesDropdownBorderWidthLeft ? `border-left-width: ${subscriptionChoicesDropdownBorderWidthLeft}px !important;` : ""}
  ${subscriptionChoicesDropdownBorderWidthRight ? `border-right-width: ${subscriptionChoicesDropdownBorderWidthRight}px !important;` : ""}
  ${subscriptionChoicesDropdownBorderWidthTop ? `border-top-width: ${subscriptionChoicesDropdownBorderWidthTop}px !important;` : ""}
  ${subscriptionChoicesDropdownBorderWidthBottom ? `border-bottom-width: ${subscriptionChoicesDropdownBorderWidthBottom}px !important;` : ""}
  ${subscriptionChoicesBorderRounding ? `border-radius: ${subscriptionChoicesBorderRounding} !important;` : ""}
  ${subscriptionChoicesDropdownBorderHoverColor ? `&:hover { border-color: ${subscriptionChoicesDropdownBorderHoverColor} !important; }` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-products-subscription-radio-wrapper input[type="radio"] {
  background-color: var(--cf-products-subscription-radio-color, ${subscriptionChoicesRadioColor || "#D4DDEA"}) !important;
}

#cta_${cta.id} .cf-element .cf-products-element .cf-products-subscription-radio-wrapper input[type="radio"]:checked {
  background-color: var(--cf-products-subscription-radio-selected-color, ${subscriptionChoicesSelectedRadioColor || "#003FFF"}) !important;
}

#cta_${cta.id} .cf-element .cf-products-element div.cf-variant-picker-wrapper.cf-product-content-type > div > select,
#cta_${cta.id} .cf-element .cf-products-element .cf-products-option-item {
  ${variantPickerOptionsMinimumWidth ? `min-width: ${variantPickerOptionsMinimumWidth}px;` : ""}
  ${variantPickerFontFamily ? `font-family: ${variantPickerFontFamily} !important;` : ""}
  ${variantPickerFontWeight ? `font-weight: ${variantPickerFontWeight} !important;` : ""}
  ${variantPickerFontSize ? `font-size: ${variantPickerFontSize}px !important;` : ""}
  ${variantPickerFontColor ? `color: ${variantPickerFontColor} !important;` : ""}
  ${variantPickerFontHoverColor ? `&:hover { color: ${variantPickerFontHoverColor} !important; }` : ""}
  ${variantPickerBorderStyle ? `border-style: ${variantPickerBorderStyle} !important;` : ""}
  ${variantPickerBorderColor ? `border-color: ${variantPickerBorderColor} !important;` : ""}
  ${variantPickerBorderHoverColor ? `&:hover { border-color: ${variantPickerBorderHoverColor} !important; }` : ""}
  ${variantPickerBorderWidthLeft ? `border-left-width: ${variantPickerBorderWidthLeft}px !important;` : ""}
  ${variantPickerBorderWidthRight ? `border-right-width: ${variantPickerBorderWidthRight}px !important;` : ""}
  ${variantPickerBorderWidthTop ? `border-top-width: ${variantPickerBorderWidthTop}px !important;` : ""}
  ${variantPickerBorderWidthBottom ? `border-bottom-width: ${variantPickerBorderWidthBottom}px !important;` : ""}
  ${variantPickerBorderRounding ? `border-radius: ${variantPickerBorderRounding} !important;` : ""}
  ${variantPickerBackgroundColor ? `background: ${variantPickerBackgroundColor} !important;` : ""}
  ${variantPickerBackgroundHoverColor ? `&:hover { background: ${variantPickerBackgroundHoverColor} !important; }` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-quantity-picker-wrapper {
  ${quantityPickerButtonMinimumWidth ? `width: ${quantityPickerButtonMinimumWidth}px !important;` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-increment-quantity-picker .cf-decrement,
#cta_${cta.id} .cf-element .cf-products-element .cf-increment-quantity-picker .cf-products-quantity,
#cta_${cta.id} .cf-element .cf-products-element .cf-increment-quantity-picker .cf-increment {
  ${quantityPickerFontFamily ? `font-family: ${quantityPickerFontFamily} !important;` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-increment-quantity-picker {
  ${quantityPickerFontWeight ? `font-weight: ${quantityPickerFontWeight} !important;` : ""}
  ${quantityPickerFontSize ? `font-size: ${quantityPickerFontSize}px !important;` : ""}
  ${quantityPickerFontColor ? `color: ${quantityPickerFontColor} !important;` : ""}
  ${quantityPickerBackgroundColor ? `background: ${quantityPickerBackgroundColor} !important;` : ""}
  ${quantityPickerBorderStyle ? `border-style: ${quantityPickerBorderStyle} !important;` : ""}
  ${quantityPickerBorderColor ? `border-color: ${quantityPickerBorderColor} !important;` : ""}
  ${quantityPickerBorderWidthLeft ? `border-left-width: ${quantityPickerBorderWidthLeft}px !important;` : ""}
  ${quantityPickerBorderWidthRight ? `border-right-width: ${quantityPickerBorderWidthRight}px !important;` : ""}
  ${quantityPickerBorderWidthBottom ? `border-bottom-width: ${quantityPickerBorderWidthBottom}px !important;` : ""}
  ${quantityPickerBorderWidthTop ? `border-top-width: ${quantityPickerBorderWidthTop}px !important;` : ""}
  ${quantityPickerBorderRounding ? `border-radius: ${quantityPickerBorderRounding} !important;` : ""}
}

#cta_${cta.id} .cf-products-element .cf-products-item {
  ${productsOuterPadding ? 'padding: ' + productsOuterPadding + ' !important;' : ''}
  ${productsVerticalMargin ? 'margin-bottom: ' + productsVerticalMargin + ' !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-product-content-type {
  ${productsContentSpacing ? `margin-bottom: ${productsContentSpacing}px !important;` : ""}
}

#cta_${cta.id} .cf-products-element .cf-products-item-inner {
  ${productsInnerPadding ? 'padding: ' + productsInnerPadding + ' !important;' : ''}
  ${options["products-item-background-color"] ? 'background: ' + options["products-item-background-color"] + ' !important;' : ''}
  ${options["products-item-border-style"] ? 'border-style: ' + options["products-item-border-style"] + '!important;' : ''}
  ${_.isNil(options["products-item-border-width"]) == false ? 'border-width: ' + options["products-item-border-width"] + 'px !important;' : ''}
  ${_.isNil(options["products-item-border-width-left"]) == false ? 'border-left-width: ' + options["products-item-border-width-left"] + 'px !important;' : ''}
  ${_.isNil(options["products-item-border-width-right"]) == false ? 'border-right-width: ' + options["products-item-border-width-right"] + 'px !important;' : ''}
  ${_.isNil(options["products-item-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["products-item-border-width-bottom"] + 'px !important;' : ''}
  ${_.isNil(options["products-item-border-width-top"]) == false ? 'border-top-width: ' + options["products-item-border-width-top"] + 'px !important;' : ''}
  ${options["products-item-border-color"] ? 'border-color: ' + options["products-item-border-color"] + ' !important;' : ''}
  ${productsBorderRadius ? 'border-radius: ' + productsBorderRadius + ' !important;' : ''}
  ${productsBoxShadow ? 'box-shadow: ' + productsBoxShadow + ' !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-product__image {
  ${productImageCarouselHeight ? `height: ${productImageCarouselHeight}px;` : "height: 50px;"}
}

#cta_${cta.id} .cf-products-element .cf-products-item-image img:not(.cf-product__image) {
  display: inline !important;
}

#cta_${cta.id} .cf-products-element .cf-products-item-image img:not(.cf-product__image),
#cta_${cta.id} .cf-products-element .cf-products-item-image svg {
  ${options["products-item-image-height"] ? 'height: ' + options["products-item-image-height"] + 'px !important;' : ''}
  ${options["products-item-image-width"] ? 'width: ' + options["products-item-image-width"] + 'px !important;' : ''}
}

#cta_${cta.id} .cf-products-element .cf-products-list .cf-col-md-3 {
  ${options["products-item-image-width"] ? `width: calc(0% + ${options["products-item-image-width"]}px) !important` : ''}
}

#cta_${cta.id} .cf-products-element .cf-products-list .cf-col-md-9 {
  ${options["products-item-image-width"] ? `width: calc(100% - ${options["products-item-image-width"]}px) !important` : ''}
}

#cta_${cta.id} .cf-products-element .cf-products-item-title p {
  ${options["products-item-title-size"] ? 'font-size: ' + options["products-item-title-size"] + 'px !important;' : ''}
  ${options["products-item-title-font"] ? 'font-family: ' + options["products-item-title-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
  ${options['products-item-title-font-weight'] ? 'font-weight: ' + options['products-item-title-font-weight'] + ' !important;' : ''}
  ${options["products-item-title-color"] ? 'color: ' + options["products-item-title-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-products-element .cf-products-item-price p {
  ${options["products-item-price-size"] ? 'font-size: ' + options["products-item-price-size"] + 'px !important;' : ''}
  ${options["products-item-price-font"] ? 'font-family: ' + options["products-item-price-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
  ${options['products-item-price-font-weight'] ? 'font-weight: ' + options['products-item-price-font-weight'] + ' !important;' : ''}
}

#cta_${cta.id} .cf-products-element .cf-products-item-description,
#cta_${cta.id} .cf-products-element .cf-products-item-description p,
#cta_${cta.id} .cf-products-element .cf-products-empty-message p {
  ${options["products-item-description-font"] ? 'font-family: ' + options["products-item-description-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
  ${options["products-item-description-size"] ? 'font-size: ' + options["products-item-description-size"] + 'px !important;' : ''}
  ${options['products-item-description-font-weight'] ? 'font-weight: ' + options['products-item-description-font-weight'] + ' !important;' : ''}
  ${options["products-item-description-color"] ? 'color: ' + options["products-item-description-color"] + ' !important;' : ''}
}`;

    const variantPickerOptionsMinimumWidthMobile = options["products-variant-picker-button-minimum-width-mobile"];
    const variantPickerFontSizeMobile = options["products-variant-picker-font-size-mobile"];
    const productImageCarouselHeightMobile = options["products-carousel-image-height-mobile"];

    const quantityPickerButtonMinimumWidthMobile = options["products-quantity-picker-minimum-width-mobile"] ? options["products-quantity-picker-minimum-width-mobile"] : undefined
    const quantityPickerFontSizeMobile = options["products-quantity-picker-font-size-mobile"];

    const reviewsStarSizeMobile = options["products-reviews-star-size-mobile"];
    const reviewsFontSizeMobile = options["products-reviews-font-size-mobile"];

    const productsContentLabelFontSizeMobile = options["products-content-label-font-size-mobile"];
    const productsContentLabelLineHeightMobile = options["products-content-label-line-height-mobile"];

    const removeFromCartFontSizeMobile = options["products-remove-from-cart-font-size-mobile"];

    mobileStyles +=
      // prettier-ignore
      `/* mobile styles */
#cta_${cta.id} .cf-products-element.cf-products-outer {
  ${options["products-item-width-mobile"] ? 'max-width: ' + options["products-item-width-mobile"] + 'px !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-quantity-picker-label,
#cta_${cta.id} .cf-element .cf-products-element .cf-variant-picker-label,
#cta_${cta.id} .cf-element .cf-products-element .cf-products-subscription-label {
  ${productsContentLabelFontSizeMobile ? `font-size: ${productsContentLabelFontSizeMobile}px !important;` : ""}
  ${productsContentLabelLineHeightMobile ? `line-height: ${productsContentLabelLineHeightMobile}px !important;` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-products-reviews {
  ${reviewsFontSizeMobile ? `font-size: ${reviewsFontSizeMobile}px !important;` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-products-reviews-stars-inner .svg-inline--fa {
  ${reviewsStarSizeMobile ? `font-size: ${reviewsStarSizeMobile}px;` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-products-item-remove-from-cart p {
  ${removeFromCartFontSizeMobile ? `font-size: ${removeFromCartFontSizeMobile}px !important;` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-quantity-picker-wrapper {
  ${quantityPickerButtonMinimumWidthMobile ? `width: ${quantityPickerButtonMinimumWidthMobile}px !important;` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-increment-quantity-picker {
  ${quantityPickerFontSizeMobile ? `font-size: ${quantityPickerFontSizeMobile}px !important;` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-product__image {
  ${productImageCarouselHeightMobile ? `height: ${productImageCarouselHeightMobile}px;` : ""}
}

#cta_${cta.id} .cf-element .cf-products-element div.cf-variant-picker-wrapper.cf-product-content-type > div > select,
#cta_${cta.id} .cf-element .cf-products-element .cf-products-option-item {
  ${variantPickerOptionsMinimumWidthMobile ? `min-width: ${variantPickerOptionsMinimumWidthMobile}px !important;` : ""}
  ${variantPickerFontSizeMobile ? `font-size: ${variantPickerFontSizeMobile}px !important;` : ""}
}

#cta_${cta.id} .cf-products-element .cf-products-item {
  ${productsOuterPaddingMobile ? 'padding: ' + productsOuterPaddingMobile + ' !important;' : ''}
  ${productsVerticalMarginMobile ? 'margin-bottom: ' + productsVerticalMarginMobile + ' !important;' : ''}
}

#cta_${cta.id} .cf-element .cf-products-element .cf-product-content-type {
  ${productsContentSpacingMobile ? `margin-bottom: ${productsContentSpacingMobile}px !important;` : ""}
}

#cta_${cta.id} .cf-products-element .cf-products-item-inner {
  ${productsInnerPaddingMobile ? 'padding: ' + productsInnerPaddingMobile + ' !important;' : ''}
}

#cta_${cta.id} .cf-products-element .cf-products-item-image img:not(.cf-product__image),
#cta_${cta.id} .cf-products-element .cf-products-item-image svg {
  ${options["products-item-image-height-mobile"] ? 'height: ' + options["products-item-image-height-mobile"] + 'px !important;' : ''}
  ${options["products-item-image-width-mobile"] ? 'width: ' + options["products-item-image-width-mobile"] + 'px !important;' : ''}
}

#cta_${cta.id} .cf-products-element .cf-products-item-title p {
  ${options["products-item-title-size-mobile"] ? 'font-size: ' + options["products-item-title-size-mobile"] + 'px !important;' : ''}
}

#cta_${cta.id} .cf-products-element .cf-products-item-price p {
  ${options["products-item-price-size-mobile"] ? 'font-size: ' + options["products-item-price-size-mobile"] + 'px !important;' : ''}
}

#cta_${cta.id} .cf-products-element .cf-products-item-description,
#cta_${cta.id} .cf-products-element .cf-products-item-description p,
#cta_${cta.id} .cf-products-element .cf-products-empty-message p {
  ${options["products-item-description-size-mobile"] ? 'font-size: ' + options["products-item-description-size-mobile"] + 'px !important;' : ''}
}`;

////////// END PRODUCT FEED THEME STYLES

    ////////// START LOGO THEME STYLES
    const logoControlStyle = options["logo-control-style"] ? options["logo-control-style"] : "width";
    const logoControlStyleMobile = options["logo-control-style-mobile"] 
      ? options["logo-control-style-mobile"] 
      : options["logo-control-style"] 
        ? options["logo-control-style"] 
        : "width";

    desktopStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element[data-type="logo"] img {
  ${logoControlStyle == "width" && options["logo-image-width"] ? `width: ${options["logo-image-width"]}px !important; height: auto !important;` : ''}
  ${logoControlStyle == "height" && options["logo-image-height"] ? `height: ${options["logo-image-height"]}px !important; width: auto !important;` : ''}
}`;

    mobileStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-element[data-type="logo"] img {
  ${logoControlStyleMobile == "width" ? 'height: initial !important;' : ''}
  ${logoControlStyleMobile == "height" ? 'width: initial !important;' : ''}
  ${logoControlStyleMobile == "width" && options["logo-image-width-mobile"] ? `width: ${options["logo-image-width-mobile"]}px !important; height: auto !important;` : ''}
  ${logoControlStyleMobile == "height" && options["logo-image-height-mobile"] ? `height: ${options["logo-image-height-mobile"]}px !important; width: auto !important;` : ''}
}`;
    ////////// END LOGO THEME STYLES


    ////////// START REVIEWS THEME STYLES
    const ratingStarColor = options["reviews-rating-star-color"];
    const ratingStarSize = options["reviews-rating-star-size"];

    const reviewsContainerWidth = options["reviews-container-width"];
    const reviewsContainerWidthMobile = options["reviews-container-width-mobile"];
    const reviewsContainerHeight = options["reviews-container-height"];
    const reviewsContainerHeightMobile = options["reviews-container-height-mobile"];
    const reviewsContentVerticalSpacing = options["reviews-content-vertical-spacing"];
    const reviewsContentVerticalSpacingMobile = options["reviews-content-vertical-spacing-mobile"];

    const reviewsArrowSize = options["reviews-arrow-size"] || 12;

    const reviewsVideoTextColor = options["reviews-video-background-text-color"];
    const reviewsVideoBgRatingColor = options["reviews-video-bg-rating-color"] || reviewsVideoTextColor || '#fff';
    const reviewsVideoBgTitleColor = options["reviews-video-bg-title-color"] || reviewsVideoTextColor || '#fff';
    const reviewsVideoBgContentColor = options["reviews-video-bg-content-color"] || reviewsVideoTextColor || '#fff';
    const reviewsVideoBgCustomerNameColor = options["reviews-video-bg-customer-name-color"] || reviewsVideoTextColor || '#fff';
    const reviewsVideoBgCustomerTitleColor = options["reviews-video-bg-customer-title-color"] || reviewsVideoTextColor || '#fff';
    const reviewsVideoBgDateColor = options["reviews-video-bg-date-color"] || reviewsVideoTextColor || '#fff';
    const reviewsVideoBgSourceColor = options["reviews-video-bg-source-color"] || reviewsVideoTextColor || '#fff';
    const reviewsBorderWidth = options["reviews-border-width"];
    const reviewsBorderWidthMobile = options["reviews-border-width-mobile"];

    const ratingShow = options["rating-show"];
    const titleShow = options["title-show"];
    const contentShow = options["content-show"];
    const customerProfileShow = options["customer-profile-show"];
    const brandLogoShow = options["brand-logo-show"];
    const videoShow = options["video-show"];
    const dateShow = options["date-show"];

    const customerProfileAvatarWidth = options["reviews-customer-profile-avatar-width"];
    const customerProfileAvatarHeight = options["reviews-customer-profile-avatar-height"];
    let customerProfileAvatarRadius = "";
    if (options["reviews-customer-profile-avatar-radius"] == "cf-not-rounded") customerProfileAvatarRadius = "0px";
    if (options["reviews-customer-profile-avatar-radius"] == "cf-slightly-rounded") customerProfileAvatarRadius = "4px";
    if (options["reviews-customer-profile-avatar-radius"] == "cf-fully-rounded") customerProfileAvatarRadius = "100px";
    if (options["reviews-customer-profile-avatar-radius"] == "custom") {
      customerProfileAvatarRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          customerProfileAvatarRadius += `${
            _.isNil(options["reviews-customer-profile-avatar-radius-" + side]) == false
              ? options["reviews-customer-profile-avatar-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let brandLogoRadius = "";
    if (options["reviews-brand-logo-radius"] == "cf-not-rounded") brandLogoRadius = "0px";
    if (options["reviews-brand-logo-radius"] == "cf-slightly-rounded") brandLogoRadius = "4px";
    if (options["reviews-brand-logo-radius"] == "cf-fully-rounded") brandLogoRadius = "100px";
    if (options["reviews-brand-logo-radius"] == "custom") {
      brandLogoRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          brandLogoRadius += `${
            _.isNil(options["reviews-brand-logo-radius-" + side]) == false
              ? options["reviews-brand-logo-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    const brandLogoWidth = options["reviews-brand-logo-width"];
    const brandLogoHeight = options["reviews-brand-logo-height"];

    const reviewVideoWidth = options["reviews-video-width"];
    const reviewVideoHeight = options["reviews-video-height"];

    const reviewsBackgroundColor = options["reviews-background-color"];
    const reviewsBorderStyle = options["reviews-border-style"] ? options["reviews-border-style"] : "solid";
    const reviewsBorderColor = options["reviews-border-color"] ? options["reviews-border-color"] : "#000000";
    let reviewsBorderRounding;
    if (options["reviews-border-rounding"] == "cf-not-rounded") { reviewsBorderRounding = "0px" }
    if (options["reviews-border-rounding"] == "cf-slightly-rounded") { reviewsBorderRounding = "4px" }
    if (options["reviews-border-rounding"] == "cf-fully-rounded") { reviewsBorderRounding = "100px" }
    if (options["reviews-border-rounding"] == "custom") {
      reviewsBorderRounding = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          reviewsBorderRounding += `${
            _.isNil(options["reviews-border-rounding-" + side]) == false
              ? options["reviews-border-rounding-" + side]
              : "4"
          }px `;
        }
      );
    }

    const reviewsSourceFontFamily = options["reviews-source-font-family"];
    const reviewsSourceFontWeight = options["reviews-source-font-weight"];
    const reviewsSourceFontSize = options["reviews-source-font-size"] ? options["reviews-source-font-size"] : 13;
    const reviewsSourceFontLineHeight = options["reviews-source-font-line-height"];
    const reviewsSourceFontColor = options["reviews-source-font-color"] ? options["reviews-source-font-color"] : "#696969";

    const reviewsTitleFontFamily = options["reviews-title-font-family"];
    const reviewsTitleFontWeight = options["reviews-title-font-weight"];
    const reviewsTitleFontSize = options["reviews-title-font-size"];
    const reviewsTitleFontLineHeight = options["reviews-title-font-line-height"];
    const reviewsTitleFontColor = options["reviews-title-font-color"];

    const reviewsContentFontFamily = options["reviews-content-font-family"];
    const reviewsContentFontWeight = options["reviews-content-font-weight"];
    const reviewsContentFontSize = options["reviews-content-font-size"];
    const reviewsContentFontLineHeight = options["reviews-content-font-line-height"];
    const reviewsContentFontColor = options["reviews-content-font-color"];

    const reviewsCustomerNameFontFamily = options["reviews-customer-profile-name-font-family"];
    const reviewsCustomerNameFontWeight = options["reviews-customer-profile-name-font-weight"];
    const reviewsCustomerNameFontSize = options["reviews-customer-profile-name-font-size"];
    const reviewsCustomerNameFontLineHeight = options["reviews-customer-profile-name-font-line-height"];
    const reviewsCustomerNameFontColor = options["reviews-customer-profile-name-font-color"];

    const reviewsCustomerTitleFontFamily = options["reviews-customer-profile-title-font-family"];
    const reviewsCustomerTitleFontWeight = options["reviews-customer-profile-title-font-weight"];
    const reviewsCustomerTitleFontSize = options["reviews-customer-profile-title-font-size"];
    const reviewsCustomerTitleFontLineHeight = options["reviews-customer-profile-title-font-line-height"];
    const reviewsCustomerTitleFontColor = options["reviews-customer-profile-title-font-color"];

    const reviewsDateFontFamily = options["reviews-date-font-family"];
    const reviewsDateFontWeight = options["reviews-date-font-weight"];
    const reviewsDateFontSize = options["reviews-date-font-size"];
    const reviewsDateFontLineHeight = options["reviews-date-font-line-height"];
    const reviewsDateFontColor = options["reviews-date-font-color"];

    const reviewsVideoOverlayColor = options["reviews-video-overlay-color"];

    desktopStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-reviews-element {
        ${reviewsContainerWidth ? `max-width: ${reviewsContainerWidth}px;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-rating svg {
        color: ${ratingStarColor ? ratingStarColor : "#EFAB40"};
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-customer-profile-avatar img {
        max-width: 100%;
        ${customerProfileAvatarWidth ? `width: ${customerProfileAvatarWidth}px;` : 'width: 150px;'}
        ${customerProfileAvatarHeight ? `height: ${customerProfileAvatarHeight}px;` : ''}
        ${customerProfileAvatarRadius ? `border-radius: ${customerProfileAvatarRadius};` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-content-box {
        overflow: hidden;
        padding: 20px;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-items: start;
        gap: 15px;
        box-sizing: border-box;
        width: 100%;
        ${reviewsContainerHeight ? `min-height: ${reviewsContainerHeight}px;` : ''}
        ${reviewsBackgroundColor ? `background: ${reviewsBackgroundColor};` : ''}
        ${reviewsBorderStyle ? 'border-style: ' + reviewsBorderStyle + ';' : ''}
        ${reviewsBorderColor ? 'border-color: ' + reviewsBorderColor + ';' : ''}
        ${reviewsBorderWidth ? 'border-width: ' + reviewsBorderWidth + 'px;' : ''}
        ${_.isNil(options["reviews-border-width"]) == false ? 'border-width: ' + options["reviews-border-width"] + 'px;' : ''}
        ${_.isNil(options["reviews-border-width-left"]) == false ? 'border-left-width: ' + options["reviews-border-width-left"] + 'px;' : _.isNil(options["reviews-border-width"]) == false ? 'border-left-width: ' + options["reviews-border-width"] + 'px;' : ''}
        ${_.isNil(options["reviews-border-width-right"]) == false ? 'border-right-width: ' + options["reviews-border-width-right"] + 'px;' : _.isNil(options["reviews-border-width"]) == false ? 'border-right-width: ' + options["reviews-border-width"] + 'px;' : ''}
        ${_.isNil(options["reviews-border-width-top"]) == false ? 'border-top-width: ' + options["reviews-border-width-top"] + 'px;' : _.isNil(options["reviews-border-width"]) == false ? 'border-top-width: ' + options["reviews-border-width"] + 'px;' : ''}
        ${_.isNil(options["reviews-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["reviews-border-width-bottom"] + 'px;' : _.isNil(options["reviews-border-width"]) == false ? 'border-bottom-width: ' + options["reviews-border-width"] + 'px;' : ''}
        ${reviewsBorderRounding ? 'border-radius: ' + reviewsBorderRounding + ';' : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-content-wrapper,
      #cta_${cta.id} .cf-reviews-element .cf-reviews-text-content {
        gap: ${reviewsContentVerticalSpacing ? reviewsContentVerticalSpacing : 15}px;
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-with-background-video .cf-reviews-rating,
      #cta_${cta.id} .cf-reviews-element .cf-reviews-with-background-video .cf-reviews-rating .cf-reviews-star,
      #cta_${cta.id} .cf-reviews-element .cf-reviews-with-background-video .cf-reviews-rating svg,
      #cta_${cta.id} .cf-reviews-element .cf-reviews-with-background-video .cf-reviews-rating .svg-inline--fa,
      #cta_${cta.id} .cf-reviews-element .cf-reviews-with-background-video .cf-reviews-rating svg path {
        color: ${reviewsVideoBgRatingColor};
        fill: ${reviewsVideoBgRatingColor};
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-with-background-video .cf-reviews-title {
        color: ${reviewsVideoBgTitleColor};
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-with-background-video .cf-reviews-content {
        color: ${reviewsVideoBgContentColor};
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-with-background-video .cf-reviews-customer-profile-name {
        color: ${reviewsVideoBgCustomerNameColor};
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-with-background-video .cf-reviews-customer-profile-title {
        color: ${reviewsVideoBgCustomerTitleColor};
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-with-background-video .cf-reviews-date {
        color: ${reviewsVideoBgDateColor};
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-with-background-video .cf-reviews-source,
      #cta_${cta.id} .cf-reviews-element .cf-reviews-with-background-video .cf-reviews-source *,
      #cta_${cta.id} .cf-reviews-element .cf-reviews-with-background-video .cf-reviews-source-icon,
      #cta_${cta.id} .cf-reviews-element .cf-reviews-with-background-video .cf-reviews-source-icon svg {
        color: ${reviewsVideoBgSourceColor};
        fill: ${reviewsVideoBgSourceColor};
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-arrow-default {
        ${reviewsArrowSize ? `width: ${parseInt(reviewsArrowSize) + 20}px;` : ''}
        ${reviewsArrowSize ? `height: ${parseInt(reviewsArrowSize) + 20}px;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-rating .svg-inline--fa {
        display: var(--fa-display, inline-block);
        height: 1em;
        overflow: visible;
        font-size: ${ratingStarSize ? ratingStarSize : "14"}px;
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-video-inline,
      #cta_${cta.id} .cf-reviews-element .cf-reviews-video-left,
      #cta_${cta.id} .cf-reviews-element .cf-reviews-video-right {
        ${reviewVideoWidth ? `width: ${reviewVideoWidth}px;` : ''}
        ${reviewVideoHeight ? `height: ${reviewVideoHeight}px;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-brand-logo img {
        ${brandLogoWidth ? `width: ${brandLogoWidth}px;` : ''}
        ${brandLogoHeight ? `height: ${brandLogoHeight}px;` : ''}
        ${brandLogoRadius ? `border-radius: ${brandLogoRadius};` : ''}
      }

      ${ratingShow === 'false' ? `#cta_${cta.id} .cf-reviews-element .cf-reviews-rating { display: none !important; }` : ''}
      ${titleShow === 'false' ? `#cta_${cta.id} .cf-reviews-element .cf-reviews-content-type { display: none !important; }` : ''}
      ${contentShow === 'false' ? `#cta_${cta.id} .cf-reviews-element .cf-reviews-content { display: none !important; }` : ''}
      ${customerProfileShow === 'false' ? `#cta_${cta.id} .cf-reviews-element .cf-reviews-customer-profile { display: none !important; }` : ''}
      ${brandLogoShow === 'false' ? `#cta_${cta.id} .cf-reviews-element .cf-reviews-brand-logo { display: none !important; }` : ''}
      ${videoShow === 'false' ? `#cta_${cta.id} .cf-reviews-element .cf-reviews-video { display: none !important; }` : ''}
      ${dateShow === 'false' ? `#cta_${cta.id} .cf-reviews-element .cf-reviews-date { display: none !important; }` : ''}

      #cta_${cta.id} .cf-reviews-element .cf-reviews-source {
        ${reviewsSourceFontSize ? `font-size: ${reviewsSourceFontSize}px !important;` : ''}
        ${reviewsSourceFontLineHeight ? `line-height: ${reviewsSourceFontLineHeight}px !important;` : ''}
        ${reviewsSourceFontFamily && reviewsSourceFontFamily !== 'inherit' ? `font-family: ${reviewsSourceFontFamily}, sans-serif !important;` : ''}
        ${reviewsSourceFontWeight ? `font-weight: ${reviewsSourceFontWeight} !important;` : ''}
        ${reviewsSourceFontColor ? `color: ${reviewsSourceFontColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-source * {
        ${reviewsSourceFontFamily && reviewsSourceFontFamily !== 'inherit' ? `font-family: ${reviewsSourceFontFamily}, sans-serif !important;` : ''}
        ${reviewsSourceFontWeight ? `font-weight: ${reviewsSourceFontWeight} !important;` : ''}
        ${reviewsSourceFontColor ? `color: ${reviewsSourceFontColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-source-icon svg {
        ${reviewsSourceFontSize ? `font-size: ${reviewsSourceFontSize}px !important;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-title,
      #cta_${cta.id} .cf-reviews-element .cf-reviews-content-type.cf-reviews-title {
        ${reviewsTitleFontSize ? `font-size: ${reviewsTitleFontSize}px !important;` : ''}
        ${reviewsTitleFontLineHeight ? `line-height: ${reviewsTitleFontLineHeight}px !important;` : ''}
        ${reviewsTitleFontFamily && reviewsTitleFontFamily !== 'inherit' ? `font-family: ${reviewsTitleFontFamily}, sans-serif !important;` : ''}
        ${reviewsTitleFontWeight ? `font-weight: ${reviewsTitleFontWeight} !important;` : ''}
        ${reviewsTitleFontColor ? `color: ${reviewsTitleFontColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-content {
        ${reviewsContentFontSize ? `font-size: ${reviewsContentFontSize}px !important;` : ''}
        ${reviewsContentFontLineHeight ? `line-height: ${reviewsContentFontLineHeight}px !important;` : ''}
        ${reviewsContentFontFamily && reviewsContentFontFamily !== 'inherit' ? `font-family: ${reviewsContentFontFamily}, sans-serif !important;` : ''}
        ${reviewsContentFontWeight ? `font-weight: ${reviewsContentFontWeight} !important;` : ''}
        ${reviewsContentFontColor ? `color: ${reviewsContentFontColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-customer-profile-name {
        ${reviewsCustomerNameFontSize ? `font-size: ${reviewsCustomerNameFontSize}px !important;` : ''}
        ${reviewsCustomerNameFontLineHeight ? `line-height: ${reviewsCustomerNameFontLineHeight}px !important;` : ''}
        ${reviewsCustomerNameFontFamily && reviewsCustomerNameFontFamily !== 'inherit' ? `font-family: ${reviewsCustomerNameFontFamily}, sans-serif !important;` : ''}
        ${reviewsCustomerNameFontWeight ? `font-weight: ${reviewsCustomerNameFontWeight} !important;` : ''}
        ${reviewsCustomerNameFontColor ? `color: ${reviewsCustomerNameFontColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-customer-profile-title {
        ${reviewsCustomerTitleFontSize ? `font-size: ${reviewsCustomerTitleFontSize}px !important;` : ''}
        ${reviewsCustomerTitleFontLineHeight ? `line-height: ${reviewsCustomerTitleFontLineHeight}px !important;` : ''}
        ${reviewsCustomerTitleFontFamily && reviewsCustomerTitleFontFamily !== 'inherit' ? `font-family: ${reviewsCustomerTitleFontFamily}, sans-serif !important;` : ''}
        ${reviewsCustomerTitleFontWeight ? `font-weight: ${reviewsCustomerTitleFontWeight} !important;` : ''}
        ${reviewsCustomerTitleFontColor ? `color: ${reviewsCustomerTitleFontColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-date {
        ${reviewsDateFontSize ? `font-size: ${reviewsDateFontSize}px !important;` : ''}
        ${reviewsDateFontLineHeight ? `line-height: ${reviewsDateFontLineHeight}px !important;` : ''}
        ${reviewsDateFontFamily && reviewsDateFontFamily !== 'inherit' ? `font-family: ${reviewsDateFontFamily}, sans-serif !important;` : ''}
        ${reviewsDateFontWeight ? `font-weight: ${reviewsDateFontWeight} !important;` : ''}
        ${reviewsDateFontColor ? `color: ${reviewsDateFontColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-video::after {
        position: absolute;
        inset: 0;
        ${reviewsVideoOverlayColor ? `background: ${reviewsVideoOverlayColor} !important;` : ''}
        ${reviewsVideoOverlayColor ? `clip-path: inset(0 round 8px);` : ''}
        content: '';
      }
      `;


    const reviewsArrowSizeMobile = options["reviews-arrow-size-mobile"] || 12;
    const ratingStarSizeMobile = options["reviews-rating-star-size-mobile"];
    const customerProfileAvatarWidthMobile = options["reviews-customer-profile-avatar-width-mobile"];
    const customerProfileAvatarHeightMobile = options["reviews-customer-profile-avatar-height-mobile"];
    const reviewVideoWidthMobile = options["reviews-video-width-mobile"];
    const reviewVideoHeightMobile = options["reviews-video-height-mobile"];

    const brandLogoWidthMobile = options["reviews-brand-logo-width-mobile"];
    const brandLogoHeightMobile = options["reviews-brand-logo-height-mobile"];

    const reviewsSourceFontSizeMobile = options["reviews-source-font-size-mobile"];
    const reviewsSourceFontLineHeightMobile = options["reviews-source-font-line-height-mobile"];

    const reviewsTitleFontSizeMobile = options["reviews-title-font-size-mobile"];
    const reviewsTitleFontLineHeightMobile = options["reviews-title-font-line-height-mobile"];
    const reviewsContentFontSizeMobile = options["reviews-content-font-size-mobile"];
    const reviewsContentFontLineHeightMobile = options["reviews-content-font-line-height-mobile"];
    const reviewsCustomerNameFontSizeMobile = options["reviews-customer-profile-name-font-size-mobile"];
    const reviewsCustomerNameFontLineHeightMobile = options["reviews-customer-profile-name-font-line-height-mobile"];
    const reviewsCustomerTitleFontSizeMobile = options["reviews-customer-profile-title-font-size-mobile"];
    const reviewsCustomerTitleFontLineHeightMobile = options["reviews-customer-profile-title-font-line-height-mobile"];
    const reviewsDateFontSizeMobile = options["reviews-date-font-size-mobile"];
    const reviewsDateFontLineHeightMobile = options["reviews-date-font-line-height-mobile"];

    mobileStyles +=
      // prettier-ignore
      `#cta_${cta.id} .cf-reviews-element {
        ${reviewsContainerWidthMobile ? `max-width: ${reviewsContainerWidthMobile}px;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-arrow-default {
        ${reviewsArrowSizeMobile ? `width: ${parseInt(reviewsArrowSizeMobile) + 20}px;` : ''}
        ${reviewsArrowSizeMobile ? `height: ${parseInt(reviewsArrowSizeMobile) + 20}px;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-rating .svg-inline--fa {
        ${ratingStarSizeMobile ? `font-size: ${ratingStarSizeMobile}px;` : ""}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-customer-profile-avatar img {
        ${customerProfileAvatarWidthMobile ? `width: ${customerProfileAvatarWidthMobile}px !important;` : ''}
        ${customerProfileAvatarHeightMobile ? `height: ${customerProfileAvatarHeightMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-video-inline,
      #cta_${cta.id} .cf-reviews-element .cf-reviews-video-left,
      #cta_${cta.id} .cf-reviews-element .cf-reviews-video-right {
        ${reviewVideoWidthMobile ? `width: ${reviewVideoWidthMobile}px;` : ''}
        ${reviewVideoHeightMobile ? `height: ${reviewVideoHeightMobile}px;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-brand-logo img {
        ${brandLogoWidthMobile ? `width: ${brandLogoWidthMobile}px;` : ''}
        ${brandLogoHeightMobile ? `height: ${brandLogoHeightMobile}px;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-content-box {
        ${reviewsContainerHeightMobile ? `min-height: ${reviewsContainerHeightMobile}px;` : ''}
        ${reviewsBorderWidthMobile ? `border-width: ${reviewsBorderWidthMobile}px;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-content-wrapper,
      #cta_${cta.id} .cf-reviews-element .cf-reviews-text-content {
        ${reviewsContentVerticalSpacingMobile ? `gap: ${reviewsContentVerticalSpacingMobile}px;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-source {
        ${reviewsSourceFontSizeMobile ? `font-size: ${reviewsSourceFontSizeMobile}px !important;` : ''}
        ${reviewsSourceFontLineHeightMobile ? `line-height: ${reviewsSourceFontLineHeightMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-source-icon svg {
        ${reviewsSourceFontSizeMobile ? `font-size: ${reviewsSourceFontSizeMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-title,
      #cta_${cta.id} .cf-reviews-element .cf-reviews-content-type.cf-reviews-title {
        ${reviewsTitleFontSizeMobile ? `font-size: ${reviewsTitleFontSizeMobile}px !important;` : ''}
        ${reviewsTitleFontLineHeightMobile ? `line-height: ${reviewsTitleFontLineHeightMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-content {
        ${reviewsContentFontSizeMobile ? `font-size: ${reviewsContentFontSizeMobile}px !important;` : ''}
        ${reviewsContentFontLineHeightMobile ? `line-height: ${reviewsContentFontLineHeightMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-customer-profile-name {
        ${reviewsCustomerNameFontSizeMobile ? `font-size: ${reviewsCustomerNameFontSizeMobile}px !important;` : ''}
        ${reviewsCustomerNameFontLineHeightMobile ? `line-height: ${reviewsCustomerNameFontLineHeightMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-customer-profile-title {
        ${reviewsCustomerTitleFontSizeMobile ? `font-size: ${reviewsCustomerTitleFontSizeMobile}px !important;` : ''}
        ${reviewsCustomerTitleFontLineHeightMobile ? `line-height: ${reviewsCustomerTitleFontLineHeightMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-reviews-element .cf-reviews-date {
        ${reviewsDateFontSizeMobile ? `font-size: ${reviewsDateFontSizeMobile}px !important;` : ''}
        ${reviewsDateFontLineHeightMobile ? `line-height: ${reviewsDateFontLineHeightMobile}px !important;` : ''}
      }
      `;
    ////////// END REVIEWS THEME STYLES

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
